import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  VOID7hggqo3abtya as VOID,
  StringCompanionObject_instance2odz3s3zbrixa as StringCompanionObject_instance,
  Unit_instance104q5opgivhr8 as Unit_instance,
  emptyList1g2z5xcrvp2zy as emptyList,
  LazyThreadSafetyMode_PUBLICATION_getInstance2x9bac6dffafm as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy,
  toString1pkumu07cwy4m as toString,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  IllegalArgumentException_init_$Create$310sysrobvll9 as IllegalArgumentException_init_$Create$,
  zip2suipyqmdw72q as zip,
  toMap1vec9topfei08 as toMap,
  LinkedHashMap_init_$Create$1p3p95clvi93w as LinkedHashMap_init_$Create$,
  IllegalStateException_init_$Create$3ib9qa3pip8n4 as IllegalStateException_init_$Create$,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  LinkedHashMap_init_$Create$7ps311k1ff73 as LinkedHashMap_init_$Create$_0,
  KtMap140uvy3s5zad8 as KtMap,
  isInterface3d6p8outrmvmk as isInterface,
  IllegalArgumentException_init_$Init$1elycfkdq8or6 as IllegalArgumentException_init_$Init$,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  captureStack1fzi4aczwc4hg as captureStack,
  IllegalArgumentException_init_$Init$1ihrezc0xr9m4 as IllegalArgumentException_init_$Init$_0,
  IllegalArgumentException_init_$Init$l84p0lagzo4a as IllegalArgumentException_init_$Init$_1,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  listOfvhqybd2zx248 as listOf,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  ArrayList_init_$Create$1s1wkrw82c0iw as ArrayList_init_$Create$,
  KClass1cc9rfeybg8hs as KClass,
  Triple1vhi3d0dgpnjb as Triple,
  getKClass1s3j9wy1cofik as getKClass,
  Paire9pteg33gng7 as Pair,
  Entry2xmjmyutzoq3p as Entry,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  HashMap1a0ld5kgwhmhv as HashMap,
  KtSetjrjc7fhfd6b9 as KtSet,
  KtMutableSetwuwn7k5m570a as KtMutableSet,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  HashSet2dzve9y63nf0v as HashSet,
  Collection1k04j3hzsbod0 as Collection,
  KtList3hktaavzmj137 as KtList,
  KtMutableList1beimitadwkna as KtMutableList,
  ArrayList3it5z8td81qkl as ArrayList,
  copyToArray2j022khrow2yi as copyToArray,
  _Result___get_value__impl__bjfvqgo6z1uu11rodr as _Result___get_value__impl__bjfvqg,
  _Result___get_isFailure__impl__jpirivzehaw445b0cy as _Result___get_isFailure__impl__jpiriv,
  Result3t1vadv16kmzk as Result,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  Iterable1y3qizuf89iou as Iterable,
  isBlank1dvkhjjvox3p0 as isBlank,
  toList383f556t1dixk as toList,
  ArrayList_init_$Create$2qnngtk1et9r9 as ArrayList_init_$Create$_0,
  HashSet_init_$Create$1urd5csbv51lq as HashSet_init_$Create$,
  toHashSet1qrcsl3g8ugc8 as toHashSet,
  toBooleanArray2u3qw7fjwsmuh as toBooleanArray,
  withIndex3s8q7w1g0hyfn as withIndex,
  to2cs3ny02qtbcb as to,
  lazy2hsh8ze7j6ikd as lazy_0,
  contentEqualsaf55p28mnw74 as contentEquals,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  Long2qws0ah9gnpki as Long,
  Char19o2r8palgjof as Char,
  Duration__toIsoString_impl_9h6wsm33t9fmb34wprd as Duration__toIsoString_impl_9h6wsm,
  Duration5ynfiptaqcrg as Duration,
  Companion_getInstance2b73c6hwbaiuw as Companion_getInstance,
  Uuid1zxgztb7abqxx as Uuid,
  Companion_getInstance3tnw2k4njrdpv as Companion_getInstance_0,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  hashCodeq5arwsb9dgti as hashCode,
  ArrayList_init_$Create$44sx2frbo105 as ArrayList_init_$Create$_1,
  HashSet_init_$Create$1205t9rx6gzuw as HashSet_init_$Create$_0,
  LinkedHashSet_init_$Create$3qv13l7kzf0ni as LinkedHashSet_init_$Create$,
  LinkedHashSet_init_$Create$aoic19bt9c3t as LinkedHashSet_init_$Create$_0,
  HashMap_init_$Create$1ria3pjlcm5i3 as HashMap_init_$Create$,
  HashMap_init_$Create$2xkn9k09cz2fd as HashMap_init_$Create$_0,
  LinkedHashMap_init_$Create$1ihgfw4xf4rsr as LinkedHashMap_init_$Create$_1,
  isArray1hxjqtqy632bc as isArray,
  arrayIterator3lgwvgteckzhv as arrayIterator,
  asList2ho2pewtsfvv as asList,
  until1jbpn0z3f8lbg as until,
  step18s9qzr5xwxat as step,
  getValue48kllevslyh6 as getValue,
  longArray288a0fctlmjmj as longArray,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  get_lastIndex1y2f6o9u8hnf7 as get_lastIndex,
  countTrailingZeroBits1k55x07cygoff as countTrailingZeroBits,
  getOrNull1d60i0672n7ns as getOrNull,
  joinToString1cxrrlmo0chqs as joinToString,
  indexOf3ic8eacwbbrog as indexOf,
  contentToString3ujacv8hqfipd as contentToString,
  Enum3alwj03lh1n41 as Enum,
  HashSet_init_$Create$7yrdg7emowlg as HashSet_init_$Create$_1,
  toString30pk9tzaqopn as toString_0,
  KTypeParameter1s8efufd4mbj5 as KTypeParameter,
  contentHashCode2i020q5tbeh2s as contentHashCode,
  booleanArray2jdug9b51huk7 as booleanArray,
  emptyMapr06gerzljqtm as emptyMap,
  Companion_getInstance2g172z58li19e as Companion_getInstance_1,
  isCharArray21auq5hbrg68m as isCharArray,
  charArray2ujmm1qusno00 as charArray,
  DoubleCompanionObject_instance2yqrcskeqd1tm as DoubleCompanionObject_instance,
  isDoubleArray1wyh4nyf7pjxn as isDoubleArray,
  FloatCompanionObject_instance29smzmmxq0czz as FloatCompanionObject_instance,
  isFloatArrayjjscnqphw92j as isFloatArray,
  Companion_getInstance1pxg306pnafvz as Companion_getInstance_2,
  isLongArray2fdt3z7yu3ef as isLongArray,
  Companion_getInstance1poxudqc1ru3p as Companion_getInstance_3,
  _ULongArray___get_size__impl__ju6dtr1b48sgq5mqufi as _ULongArray___get_size__impl__ju6dtr,
  ULongArray3nd0d80mdwjj8 as ULongArray,
  _ULongArray___init__impl__twm1l3w35zjgwc40e6 as _ULongArray___init__impl__twm1l3,
  _ULong___init__impl__c78o9k2uqxdjm6b0lbg as _ULong___init__impl__c78o9k,
  ULongArray__get_impl_pr71q927jt2k7w7gjei as ULongArray__get_impl_pr71q9,
  _ULong___get_data__impl__fggpzb1jl4xe0gulani as _ULong___get_data__impl__fggpzb,
  IntCompanionObject_instance2nvyd29rdzxbs as IntCompanionObject_instance,
  isIntArrayeijsubfngq38 as isIntArray,
  Companion_getInstance1z323tr26bmxd as Companion_getInstance_4,
  _UIntArray___get_size__impl__r6l8ci9njro21awxk9 as _UIntArray___get_size__impl__r6l8ci,
  UIntArrayrp6cv44n5v4y as UIntArray,
  _UIntArray___init__impl__ghjpc6p9a9ozepj5yp as _UIntArray___init__impl__ghjpc6,
  _UInt___init__impl__l7qpdl1vpobek1e692 as _UInt___init__impl__l7qpdl,
  UIntArray__get_impl_gp5kza3dxey4dpmolyb as UIntArray__get_impl_gp5kza,
  _UInt___get_data__impl__f0vqqw9xdox7iecbly as _UInt___get_data__impl__f0vqqw,
  ShortCompanionObject_instanceyg0ko6hbt9iy as ShortCompanionObject_instance,
  isShortArraywz30zxwtqi8h as isShortArray,
  Companion_getInstanceojp2cj59jqir as Companion_getInstance_5,
  _UShortArray___get_size__impl__jqto1bat9kt7h1kexu as _UShortArray___get_size__impl__jqto1b,
  UShortArray11avpmknxdgvv as UShortArray,
  _UShortArray___init__impl__9b26ef20xbmpmmmp8nr as _UShortArray___init__impl__9b26ef,
  _UShort___init__impl__jigrne3h2nm35iaibum as _UShort___init__impl__jigrne,
  UShortArray__get_impl_fnbhmx2rw6mvd6ywjjn as UShortArray__get_impl_fnbhmx,
  _UShort___get_data__impl__g02459z5yfs6z0kj0 as _UShort___get_data__impl__g0245,
  ByteCompanionObject_instancerp27gpfua1xf as ByteCompanionObject_instance,
  isByteArray4nnzfn1x4o3w as isByteArray,
  Companion_getInstance374brtr06v94p as Companion_getInstance_6,
  _UByteArray___get_size__impl__h6pkdv2ztnvvin1oejd as _UByteArray___get_size__impl__h6pkdv,
  UByteArray2qu4d6gwssdf9 as UByteArray,
  _UByteArray___init__impl__ip4y9n2yrhvr539f00i as _UByteArray___init__impl__ip4y9n,
  _UByte___init__impl__g9hnc415bxbmye0j11o as _UByte___init__impl__g9hnc4,
  UByteArray__get_impl_t5f3hv2yxdiuhsa1bkg as UByteArray__get_impl_t5f3hv,
  _UByte___get_data__impl__jof9qrfj1ch8mjizvj as _UByte___get_data__impl__jof9qr,
  BooleanCompanionObject_instance3nvf6tg77gv83 as BooleanCompanionObject_instance,
  isBooleanArray35llghle4c6w1 as isBooleanArray,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  copyOf2p23ljc5f5ea3 as copyOf,
  copyOfgossjg6lh6js as copyOf_0,
  copyOfq9pcgcgbldck as copyOf_1,
  copyOf9mbsebmgnw4t as copyOf_2,
  _ULongArray___get_storage__impl__28e64jlq4wjpcpg0xb as _ULongArray___get_storage__impl__28e64j,
  _ULongArray___init__impl__twm1l31njh1yo2fhc3d as _ULongArray___init__impl__twm1l3_0,
  ULongArray__set_impl_z19mvh3jq4upxqlu5i0 as ULongArray__set_impl_z19mvh,
  copyOf3rutauicler23 as copyOf_3,
  _UIntArray___get_storage__impl__92a0v03adro3l9nnqca as _UIntArray___get_storage__impl__92a0v0,
  _UIntArray___init__impl__ghjpc61vagysy0rvf as _UIntArray___init__impl__ghjpc6_0,
  UIntArray__set_impl_7f2zu22xxx79utmdcyl as UIntArray__set_impl_7f2zu2,
  copyOf39s58md6y6rn6 as copyOf_4,
  _UShortArray___get_storage__impl__t2jpv53ishea48wnh3x as _UShortArray___get_storage__impl__t2jpv5,
  _UShortArray___init__impl__9b26ef2p62uevidil7h as _UShortArray___init__impl__9b26ef_0,
  UShortArray__set_impl_6d8whp1v6ijtn8ethum as UShortArray__set_impl_6d8whp,
  copyOfwy6h3t5vzqpl as copyOf_5,
  _UByteArray___get_storage__impl__d4kctt24cpxlf9wdrm1 as _UByteArray___get_storage__impl__d4kctt,
  _UByteArray___init__impl__ip4y9n1d0y5mfc7d2ru as _UByteArray___init__impl__ip4y9n_0,
  UByteArray__set_impl_jvcicn17xhe4228sib8 as UByteArray__set_impl_jvcicn,
  copyOf37mht4mx7mjgh as copyOf_6,
  Unitkvevlwgzwiuc as Unit,
  trimIndent1qytc1wvt8suh as trimIndent,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  get_lastIndex1yw0x4k50k51w as get_lastIndex_0,
  ULong3f9k7s38t3rfp as ULong,
  UInt1hthisrv6cndi as UInt,
  UShort26xnqty60t7le as UShort,
  UBytep4j7r1t64gz1 as UByte,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  PrimitiveClasses_getInstance28ukyr6i8fs0q as PrimitiveClasses_getInstance,
  mapOf1xd03cq9cnmy8 as mapOf,
  get_js1ale1wr4fbvs0 as get_js,
  findAssociatedObject1kb88g16k1goa as findAssociatedObject,
  get_indicesc04v40g017hw as get_indices,
  IndexOutOfBoundsException_init_$Create$jb51qtvf74or as IndexOutOfBoundsException_init_$Create$,
  get_indices377latqcai313 as get_indices_0,
  Companion_instance3fplhgf4ipvld as Companion_instance,
  _Result___init__impl__xyqfz81wclroc5pw7j2 as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForInterface(SerializationStrategy, 'SerializationStrategy');
initMetadataForInterface(DeserializationStrategy, 'DeserializationStrategy');
initMetadataForInterface(KSerializer, 'KSerializer', VOID, VOID, [SerializationStrategy, DeserializationStrategy]);
initMetadataForClass(AbstractPolymorphicSerializer, 'AbstractPolymorphicSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(PolymorphicSerializer, 'PolymorphicSerializer', VOID, AbstractPolymorphicSerializer);
initMetadataForClass(SealedClassSerializer$$inlined$groupingBy$1);
initMetadataForClass(SealedClassSerializer, 'SealedClassSerializer', VOID, AbstractPolymorphicSerializer);
initMetadataForInterface(StringFormat, 'StringFormat');
initMetadataForInterface(BinaryFormat, 'BinaryFormat');
initMetadataForClass(SerializationException, 'SerializationException', SerializationException_init_$Create$, IllegalArgumentException);
initMetadataForClass(MissingFieldException, 'MissingFieldException', VOID, SerializationException);
initMetadataForClass(UnknownFieldException, 'UnknownFieldException', VOID, SerializationException);
function get_isNullable() {
  return false;
}
function get_isInline() {
  return false;
}
function get_annotations() {
  return emptyList();
}
initMetadataForInterface(SerialDescriptor, 'SerialDescriptor');
initMetadataForClass(ContextDescriptor, 'ContextDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForClass(elementDescriptors$1);
initMetadataForClass(elementDescriptors$$inlined$Iterable$1, VOID, VOID, VOID, [Iterable]);
initMetadataForClass(elementNames$1);
initMetadataForClass(elementNames$$inlined$Iterable$1, VOID, VOID, VOID, [Iterable]);
initMetadataForClass(ClassSerialDescriptorBuilder, 'ClassSerialDescriptorBuilder');
initMetadataForInterface(CachedNames, 'CachedNames');
initMetadataForClass(SerialDescriptorImpl, 'SerialDescriptorImpl', VOID, VOID, [SerialDescriptor, CachedNames]);
initMetadataForClass(SerialKind, 'SerialKind');
initMetadataForObject(ENUM, 'ENUM', VOID, SerialKind);
initMetadataForObject(CONTEXTUAL, 'CONTEXTUAL', VOID, SerialKind);
initMetadataForClass(PolymorphicKind, 'PolymorphicKind', VOID, SerialKind);
initMetadataForObject(SEALED, 'SEALED', VOID, PolymorphicKind);
initMetadataForObject(OPEN, 'OPEN', VOID, PolymorphicKind);
initMetadataForClass(PrimitiveKind, 'PrimitiveKind', VOID, SerialKind);
initMetadataForObject(BOOLEAN, 'BOOLEAN', VOID, PrimitiveKind);
initMetadataForObject(BYTE, 'BYTE', VOID, PrimitiveKind);
initMetadataForObject(CHAR, 'CHAR', VOID, PrimitiveKind);
initMetadataForObject(SHORT, 'SHORT', VOID, PrimitiveKind);
initMetadataForObject(INT, 'INT', VOID, PrimitiveKind);
initMetadataForObject(LONG, 'LONG', VOID, PrimitiveKind);
initMetadataForObject(FLOAT, 'FLOAT', VOID, PrimitiveKind);
initMetadataForObject(DOUBLE, 'DOUBLE', VOID, PrimitiveKind);
initMetadataForObject(STRING, 'STRING', VOID, PrimitiveKind);
initMetadataForClass(StructureKind, 'StructureKind', VOID, SerialKind);
initMetadataForObject(CLASS, 'CLASS', VOID, StructureKind);
initMetadataForObject(LIST, 'LIST', VOID, StructureKind);
initMetadataForObject(MAP, 'MAP', VOID, StructureKind);
initMetadataForObject(OBJECT, 'OBJECT', VOID, StructureKind);
function decodeSerializableValue(deserializer) {
  return deserializer.zn(this);
}
initMetadataForInterface(Decoder, 'Decoder');
function decodeSequentially() {
  return false;
}
function decodeCollectionSize(descriptor) {
  return -1;
}
function decodeSerializableElement$default(descriptor, index, deserializer, previousValue, $super) {
  previousValue = previousValue === VOID ? null : previousValue;
  return $super === VOID ? this.wr(descriptor, index, deserializer, previousValue) : $super.wr.call(this, descriptor, index, deserializer, previousValue);
}
initMetadataForInterface(CompositeDecoder, 'CompositeDecoder');
initMetadataForClass(AbstractDecoder, 'AbstractDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
function encodeNotNullMark() {
}
function beginCollection(descriptor, collectionSize) {
  return this.kr(descriptor);
}
function encodeSerializableValue(serializer, value) {
  serializer.yn(this, value);
}
function encodeNullableSerializableValue(serializer, value) {
  var isNullabilitySupported = serializer.xn().kp();
  if (isNullabilitySupported) {
    return this.ct(isInterface(serializer, SerializationStrategy) ? serializer : THROW_CCE(), value);
  }
  if (value == null) {
    this.fs();
  } else {
    this.ft();
    this.ct(serializer, value);
  }
}
initMetadataForInterface(Encoder, 'Encoder');
function shouldEncodeElementDefault(descriptor, index) {
  return true;
}
initMetadataForInterface(CompositeEncoder, 'CompositeEncoder');
initMetadataForClass(AbstractEncoder, 'AbstractEncoder', VOID, VOID, [Encoder, CompositeEncoder]);
initMetadataForObject(NothingSerializer_0, 'NothingSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(DurationSerializer, 'DurationSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(UuidSerializer, 'UuidSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(ListLikeDescriptor, 'ListLikeDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForClass(ArrayListClassDesc, 'ArrayListClassDesc', VOID, ListLikeDescriptor);
initMetadataForClass(HashSetClassDesc, 'HashSetClassDesc', VOID, ListLikeDescriptor);
initMetadataForClass(LinkedHashSetClassDesc, 'LinkedHashSetClassDesc', VOID, ListLikeDescriptor);
initMetadataForClass(MapLikeDescriptor, 'MapLikeDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForClass(HashMapClassDesc, 'HashMapClassDesc', VOID, MapLikeDescriptor);
initMetadataForClass(LinkedHashMapClassDesc, 'LinkedHashMapClassDesc', VOID, MapLikeDescriptor);
initMetadataForClass(ArrayClassDesc, 'ArrayClassDesc', VOID, ListLikeDescriptor);
initMetadataForClass(PrimitiveArrayDescriptor, 'PrimitiveArrayDescriptor', VOID, ListLikeDescriptor);
initMetadataForClass(AbstractCollectionSerializer, 'AbstractCollectionSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(CollectionLikeSerializer, 'CollectionLikeSerializer', VOID, AbstractCollectionSerializer);
initMetadataForClass(CollectionSerializer, 'CollectionSerializer', VOID, CollectionLikeSerializer);
initMetadataForClass(ArrayListSerializer, 'ArrayListSerializer', VOID, CollectionSerializer);
initMetadataForClass(HashSetSerializer, 'HashSetSerializer', VOID, CollectionSerializer);
initMetadataForClass(LinkedHashSetSerializer, 'LinkedHashSetSerializer', VOID, CollectionSerializer);
initMetadataForClass(MapLikeSerializer, 'MapLikeSerializer', VOID, AbstractCollectionSerializer);
initMetadataForClass(HashMapSerializer, 'HashMapSerializer', VOID, MapLikeSerializer);
initMetadataForClass(LinkedHashMapSerializer, 'LinkedHashMapSerializer', VOID, MapLikeSerializer);
initMetadataForClass(ReferenceArraySerializer, 'ReferenceArraySerializer', VOID, CollectionLikeSerializer);
initMetadataForClass(PrimitiveArraySerializer, 'PrimitiveArraySerializer', VOID, CollectionLikeSerializer);
initMetadataForClass(PrimitiveArrayBuilder, 'PrimitiveArrayBuilder');
initMetadataForCompanion(Companion);
initMetadataForClass(ElementMarker, 'ElementMarker');
initMetadataForClass(PluginGeneratedSerialDescriptor, 'PluginGeneratedSerialDescriptor', VOID, VOID, [SerialDescriptor, CachedNames]);
initMetadataForClass(EnumDescriptor, 'EnumDescriptor', VOID, PluginGeneratedSerialDescriptor);
initMetadataForClass(EnumSerializer, 'EnumSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(InlineClassDescriptor, 'InlineClassDescriptor', VOID, PluginGeneratedSerialDescriptor);
function typeParametersSerializers() {
  return get_EMPTY_SERIALIZER_ARRAY();
}
initMetadataForInterface(GeneratedSerializer, 'GeneratedSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(InlinePrimitiveDescriptor$1, VOID, VOID, VOID, [GeneratedSerializer]);
initMetadataForObject(NoOpEncoder, 'NoOpEncoder', VOID, AbstractEncoder);
initMetadataForObject(NothingSerialDescriptor, 'NothingSerialDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForClass(NullableSerializer, 'NullableSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(SerialDescriptorForNullable, 'SerialDescriptorForNullable', VOID, VOID, [SerialDescriptor, CachedNames]);
initMetadataForClass(ObjectSerializer, 'ObjectSerializer', VOID, VOID, [KSerializer]);
initMetadataForInterface(SerializerFactory, 'SerializerFactory');
initMetadataForObject(CharArraySerializer_0, 'CharArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(DoubleArraySerializer_0, 'DoubleArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(FloatArraySerializer_0, 'FloatArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(LongArraySerializer_0, 'LongArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(ULongArraySerializer_0, 'ULongArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(IntArraySerializer_0, 'IntArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(UIntArraySerializer_0, 'UIntArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(ShortArraySerializer_0, 'ShortArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(UShortArraySerializer_0, 'UShortArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(ByteArraySerializer_0, 'ByteArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(UByteArraySerializer_0, 'UByteArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(BooleanArraySerializer_0, 'BooleanArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForClass(CharArrayBuilder, 'CharArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForClass(DoubleArrayBuilder, 'DoubleArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForClass(FloatArrayBuilder, 'FloatArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForClass(LongArrayBuilder, 'LongArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForClass(ULongArrayBuilder, 'ULongArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForClass(IntArrayBuilder, 'IntArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForClass(UIntArrayBuilder, 'UIntArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForClass(ShortArrayBuilder, 'ShortArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForClass(UShortArrayBuilder, 'UShortArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForClass(ByteArrayBuilder, 'ByteArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForClass(UByteArrayBuilder, 'UByteArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForClass(BooleanArrayBuilder, 'BooleanArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForObject(StringSerializer, 'StringSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(CharSerializer, 'CharSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(DoubleSerializer, 'DoubleSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(FloatSerializer, 'FloatSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(LongSerializer, 'LongSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(IntSerializer, 'IntSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(ShortSerializer, 'ShortSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(ByteSerializer, 'ByteSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(BooleanSerializer, 'BooleanSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(UnitSerializer, 'UnitSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(PrimitiveSerialDescriptor_0, 'PrimitiveSerialDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForClass(TaggedDecoder, 'TaggedDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
initMetadataForClass(NamedValueDecoder, 'NamedValueDecoder', VOID, TaggedDecoder);
initMetadataForClass(MapEntry, 'MapEntry', VOID, VOID, [Entry]);
initMetadataForClass(KeyValueSerializer, 'KeyValueSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(MapEntrySerializer_0, 'MapEntrySerializer', VOID, KeyValueSerializer);
initMetadataForClass(PairSerializer_0, 'PairSerializer', VOID, KeyValueSerializer);
initMetadataForClass(TripleSerializer_0, 'TripleSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(ULongSerializer, 'ULongSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(UIntSerializer, 'UIntSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(UShortSerializer, 'UShortSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(UByteSerializer, 'UByteSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(SerializersModule, 'SerializersModule');
initMetadataForClass(SerialModuleImpl, 'SerialModuleImpl', VOID, SerializersModule);
initMetadataForClass(ContextualProvider, 'ContextualProvider');
initMetadataForClass(Argless, 'Argless', VOID, ContextualProvider);
initMetadataForClass(WithTypeArguments, 'WithTypeArguments', VOID, ContextualProvider);
function contextual(kClass, serializer) {
  return this.c18(kClass, SerializersModuleCollector$contextual$lambda(serializer));
}
initMetadataForInterface(SerializersModuleCollector, 'SerializersModuleCollector');
initMetadataForClass(SerializableWith, 'SerializableWith', VOID, VOID, VOID, VOID, 0);
initMetadataForClass(createCache$1);
initMetadataForClass(createParametrizedCache$1);
//endregion
function KSerializer() {
}
function SerializationStrategy() {
}
function DeserializationStrategy() {
}
function PolymorphicSerializer$descriptor$delegate$lambda$lambda(this$0) {
  return function ($this$buildSerialDescriptor) {
    $this$buildSerialDescriptor.io('type', serializer_2(StringCompanionObject_instance).xn());
    $this$buildSerialDescriptor.io('value', buildSerialDescriptor('kotlinx.serialization.Polymorphic<' + this$0.jo_1.pa() + '>', CONTEXTUAL_getInstance(), []));
    $this$buildSerialDescriptor.co_1 = this$0.ko_1;
    return Unit_instance;
  };
}
function PolymorphicSerializer$descriptor$delegate$lambda(this$0) {
  return function () {
    var tmp = OPEN_getInstance();
    return withContext(buildSerialDescriptor('kotlinx.serialization.Polymorphic', tmp, [], PolymorphicSerializer$descriptor$delegate$lambda$lambda(this$0)), this$0.jo_1);
  };
}
function PolymorphicSerializer(baseClass) {
  AbstractPolymorphicSerializer.call(this);
  this.jo_1 = baseClass;
  this.ko_1 = emptyList();
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.lo_1 = lazy(tmp_0, PolymorphicSerializer$descriptor$delegate$lambda(this));
}
protoOf(PolymorphicSerializer).mo = function () {
  return this.jo_1;
};
protoOf(PolymorphicSerializer).xn = function () {
  var tmp0 = this.lo_1;
  // Inline function 'kotlin.getValue' call
  descriptor$factory();
  return tmp0.t();
};
protoOf(PolymorphicSerializer).toString = function () {
  return 'kotlinx.serialization.PolymorphicSerializer(baseClass: ' + toString(this.jo_1) + ')';
};
function findPolymorphicSerializer(_this__u8e3s4, encoder, value) {
  var tmp0_elvis_lhs = _this__u8e3s4.po(encoder, value);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throwSubtypeNotRegistered(getKClassFromExpression(value), _this__u8e3s4.mo());
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function findPolymorphicSerializer_0(_this__u8e3s4, decoder, klassName) {
  var tmp0_elvis_lhs = _this__u8e3s4.oo(decoder, klassName);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throwSubtypeNotRegistered_0(klassName, _this__u8e3s4.mo());
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function descriptor$factory() {
  return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
    return receiver.xn();
  }, null);
}
function SealedClassSerializer$descriptor$delegate$lambda$lambda$lambda(this$0) {
  return function ($this$buildSerialDescriptor) {
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = this$0.uo_1.r().j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      // Inline function 'kotlin.collections.component1' call
      var name = element.s();
      // Inline function 'kotlin.collections.component2' call
      var serializer = element.t();
      $this$buildSerialDescriptor.io(name, serializer.xn());
    }
    return Unit_instance;
  };
}
function SealedClassSerializer$descriptor$delegate$lambda$lambda(this$0) {
  return function ($this$buildSerialDescriptor) {
    $this$buildSerialDescriptor.io('type', serializer_2(StringCompanionObject_instance).xn());
    var tmp = 'kotlinx.serialization.Sealed<' + this$0.qo_1.pa() + '>';
    var tmp_0 = CONTEXTUAL_getInstance();
    var elementDescriptor = buildSerialDescriptor(tmp, tmp_0, [], SealedClassSerializer$descriptor$delegate$lambda$lambda$lambda(this$0));
    $this$buildSerialDescriptor.io('value', elementDescriptor);
    $this$buildSerialDescriptor.co_1 = this$0.ro_1;
    return Unit_instance;
  };
}
function SealedClassSerializer$descriptor$delegate$lambda($serialName, this$0) {
  return function () {
    var tmp = SEALED_getInstance();
    return buildSerialDescriptor($serialName, tmp, [], SealedClassSerializer$descriptor$delegate$lambda$lambda(this$0));
  };
}
function SealedClassSerializer$$inlined$groupingBy$1($this) {
  this.vo_1 = $this;
}
protoOf(SealedClassSerializer$$inlined$groupingBy$1).wo = function () {
  return this.vo_1.j();
};
protoOf(SealedClassSerializer$$inlined$groupingBy$1).xo = function (element) {
  return element.t().xn().yo();
};
protoOf(SealedClassSerializer$$inlined$groupingBy$1).zo = function (element) {
  return this.xo((element == null ? true : !(element == null)) ? element : THROW_CCE());
};
function SealedClassSerializer(serialName, baseClass, subclasses, subclassSerializers) {
  AbstractPolymorphicSerializer.call(this);
  this.qo_1 = baseClass;
  this.ro_1 = emptyList();
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.so_1 = lazy(tmp_0, SealedClassSerializer$descriptor$delegate$lambda(serialName, this));
  if (!(subclasses.length === subclassSerializers.length)) {
    throw IllegalArgumentException_init_$Create$('All subclasses of sealed class ' + this.qo_1.pa() + ' should be marked @Serializable');
  }
  this.to_1 = toMap(zip(subclasses, subclassSerializers));
  var tmp_1 = this;
  // Inline function 'kotlin.collections.groupingBy' call
  var this_0 = this.to_1.r();
  // Inline function 'kotlin.collections.aggregate' call
  var tmp0 = new SealedClassSerializer$$inlined$groupingBy$1(this_0);
  // Inline function 'kotlin.collections.mutableMapOf' call
  // Inline function 'kotlin.collections.aggregateTo' call
  var destination = LinkedHashMap_init_$Create$();
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = tmp0.wo();
  while (_iterator__ex2g4s.k()) {
    var e = _iterator__ex2g4s.l();
    var key = tmp0.zo(e);
    var accumulator = destination.a2(key);
    accumulator == null && !destination.y1(key);
    if (!(accumulator == null)) {
      // Inline function 'kotlin.error' call
      var message = "Multiple sealed subclasses of '" + toString(this.qo_1) + "' have the same serial name '" + key + "':" + (" '" + toString(accumulator.s()) + "', '" + toString(e.s()) + "'");
      throw IllegalStateException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.collections.set' call
    destination.h2(key, e);
  }
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination_0 = LinkedHashMap_init_$Create$_0(mapCapacity(destination.m()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s_0 = destination.r().j();
  while (_iterator__ex2g4s_0.k()) {
    var element = _iterator__ex2g4s_0.l();
    var tmp_2 = element.s();
    var tmp$ret$8 = element.t().t();
    destination_0.h2(tmp_2, tmp$ret$8);
  }
  tmp_1.uo_1 = destination_0;
}
protoOf(SealedClassSerializer).mo = function () {
  return this.qo_1;
};
protoOf(SealedClassSerializer).xn = function () {
  var tmp0 = this.so_1;
  // Inline function 'kotlin.getValue' call
  descriptor$factory_0();
  return tmp0.t();
};
protoOf(SealedClassSerializer).oo = function (decoder, klassName) {
  // Inline function 'kotlin.collections.get' call
  var this_0 = this.uo_1;
  var tmp0_elvis_lhs = (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).a2(klassName);
  return tmp0_elvis_lhs == null ? protoOf(AbstractPolymorphicSerializer).oo.call(this, decoder, klassName) : tmp0_elvis_lhs;
};
protoOf(SealedClassSerializer).po = function (encoder, value) {
  var tmp0_elvis_lhs = this.to_1.a2(getKClassFromExpression(value));
  var tmp1_safe_receiver = tmp0_elvis_lhs == null ? protoOf(AbstractPolymorphicSerializer).po.call(this, encoder, value) : tmp0_elvis_lhs;
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlinx.serialization.internal.cast' call
    tmp = isInterface(tmp1_safe_receiver, SerializationStrategy) ? tmp1_safe_receiver : THROW_CCE();
  }
  return tmp;
};
function descriptor$factory_0() {
  return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
    return receiver.xn();
  }, null);
}
function StringFormat() {
}
function BinaryFormat() {
}
function SerializationException_init_$Init$($this) {
  IllegalArgumentException_init_$Init$($this);
  SerializationException.call($this);
  return $this;
}
function SerializationException_init_$Create$() {
  var tmp = SerializationException_init_$Init$(objectCreate(protoOf(SerializationException)));
  captureStack(tmp, SerializationException_init_$Create$);
  return tmp;
}
function SerializationException_init_$Init$_0(message, $this) {
  IllegalArgumentException_init_$Init$_0(message, $this);
  SerializationException.call($this);
  return $this;
}
function SerializationException_init_$Create$_0(message) {
  var tmp = SerializationException_init_$Init$_0(message, objectCreate(protoOf(SerializationException)));
  captureStack(tmp, SerializationException_init_$Create$_0);
  return tmp;
}
function SerializationException_init_$Init$_1(message, cause, $this) {
  IllegalArgumentException_init_$Init$_1(message, cause, $this);
  SerializationException.call($this);
  return $this;
}
function SerializationException() {
  captureStack(this, SerializationException);
}
function MissingFieldException_init_$Init$(missingFields, serialName, $this) {
  MissingFieldException.call($this, missingFields, missingFields.m() === 1 ? "Field '" + missingFields.o(0) + "' is required for type with serial name '" + serialName + "', but it was missing" : 'Fields ' + toString(missingFields) + " are required for type with serial name '" + serialName + "', but they were missing", null);
  return $this;
}
function MissingFieldException_init_$Create$(missingFields, serialName) {
  var tmp = MissingFieldException_init_$Init$(missingFields, serialName, objectCreate(protoOf(MissingFieldException)));
  captureStack(tmp, MissingFieldException_init_$Create$);
  return tmp;
}
function MissingFieldException_init_$Init$_0(missingField, serialName, $this) {
  MissingFieldException.call($this, listOf(missingField), "Field '" + missingField + "' is required for type with serial name '" + serialName + "', but it was missing", null);
  return $this;
}
function MissingFieldException_init_$Create$_0(missingField, serialName) {
  var tmp = MissingFieldException_init_$Init$_0(missingField, serialName, objectCreate(protoOf(MissingFieldException)));
  captureStack(tmp, MissingFieldException_init_$Create$_0);
  return tmp;
}
function MissingFieldException(missingFields, message, cause) {
  SerializationException_init_$Init$_1(message, cause, this);
  captureStack(this, MissingFieldException);
  this.ep_1 = missingFields;
}
function UnknownFieldException_init_$Init$(index, $this) {
  UnknownFieldException.call($this, 'An unknown field for index ' + index);
  return $this;
}
function UnknownFieldException_init_$Create$(index) {
  var tmp = UnknownFieldException_init_$Init$(index, objectCreate(protoOf(UnknownFieldException)));
  captureStack(tmp, UnknownFieldException_init_$Create$);
  return tmp;
}
function UnknownFieldException(message) {
  SerializationException_init_$Init$_0(message, this);
  captureStack(this, UnknownFieldException);
}
function serializerOrNull(_this__u8e3s4) {
  var tmp0_elvis_lhs = compiledSerializerImpl(_this__u8e3s4);
  return tmp0_elvis_lhs == null ? builtinSerializerOrNull(_this__u8e3s4) : tmp0_elvis_lhs;
}
function serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer) {
  var tmp;
  if (failOnMissingTypeArgSerializer) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(typeArguments, 10));
    var _iterator__ex2g4s = typeArguments.j();
    while (_iterator__ex2g4s.k()) {
      var item = _iterator__ex2g4s.l();
      var tmp$ret$0 = serializer(_this__u8e3s4, item);
      destination.e(tmp$ret$0);
    }
    tmp = destination;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(typeArguments, 10));
    var _iterator__ex2g4s_0 = typeArguments.j();
    while (_iterator__ex2g4s_0.k()) {
      var item_0 = _iterator__ex2g4s_0.l();
      var tmp0_elvis_lhs = serializerOrNull_0(_this__u8e3s4, item_0);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        return null;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var tmp$ret$3 = tmp_0;
      destination_0.e(tmp$ret$3);
    }
    tmp = destination_0;
  }
  var serializers = tmp;
  return serializers;
}
function parametrizedSerializerOrNull(_this__u8e3s4, serializers, elementClassifierIfArray) {
  var tmp0_elvis_lhs = builtinParametrizedSerializer(_this__u8e3s4, serializers, elementClassifierIfArray);
  return tmp0_elvis_lhs == null ? compiledParametrizedSerializer(_this__u8e3s4, serializers) : tmp0_elvis_lhs;
}
function serializer(_this__u8e3s4, type) {
  var tmp0_elvis_lhs = serializerByKTypeImpl(_this__u8e3s4, type, true);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    platformSpecificSerializerNotRegistered(kclass(type));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function serializerOrNull_0(_this__u8e3s4, type) {
  return serializerByKTypeImpl(_this__u8e3s4, type, false);
}
function builtinParametrizedSerializer(_this__u8e3s4, serializers, elementClassifierIfArray) {
  var tmp;
  if (_this__u8e3s4.equals(getKClass(Collection)) || _this__u8e3s4.equals(getKClass(KtList)) || (_this__u8e3s4.equals(getKClass(KtMutableList)) || _this__u8e3s4.equals(getKClass(ArrayList)))) {
    tmp = new ArrayListSerializer(serializers.o(0));
  } else if (_this__u8e3s4.equals(getKClass(HashSet))) {
    tmp = new HashSetSerializer(serializers.o(0));
  } else if (_this__u8e3s4.equals(getKClass(KtSet)) || (_this__u8e3s4.equals(getKClass(KtMutableSet)) || _this__u8e3s4.equals(getKClass(LinkedHashSet)))) {
    tmp = new LinkedHashSetSerializer(serializers.o(0));
  } else if (_this__u8e3s4.equals(getKClass(HashMap))) {
    tmp = new HashMapSerializer(serializers.o(0), serializers.o(1));
  } else if (_this__u8e3s4.equals(getKClass(KtMap)) || (_this__u8e3s4.equals(getKClass(KtMutableMap)) || _this__u8e3s4.equals(getKClass(LinkedHashMap)))) {
    tmp = new LinkedHashMapSerializer(serializers.o(0), serializers.o(1));
  } else if (_this__u8e3s4.equals(getKClass(Entry))) {
    tmp = MapEntrySerializer(serializers.o(0), serializers.o(1));
  } else if (_this__u8e3s4.equals(getKClass(Pair))) {
    tmp = PairSerializer(serializers.o(0), serializers.o(1));
  } else if (_this__u8e3s4.equals(getKClass(Triple))) {
    tmp = TripleSerializer(serializers.o(0), serializers.o(1), serializers.o(2));
  } else {
    var tmp_0;
    if (isReferenceArray(_this__u8e3s4)) {
      var tmp_1 = elementClassifierIfArray();
      tmp_0 = ArraySerializer((!(tmp_1 == null) ? isInterface(tmp_1, KClass) : false) ? tmp_1 : THROW_CCE(), serializers.o(0));
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function compiledParametrizedSerializer(_this__u8e3s4, serializers) {
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$0 = copyToArray(serializers);
  return constructSerializerForGivenTypeArgs(_this__u8e3s4, tmp$ret$0.slice());
}
function serializerByKTypeImpl(_this__u8e3s4, type, failOnMissingTypeArgSerializer) {
  var rootClass = kclass(type);
  var isNullable = type.gb();
  // Inline function 'kotlin.collections.map' call
  var this_0 = type.fb();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$0 = typeOrThrow(item);
    destination.e(tmp$ret$0);
  }
  var typeArguments = destination;
  var tmp;
  if (typeArguments.p()) {
    var tmp_0;
    if (isInterface_0(rootClass) && !(_this__u8e3s4.gp(rootClass) == null)) {
      tmp_0 = null;
    } else {
      tmp_0 = findCachedSerializer(rootClass, isNullable);
    }
    tmp = tmp_0;
  } else {
    var tmp_1;
    if (_this__u8e3s4.fp()) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.Result.getOrNull' call
      var this_1 = findParametrizedCachedSerializer(rootClass, typeArguments, isNullable);
      var tmp_2;
      if (_Result___get_isFailure__impl__jpiriv(this_1)) {
        tmp_2 = null;
      } else {
        var tmp_3 = _Result___get_value__impl__bjfvqg(this_1);
        tmp_2 = (tmp_3 == null ? true : !(tmp_3 == null)) ? tmp_3 : THROW_CCE();
      }
      tmp_1 = tmp_2;
    }
    tmp = tmp_1;
  }
  var cachedSerializer = tmp;
  if (!(cachedSerializer == null))
    return cachedSerializer;
  var tmp_4;
  if (typeArguments.p()) {
    var tmp0_elvis_lhs = serializerOrNull(rootClass);
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? _this__u8e3s4.gp(rootClass) : tmp0_elvis_lhs;
    var tmp_5;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
      tmp_5 = isInterface_0(rootClass) ? new PolymorphicSerializer(rootClass) : null;
    } else {
      tmp_5 = tmp1_elvis_lhs;
    }
    tmp_4 = tmp_5;
  } else {
    var tmp2_elvis_lhs = serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer);
    var tmp_6;
    if (tmp2_elvis_lhs == null) {
      return null;
    } else {
      tmp_6 = tmp2_elvis_lhs;
    }
    var serializers = tmp_6;
    var tmp3_elvis_lhs = parametrizedSerializerOrNull(rootClass, serializers, serializerByKTypeImpl$lambda(typeArguments));
    var tmp4_elvis_lhs = tmp3_elvis_lhs == null ? _this__u8e3s4.hp(rootClass, serializers) : tmp3_elvis_lhs;
    var tmp_7;
    if (tmp4_elvis_lhs == null) {
      // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
      tmp_7 = isInterface_0(rootClass) ? new PolymorphicSerializer(rootClass) : null;
    } else {
      tmp_7 = tmp4_elvis_lhs;
    }
    tmp_4 = tmp_7;
  }
  var contextualSerializer = tmp_4;
  var tmp_8;
  if (contextualSerializer == null) {
    tmp_8 = null;
  } else {
    // Inline function 'kotlinx.serialization.internal.cast' call
    tmp_8 = isInterface(contextualSerializer, KSerializer) ? contextualSerializer : THROW_CCE();
  }
  var tmp6_safe_receiver = tmp_8;
  return tmp6_safe_receiver == null ? null : nullable(tmp6_safe_receiver, isNullable);
}
function nullable(_this__u8e3s4, shouldBeNullable) {
  if (shouldBeNullable)
    return get_nullable(_this__u8e3s4);
  return isInterface(_this__u8e3s4, KSerializer) ? _this__u8e3s4 : THROW_CCE();
}
function serializer_0(type) {
  return serializer(EmptySerializersModule_0(), type);
}
function serializer_1(_this__u8e3s4) {
  var tmp0_elvis_lhs = serializerOrNull(_this__u8e3s4);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    serializerNotRegistered(_this__u8e3s4);
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function serializerByKTypeImpl$lambda($typeArguments) {
  return function () {
    return $typeArguments.o(0).eb();
  };
}
function get_SERIALIZERS_CACHE() {
  _init_properties_SerializersCache_kt__hgwi2p();
  return SERIALIZERS_CACHE;
}
var SERIALIZERS_CACHE;
function get_SERIALIZERS_CACHE_NULLABLE() {
  _init_properties_SerializersCache_kt__hgwi2p();
  return SERIALIZERS_CACHE_NULLABLE;
}
var SERIALIZERS_CACHE_NULLABLE;
function get_PARAMETRIZED_SERIALIZERS_CACHE() {
  _init_properties_SerializersCache_kt__hgwi2p();
  return PARAMETRIZED_SERIALIZERS_CACHE;
}
var PARAMETRIZED_SERIALIZERS_CACHE;
function get_PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE() {
  _init_properties_SerializersCache_kt__hgwi2p();
  return PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE;
}
var PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE;
function findCachedSerializer(clazz, isNullable) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var tmp;
  if (!isNullable) {
    var tmp0_safe_receiver = get_SERIALIZERS_CACHE().ip(clazz);
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp_0 = isInterface(tmp0_safe_receiver, KSerializer) ? tmp0_safe_receiver : THROW_CCE();
    }
    tmp = tmp_0;
  } else {
    tmp = get_SERIALIZERS_CACHE_NULLABLE().ip(clazz);
  }
  return tmp;
}
function findParametrizedCachedSerializer(clazz, types, isNullable) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var tmp;
  if (!isNullable) {
    var tmp_0 = get_PARAMETRIZED_SERIALIZERS_CACHE().jp(clazz, types);
    tmp = new Result(tmp_0) instanceof Result ? tmp_0 : THROW_CCE();
  } else {
    tmp = get_PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE().jp(clazz, types);
  }
  return tmp;
}
function SERIALIZERS_CACHE$lambda(it) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var tmp0_elvis_lhs = serializerOrNull(it);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
    tmp = isInterface_0(it) ? new PolymorphicSerializer(it) : null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function SERIALIZERS_CACHE_NULLABLE$lambda(it) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var tmp0_elvis_lhs = serializerOrNull(it);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
    tmp = isInterface_0(it) ? new PolymorphicSerializer(it) : null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp1_safe_receiver = tmp;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : get_nullable(tmp1_safe_receiver);
  var tmp_0;
  if (tmp2_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlinx.serialization.internal.cast' call
    tmp_0 = isInterface(tmp2_safe_receiver, KSerializer) ? tmp2_safe_receiver : THROW_CCE();
  }
  return tmp_0;
}
function PARAMETRIZED_SERIALIZERS_CACHE$lambda(clazz, types) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var serializers = ensureNotNull(serializersForParameters(EmptySerializersModule_0(), types, true));
  return parametrizedSerializerOrNull(clazz, serializers, PARAMETRIZED_SERIALIZERS_CACHE$lambda$lambda(types));
}
function PARAMETRIZED_SERIALIZERS_CACHE$lambda$lambda($types) {
  return function () {
    return $types.o(0).eb();
  };
}
function PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda(clazz, types) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var serializers = ensureNotNull(serializersForParameters(EmptySerializersModule_0(), types, true));
  var tmp0_safe_receiver = parametrizedSerializerOrNull(clazz, serializers, PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda$lambda(types));
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_nullable(tmp0_safe_receiver);
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlinx.serialization.internal.cast' call
    tmp = isInterface(tmp1_safe_receiver, KSerializer) ? tmp1_safe_receiver : THROW_CCE();
  }
  return tmp;
}
function PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda$lambda($types) {
  return function () {
    return $types.o(0).eb();
  };
}
var properties_initialized_SerializersCache_kt_q8kf25;
function _init_properties_SerializersCache_kt__hgwi2p() {
  if (!properties_initialized_SerializersCache_kt_q8kf25) {
    properties_initialized_SerializersCache_kt_q8kf25 = true;
    SERIALIZERS_CACHE = createCache(SERIALIZERS_CACHE$lambda);
    SERIALIZERS_CACHE_NULLABLE = createCache(SERIALIZERS_CACHE_NULLABLE$lambda);
    PARAMETRIZED_SERIALIZERS_CACHE = createParametrizedCache(PARAMETRIZED_SERIALIZERS_CACHE$lambda);
    PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE = createParametrizedCache(PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda);
  }
}
function get_nullable(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4.xn().kp()) {
    tmp = isInterface(_this__u8e3s4, KSerializer) ? _this__u8e3s4 : THROW_CCE();
  } else {
    tmp = new NullableSerializer(_this__u8e3s4);
  }
  return tmp;
}
function serializer_2(_this__u8e3s4) {
  return StringSerializer_getInstance();
}
function serializer_3(_this__u8e3s4) {
  return CharSerializer_getInstance();
}
function CharArraySerializer() {
  return CharArraySerializer_getInstance();
}
function serializer_4(_this__u8e3s4) {
  return DoubleSerializer_getInstance();
}
function DoubleArraySerializer() {
  return DoubleArraySerializer_getInstance();
}
function serializer_5(_this__u8e3s4) {
  return FloatSerializer_getInstance();
}
function FloatArraySerializer() {
  return FloatArraySerializer_getInstance();
}
function serializer_6(_this__u8e3s4) {
  return LongSerializer_getInstance();
}
function LongArraySerializer() {
  return LongArraySerializer_getInstance();
}
function serializer_7(_this__u8e3s4) {
  return ULongSerializer_getInstance();
}
function ULongArraySerializer() {
  return ULongArraySerializer_getInstance();
}
function serializer_8(_this__u8e3s4) {
  return IntSerializer_getInstance();
}
function IntArraySerializer() {
  return IntArraySerializer_getInstance();
}
function serializer_9(_this__u8e3s4) {
  return UIntSerializer_getInstance();
}
function UIntArraySerializer() {
  return UIntArraySerializer_getInstance();
}
function serializer_10(_this__u8e3s4) {
  return ShortSerializer_getInstance();
}
function ShortArraySerializer() {
  return ShortArraySerializer_getInstance();
}
function serializer_11(_this__u8e3s4) {
  return UShortSerializer_getInstance();
}
function UShortArraySerializer() {
  return UShortArraySerializer_getInstance();
}
function serializer_12(_this__u8e3s4) {
  return ByteSerializer_getInstance();
}
function ByteArraySerializer() {
  return ByteArraySerializer_getInstance();
}
function serializer_13(_this__u8e3s4) {
  return UByteSerializer_getInstance();
}
function UByteArraySerializer() {
  return UByteArraySerializer_getInstance();
}
function serializer_14(_this__u8e3s4) {
  return BooleanSerializer_getInstance();
}
function BooleanArraySerializer() {
  return BooleanArraySerializer_getInstance();
}
function serializer_15(_this__u8e3s4) {
  return UnitSerializer_getInstance();
}
function NothingSerializer() {
  return NothingSerializer_getInstance();
}
function serializer_16(_this__u8e3s4) {
  return DurationSerializer_getInstance();
}
function serializer_17(_this__u8e3s4) {
  return UuidSerializer_getInstance();
}
function MapEntrySerializer(keySerializer, valueSerializer) {
  return new MapEntrySerializer_0(keySerializer, valueSerializer);
}
function PairSerializer(keySerializer, valueSerializer) {
  return new PairSerializer_0(keySerializer, valueSerializer);
}
function TripleSerializer(aSerializer, bSerializer, cSerializer) {
  return new TripleSerializer_0(aSerializer, bSerializer, cSerializer);
}
function ArraySerializer(kClass, elementSerializer) {
  return new ReferenceArraySerializer(kClass, elementSerializer);
}
function ListSerializer(elementSerializer) {
  return new ArrayListSerializer(elementSerializer);
}
function SetSerializer(elementSerializer) {
  return new LinkedHashSetSerializer(elementSerializer);
}
function MapSerializer(keySerializer, valueSerializer) {
  return new LinkedHashMapSerializer(keySerializer, valueSerializer);
}
function withContext(_this__u8e3s4, context) {
  return new ContextDescriptor(_this__u8e3s4, context);
}
function ContextDescriptor(original, kClass) {
  this.lp_1 = original;
  this.mp_1 = kClass;
  this.np_1 = this.lp_1.yo() + '<' + this.mp_1.pa() + '>';
}
protoOf(ContextDescriptor).yo = function () {
  return this.np_1;
};
protoOf(ContextDescriptor).equals = function (other) {
  var tmp0_elvis_lhs = other instanceof ContextDescriptor ? other : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var another = tmp;
  return equals(this.lp_1, another.lp_1) && another.mp_1.equals(this.mp_1);
};
protoOf(ContextDescriptor).hashCode = function () {
  var result = this.mp_1.hashCode();
  result = imul(31, result) + getStringHashCode(this.np_1) | 0;
  return result;
};
protoOf(ContextDescriptor).toString = function () {
  return 'ContextDescriptor(kClass: ' + toString(this.mp_1) + ', original: ' + toString(this.lp_1) + ')';
};
protoOf(ContextDescriptor).op = function () {
  return this.lp_1.op();
};
protoOf(ContextDescriptor).kp = function () {
  return this.lp_1.kp();
};
protoOf(ContextDescriptor).pp = function () {
  return this.lp_1.pp();
};
protoOf(ContextDescriptor).qp = function () {
  return this.lp_1.qp();
};
protoOf(ContextDescriptor).rp = function () {
  return this.lp_1.rp();
};
protoOf(ContextDescriptor).sp = function (index) {
  return this.lp_1.sp(index);
};
protoOf(ContextDescriptor).tp = function (name) {
  return this.lp_1.tp(name);
};
protoOf(ContextDescriptor).up = function (index) {
  return this.lp_1.up(index);
};
protoOf(ContextDescriptor).vp = function (index) {
  return this.lp_1.vp(index);
};
protoOf(ContextDescriptor).wp = function (index) {
  return this.lp_1.wp(index);
};
function getContextualDescriptor(_this__u8e3s4, descriptor) {
  var tmp0_safe_receiver = get_capturedKClass(descriptor);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_0 = _this__u8e3s4.gp(tmp0_safe_receiver);
    tmp = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.xn();
  }
  return tmp;
}
function get_capturedKClass(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof ContextDescriptor) {
    tmp = _this__u8e3s4.mp_1;
  } else {
    if (_this__u8e3s4 instanceof SerialDescriptorForNullable) {
      tmp = get_capturedKClass(_this__u8e3s4.xp_1);
    } else {
      tmp = null;
    }
  }
  return tmp;
}
function SerialDescriptor() {
}
function get_elementDescriptors(_this__u8e3s4) {
  // Inline function 'kotlin.collections.Iterable' call
  return new elementDescriptors$$inlined$Iterable$1(_this__u8e3s4);
}
function get_elementNames(_this__u8e3s4) {
  // Inline function 'kotlin.collections.Iterable' call
  return new elementNames$$inlined$Iterable$1(_this__u8e3s4);
}
function elementDescriptors$1($this_elementDescriptors) {
  this.bq_1 = $this_elementDescriptors;
  this.aq_1 = $this_elementDescriptors.qp();
}
protoOf(elementDescriptors$1).k = function () {
  return this.aq_1 > 0;
};
protoOf(elementDescriptors$1).l = function () {
  var tmp = this.bq_1.qp();
  var _unary__edvuaz = this.aq_1;
  this.aq_1 = _unary__edvuaz - 1 | 0;
  return this.bq_1.vp(tmp - _unary__edvuaz | 0);
};
function elementDescriptors$$inlined$Iterable$1($this_elementDescriptors) {
  this.cq_1 = $this_elementDescriptors;
}
protoOf(elementDescriptors$$inlined$Iterable$1).j = function () {
  return new elementDescriptors$1(this.cq_1);
};
function elementNames$1($this_elementNames) {
  this.eq_1 = $this_elementNames;
  this.dq_1 = $this_elementNames.qp();
}
protoOf(elementNames$1).k = function () {
  return this.dq_1 > 0;
};
protoOf(elementNames$1).l = function () {
  var tmp = this.eq_1.qp();
  var _unary__edvuaz = this.dq_1;
  this.dq_1 = _unary__edvuaz - 1 | 0;
  return this.eq_1.sp(tmp - _unary__edvuaz | 0);
};
function elementNames$$inlined$Iterable$1($this_elementNames) {
  this.fq_1 = $this_elementNames;
}
protoOf(elementNames$$inlined$Iterable$1).j = function () {
  return new elementNames$1(this.fq_1);
};
function buildSerialDescriptor(serialName, kind, typeParameters, builder) {
  var tmp;
  if (builder === VOID) {
    tmp = buildSerialDescriptor$lambda;
  } else {
    tmp = builder;
  }
  builder = tmp;
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.require' call
  if (!!isBlank(serialName)) {
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!!equals(kind, CLASS_getInstance())) {
    var message_0 = "For StructureKind.CLASS please use 'buildClassSerialDescriptor' instead";
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
  builder(sdBuilder);
  return new SerialDescriptorImpl(serialName, kind, sdBuilder.do_1.m(), toList(typeParameters), sdBuilder);
}
function ClassSerialDescriptorBuilder(serialName) {
  this.ao_1 = serialName;
  this.bo_1 = false;
  this.co_1 = emptyList();
  this.do_1 = ArrayList_init_$Create$_0();
  this.eo_1 = HashSet_init_$Create$();
  this.fo_1 = ArrayList_init_$Create$_0();
  this.go_1 = ArrayList_init_$Create$_0();
  this.ho_1 = ArrayList_init_$Create$_0();
}
protoOf(ClassSerialDescriptorBuilder).gq = function (elementName, descriptor, annotations, isOptional) {
  // Inline function 'kotlin.require' call
  if (!this.eo_1.e(elementName)) {
    var message = "Element with name '" + elementName + "' is already registered in " + this.ao_1;
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.collections.plusAssign' call
  this.do_1.e(elementName);
  // Inline function 'kotlin.collections.plusAssign' call
  this.fo_1.e(descriptor);
  // Inline function 'kotlin.collections.plusAssign' call
  this.go_1.e(annotations);
  // Inline function 'kotlin.collections.plusAssign' call
  this.ho_1.e(isOptional);
};
protoOf(ClassSerialDescriptorBuilder).io = function (elementName, descriptor, annotations, isOptional, $super) {
  annotations = annotations === VOID ? emptyList() : annotations;
  isOptional = isOptional === VOID ? false : isOptional;
  var tmp;
  if ($super === VOID) {
    this.gq(elementName, descriptor, annotations, isOptional);
    tmp = Unit_instance;
  } else {
    tmp = $super.gq.call(this, elementName, descriptor, annotations, isOptional);
  }
  return tmp;
};
function _get__hashCode__tgwhef($this) {
  var tmp0 = $this.sq_1;
  // Inline function 'kotlin.getValue' call
  _hashCode$factory();
  return tmp0.t();
}
function SerialDescriptorImpl$_hashCode$delegate$lambda(this$0) {
  return function () {
    return hashCodeImpl(this$0, this$0.rq_1);
  };
}
function SerialDescriptorImpl(serialName, kind, elementsCount, typeParameters, builder) {
  this.hq_1 = serialName;
  this.iq_1 = kind;
  this.jq_1 = elementsCount;
  this.kq_1 = builder.co_1;
  this.lq_1 = toHashSet(builder.do_1);
  var tmp = this;
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = builder.do_1;
  tmp.mq_1 = copyToArray(this_0);
  this.nq_1 = compactArray(builder.fo_1);
  var tmp_0 = this;
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_1 = builder.go_1;
  tmp_0.oq_1 = copyToArray(this_1);
  this.pq_1 = toBooleanArray(builder.ho_1);
  var tmp_1 = this;
  // Inline function 'kotlin.collections.map' call
  var this_2 = withIndex(this.mq_1);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
  var _iterator__ex2g4s = this_2.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = to(item.cf_1, item.bf_1);
    destination.e(tmp$ret$2);
  }
  tmp_1.qq_1 = toMap(destination);
  this.rq_1 = compactArray(typeParameters);
  var tmp_2 = this;
  tmp_2.sq_1 = lazy_0(SerialDescriptorImpl$_hashCode$delegate$lambda(this));
}
protoOf(SerialDescriptorImpl).yo = function () {
  return this.hq_1;
};
protoOf(SerialDescriptorImpl).op = function () {
  return this.iq_1;
};
protoOf(SerialDescriptorImpl).qp = function () {
  return this.jq_1;
};
protoOf(SerialDescriptorImpl).rp = function () {
  return this.kq_1;
};
protoOf(SerialDescriptorImpl).tq = function () {
  return this.lq_1;
};
protoOf(SerialDescriptorImpl).sp = function (index) {
  return getChecked(this.mq_1, index);
};
protoOf(SerialDescriptorImpl).tp = function (name) {
  var tmp0_elvis_lhs = this.qq_1.a2(name);
  return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
};
protoOf(SerialDescriptorImpl).up = function (index) {
  return getChecked(this.oq_1, index);
};
protoOf(SerialDescriptorImpl).vp = function (index) {
  return getChecked(this.nq_1, index);
};
protoOf(SerialDescriptorImpl).wp = function (index) {
  return getChecked_0(this.pq_1, index);
};
protoOf(SerialDescriptorImpl).equals = function (other) {
  var tmp$ret$0;
  $l$block_5: {
    // Inline function 'kotlinx.serialization.internal.equalsImpl' call
    if (this === other) {
      tmp$ret$0 = true;
      break $l$block_5;
    }
    if (!(other instanceof SerialDescriptorImpl)) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    if (!(this.yo() === other.yo())) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    if (!contentEquals(this.rq_1, other.rq_1)) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    if (!(this.qp() === other.qp())) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    var inductionVariable = 0;
    var last = this.qp();
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(this.vp(index).yo() === other.vp(index).yo())) {
          tmp$ret$0 = false;
          break $l$block_5;
        }
        if (!equals(this.vp(index).op(), other.vp(index).op())) {
          tmp$ret$0 = false;
          break $l$block_5;
        }
      }
       while (inductionVariable < last);
    tmp$ret$0 = true;
  }
  return tmp$ret$0;
};
protoOf(SerialDescriptorImpl).hashCode = function () {
  return _get__hashCode__tgwhef(this);
};
protoOf(SerialDescriptorImpl).toString = function () {
  return toStringImpl(this);
};
function buildClassSerialDescriptor(serialName, typeParameters, builderAction) {
  var tmp;
  if (builderAction === VOID) {
    tmp = buildClassSerialDescriptor$lambda;
  } else {
    tmp = builderAction;
  }
  builderAction = tmp;
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.require' call
  if (!!isBlank(serialName)) {
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
  builderAction(sdBuilder);
  return new SerialDescriptorImpl(serialName, CLASS_getInstance(), sdBuilder.do_1.m(), toList(typeParameters), sdBuilder);
}
function PrimitiveSerialDescriptor(serialName, kind) {
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.require' call
  if (!!isBlank(serialName)) {
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return PrimitiveDescriptorSafe(serialName, kind);
}
function buildSerialDescriptor$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function buildClassSerialDescriptor$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function _hashCode$factory() {
  return getPropertyCallableRef('_hashCode', 1, KProperty1, function (receiver) {
    return _get__hashCode__tgwhef(receiver);
  }, null);
}
function ENUM() {
  ENUM_instance = this;
  SerialKind.call(this);
}
var ENUM_instance;
function ENUM_getInstance() {
  if (ENUM_instance == null)
    new ENUM();
  return ENUM_instance;
}
function CONTEXTUAL() {
  CONTEXTUAL_instance = this;
  SerialKind.call(this);
}
var CONTEXTUAL_instance;
function CONTEXTUAL_getInstance() {
  if (CONTEXTUAL_instance == null)
    new CONTEXTUAL();
  return CONTEXTUAL_instance;
}
function SerialKind() {
}
protoOf(SerialKind).toString = function () {
  return ensureNotNull(getKClassFromExpression(this).pa());
};
protoOf(SerialKind).hashCode = function () {
  return getStringHashCode(this.toString());
};
function SEALED() {
  SEALED_instance = this;
  PolymorphicKind.call(this);
}
var SEALED_instance;
function SEALED_getInstance() {
  if (SEALED_instance == null)
    new SEALED();
  return SEALED_instance;
}
function OPEN() {
  OPEN_instance = this;
  PolymorphicKind.call(this);
}
var OPEN_instance;
function OPEN_getInstance() {
  if (OPEN_instance == null)
    new OPEN();
  return OPEN_instance;
}
function PolymorphicKind() {
  SerialKind.call(this);
}
function BOOLEAN() {
  BOOLEAN_instance = this;
  PrimitiveKind.call(this);
}
var BOOLEAN_instance;
function BOOLEAN_getInstance() {
  if (BOOLEAN_instance == null)
    new BOOLEAN();
  return BOOLEAN_instance;
}
function BYTE() {
  BYTE_instance = this;
  PrimitiveKind.call(this);
}
var BYTE_instance;
function BYTE_getInstance() {
  if (BYTE_instance == null)
    new BYTE();
  return BYTE_instance;
}
function CHAR() {
  CHAR_instance = this;
  PrimitiveKind.call(this);
}
var CHAR_instance;
function CHAR_getInstance() {
  if (CHAR_instance == null)
    new CHAR();
  return CHAR_instance;
}
function SHORT() {
  SHORT_instance = this;
  PrimitiveKind.call(this);
}
var SHORT_instance;
function SHORT_getInstance() {
  if (SHORT_instance == null)
    new SHORT();
  return SHORT_instance;
}
function INT() {
  INT_instance = this;
  PrimitiveKind.call(this);
}
var INT_instance;
function INT_getInstance() {
  if (INT_instance == null)
    new INT();
  return INT_instance;
}
function LONG() {
  LONG_instance = this;
  PrimitiveKind.call(this);
}
var LONG_instance;
function LONG_getInstance() {
  if (LONG_instance == null)
    new LONG();
  return LONG_instance;
}
function FLOAT() {
  FLOAT_instance = this;
  PrimitiveKind.call(this);
}
var FLOAT_instance;
function FLOAT_getInstance() {
  if (FLOAT_instance == null)
    new FLOAT();
  return FLOAT_instance;
}
function DOUBLE() {
  DOUBLE_instance = this;
  PrimitiveKind.call(this);
}
var DOUBLE_instance;
function DOUBLE_getInstance() {
  if (DOUBLE_instance == null)
    new DOUBLE();
  return DOUBLE_instance;
}
function STRING() {
  STRING_instance = this;
  PrimitiveKind.call(this);
}
var STRING_instance;
function STRING_getInstance() {
  if (STRING_instance == null)
    new STRING();
  return STRING_instance;
}
function PrimitiveKind() {
  SerialKind.call(this);
}
function CLASS() {
  CLASS_instance = this;
  StructureKind.call(this);
}
var CLASS_instance;
function CLASS_getInstance() {
  if (CLASS_instance == null)
    new CLASS();
  return CLASS_instance;
}
function LIST() {
  LIST_instance = this;
  StructureKind.call(this);
}
var LIST_instance;
function LIST_getInstance() {
  if (LIST_instance == null)
    new LIST();
  return LIST_instance;
}
function MAP() {
  MAP_instance = this;
  StructureKind.call(this);
}
var MAP_instance;
function MAP_getInstance() {
  if (MAP_instance == null)
    new MAP();
  return MAP_instance;
}
function OBJECT() {
  OBJECT_instance = this;
  StructureKind.call(this);
}
var OBJECT_instance;
function OBJECT_getInstance() {
  if (OBJECT_instance == null)
    new OBJECT();
  return OBJECT_instance;
}
function StructureKind() {
  SerialKind.call(this);
}
function AbstractDecoder() {
}
protoOf(AbstractDecoder).uq = function () {
  throw SerializationException_init_$Create$_0(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
};
protoOf(AbstractDecoder).vq = function () {
  return true;
};
protoOf(AbstractDecoder).wq = function () {
  return null;
};
protoOf(AbstractDecoder).xq = function () {
  var tmp = this.uq();
  return typeof tmp === 'boolean' ? tmp : THROW_CCE();
};
protoOf(AbstractDecoder).yq = function () {
  var tmp = this.uq();
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(AbstractDecoder).zq = function () {
  var tmp = this.uq();
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(AbstractDecoder).ar = function () {
  var tmp = this.uq();
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(AbstractDecoder).br = function () {
  var tmp = this.uq();
  return tmp instanceof Long ? tmp : THROW_CCE();
};
protoOf(AbstractDecoder).cr = function () {
  var tmp = this.uq();
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(AbstractDecoder).dr = function () {
  var tmp = this.uq();
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(AbstractDecoder).er = function () {
  var tmp = this.uq();
  return tmp instanceof Char ? tmp.i1_1 : THROW_CCE();
};
protoOf(AbstractDecoder).fr = function () {
  var tmp = this.uq();
  return typeof tmp === 'string' ? tmp : THROW_CCE();
};
protoOf(AbstractDecoder).gr = function (enumDescriptor) {
  var tmp = this.uq();
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(AbstractDecoder).hr = function (descriptor) {
  return this;
};
protoOf(AbstractDecoder).ir = function (deserializer, previousValue) {
  return this.jr(deserializer);
};
protoOf(AbstractDecoder).kr = function (descriptor) {
  return this;
};
protoOf(AbstractDecoder).lr = function (descriptor) {
};
protoOf(AbstractDecoder).mr = function (descriptor, index) {
  return this.xq();
};
protoOf(AbstractDecoder).nr = function (descriptor, index) {
  return this.yq();
};
protoOf(AbstractDecoder).or = function (descriptor, index) {
  return this.zq();
};
protoOf(AbstractDecoder).pr = function (descriptor, index) {
  return this.ar();
};
protoOf(AbstractDecoder).qr = function (descriptor, index) {
  return this.br();
};
protoOf(AbstractDecoder).rr = function (descriptor, index) {
  return this.cr();
};
protoOf(AbstractDecoder).sr = function (descriptor, index) {
  return this.dr();
};
protoOf(AbstractDecoder).tr = function (descriptor, index) {
  return this.er();
};
protoOf(AbstractDecoder).ur = function (descriptor, index) {
  return this.fr();
};
protoOf(AbstractDecoder).vr = function (descriptor, index) {
  return this.hr(descriptor.vp(index));
};
protoOf(AbstractDecoder).wr = function (descriptor, index, deserializer, previousValue) {
  return this.ir(deserializer, previousValue);
};
protoOf(AbstractDecoder).yr = function (descriptor, index, deserializer, previousValue) {
  // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
  var isNullabilitySupported = deserializer.xn().kp();
  var tmp;
  if (isNullabilitySupported || this.vq()) {
    tmp = this.ir(deserializer, previousValue);
  } else {
    tmp = this.wq();
  }
  return tmp;
};
function AbstractEncoder() {
}
protoOf(AbstractEncoder).kr = function (descriptor) {
  return this;
};
protoOf(AbstractEncoder).lr = function (descriptor) {
};
protoOf(AbstractEncoder).ds = function (descriptor, index) {
  return true;
};
protoOf(AbstractEncoder).es = function (value) {
  throw SerializationException_init_$Create$_0('Non-serializable ' + toString(getKClassFromExpression(value)) + ' is not supported by ' + toString(getKClassFromExpression(this)) + ' encoder');
};
protoOf(AbstractEncoder).fs = function () {
  throw SerializationException_init_$Create$_0("'null' is not supported by default");
};
protoOf(AbstractEncoder).gs = function (value) {
  return this.es(value);
};
protoOf(AbstractEncoder).hs = function (value) {
  return this.es(value);
};
protoOf(AbstractEncoder).is = function (value) {
  return this.es(value);
};
protoOf(AbstractEncoder).js = function (value) {
  return this.es(value);
};
protoOf(AbstractEncoder).ks = function (value) {
  return this.es(value);
};
protoOf(AbstractEncoder).ls = function (value) {
  return this.es(value);
};
protoOf(AbstractEncoder).ms = function (value) {
  return this.es(value);
};
protoOf(AbstractEncoder).ns = function (value) {
  return this.es(new Char(value));
};
protoOf(AbstractEncoder).os = function (value) {
  return this.es(value);
};
protoOf(AbstractEncoder).ps = function (enumDescriptor, index) {
  return this.es(index);
};
protoOf(AbstractEncoder).qs = function (descriptor) {
  return this;
};
protoOf(AbstractEncoder).rs = function (descriptor, index, value) {
  if (this.ds(descriptor, index)) {
    this.gs(value);
  }
};
protoOf(AbstractEncoder).ss = function (descriptor, index, value) {
  if (this.ds(descriptor, index)) {
    this.hs(value);
  }
};
protoOf(AbstractEncoder).ts = function (descriptor, index, value) {
  if (this.ds(descriptor, index)) {
    this.is(value);
  }
};
protoOf(AbstractEncoder).us = function (descriptor, index, value) {
  if (this.ds(descriptor, index)) {
    this.js(value);
  }
};
protoOf(AbstractEncoder).vs = function (descriptor, index, value) {
  if (this.ds(descriptor, index)) {
    this.ks(value);
  }
};
protoOf(AbstractEncoder).ws = function (descriptor, index, value) {
  if (this.ds(descriptor, index)) {
    this.ls(value);
  }
};
protoOf(AbstractEncoder).xs = function (descriptor, index, value) {
  if (this.ds(descriptor, index)) {
    this.ms(value);
  }
};
protoOf(AbstractEncoder).ys = function (descriptor, index, value) {
  if (this.ds(descriptor, index)) {
    this.ns(value);
  }
};
protoOf(AbstractEncoder).zs = function (descriptor, index, value) {
  if (this.ds(descriptor, index)) {
    this.os(value);
  }
};
protoOf(AbstractEncoder).at = function (descriptor, index) {
  return this.ds(descriptor, index) ? this.qs(descriptor.vp(index)) : NoOpEncoder_getInstance();
};
protoOf(AbstractEncoder).bt = function (descriptor, index, serializer, value) {
  if (this.ds(descriptor, index)) {
    this.ct(serializer, value);
  }
};
protoOf(AbstractEncoder).dt = function (descriptor, index, serializer, value) {
  if (this.ds(descriptor, index)) {
    this.et(serializer, value);
  }
};
function Decoder() {
}
function CompositeDecoder() {
}
function Encoder() {
}
function CompositeEncoder() {
}
function decodeSequentially_0($this, compositeDecoder) {
  var klassName = compositeDecoder.ur($this.xn(), 0);
  var serializer = findPolymorphicSerializer_0($this, compositeDecoder, klassName);
  return compositeDecoder.xr($this.xn(), 1, serializer);
}
function AbstractPolymorphicSerializer() {
}
protoOf(AbstractPolymorphicSerializer).no = function (encoder, value) {
  var actualSerializer = findPolymorphicSerializer(this, encoder, value);
  // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
  var descriptor = this.xn();
  var composite = encoder.kr(descriptor);
  composite.zs(this.xn(), 0, actualSerializer.xn().yo());
  var tmp = this.xn();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var tmp$ret$0 = isInterface(actualSerializer, SerializationStrategy) ? actualSerializer : THROW_CCE();
  composite.bt(tmp, 1, tmp$ret$0, value);
  composite.lr(descriptor);
};
protoOf(AbstractPolymorphicSerializer).yn = function (encoder, value) {
  return this.no(encoder, !(value == null) ? value : THROW_CCE());
};
protoOf(AbstractPolymorphicSerializer).zn = function (decoder) {
  // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
  var descriptor = this.xn();
  var composite = decoder.kr(descriptor);
  var tmp$ret$0;
  $l$block: {
    var klassName = null;
    var value = null;
    if (composite.as()) {
      tmp$ret$0 = decodeSequentially_0(this, composite);
      break $l$block;
    }
    mainLoop: while (true) {
      var index = composite.bs(this.xn());
      switch (index) {
        case -1:
          break mainLoop;
        case 0:
          klassName = composite.ur(this.xn(), index);
          break;
        case 1:
          var tmp0 = klassName;
          var tmp$ret$2;
          $l$block_0: {
            // Inline function 'kotlin.requireNotNull' call
            if (tmp0 == null) {
              var message = 'Cannot read polymorphic value before its type token';
              throw IllegalArgumentException_init_$Create$(toString(message));
            } else {
              tmp$ret$2 = tmp0;
              break $l$block_0;
            }
          }

          klassName = tmp$ret$2;
          var serializer = findPolymorphicSerializer_0(this, composite, klassName);
          value = composite.xr(this.xn(), index, serializer);
          break;
        default:
          var tmp0_elvis_lhs = klassName;
          throw SerializationException_init_$Create$_0('Invalid index in polymorphic deserialization of ' + (tmp0_elvis_lhs == null ? 'unknown class' : tmp0_elvis_lhs) + ('\n Expected 0, 1 or DECODE_DONE(-1), but found ' + index));
      }
    }
    var tmp1 = value;
    var tmp$ret$4;
    $l$block_1: {
      // Inline function 'kotlin.requireNotNull' call
      if (tmp1 == null) {
        var message_0 = 'Polymorphic value has not been read for class ' + klassName;
        throw IllegalArgumentException_init_$Create$(toString(message_0));
      } else {
        tmp$ret$4 = tmp1;
        break $l$block_1;
      }
    }
    var tmp = tmp$ret$4;
    tmp$ret$0 = !(tmp == null) ? tmp : THROW_CCE();
  }
  var result = tmp$ret$0;
  composite.lr(descriptor);
  return result;
};
protoOf(AbstractPolymorphicSerializer).oo = function (decoder, klassName) {
  return decoder.zr().it(this.mo(), klassName);
};
protoOf(AbstractPolymorphicSerializer).po = function (encoder, value) {
  return encoder.zr().jt(this.mo(), value);
};
function throwSubtypeNotRegistered(subClass, baseClass) {
  var tmp0_elvis_lhs = subClass.pa();
  throwSubtypeNotRegistered_0(tmp0_elvis_lhs == null ? toString(subClass) : tmp0_elvis_lhs, baseClass);
}
function throwSubtypeNotRegistered_0(subClassName, baseClass) {
  var scope = "in the polymorphic scope of '" + baseClass.pa() + "'";
  throw SerializationException_init_$Create$_0(subClassName == null ? 'Class discriminator was missing and no default serializers were registered ' + scope + '.' : "Serializer for subclass '" + subClassName + "' is not found " + scope + '.\n' + ("Check if class with serial name '" + subClassName + "' exists and serializer is registered in a corresponding SerializersModule.\n") + ("To be registered automatically, class '" + subClassName + "' has to be '@Serializable', and the base class '" + baseClass.pa() + "' has to be sealed and '@Serializable'."));
}
function NothingSerializer_0() {
  NothingSerializer_instance = this;
  this.kt_1 = NothingSerialDescriptor_getInstance();
}
protoOf(NothingSerializer_0).xn = function () {
  return this.kt_1;
};
protoOf(NothingSerializer_0).lt = function (encoder, value) {
  throw SerializationException_init_$Create$_0("'kotlin.Nothing' cannot be serialized");
};
protoOf(NothingSerializer_0).yn = function (encoder, value) {
  var tmp;
  if (false) {
    tmp = value;
  } else {
    tmp = THROW_CCE();
  }
  return this.lt(encoder, tmp);
};
protoOf(NothingSerializer_0).zn = function (decoder) {
  throw SerializationException_init_$Create$_0("'kotlin.Nothing' does not have instances");
};
var NothingSerializer_instance;
function NothingSerializer_getInstance() {
  if (NothingSerializer_instance == null)
    new NothingSerializer_0();
  return NothingSerializer_instance;
}
function DurationSerializer() {
  DurationSerializer_instance = this;
  this.mt_1 = new PrimitiveSerialDescriptor_0('kotlin.time.Duration', STRING_getInstance());
}
protoOf(DurationSerializer).xn = function () {
  return this.mt_1;
};
protoOf(DurationSerializer).nt = function (encoder, value) {
  encoder.os(Duration__toIsoString_impl_9h6wsm(value));
};
protoOf(DurationSerializer).yn = function (encoder, value) {
  return this.nt(encoder, value instanceof Duration ? value.ld_1 : THROW_CCE());
};
protoOf(DurationSerializer).ot = function (decoder) {
  return Companion_getInstance().cl(decoder.fr());
};
protoOf(DurationSerializer).zn = function (decoder) {
  return new Duration(this.ot(decoder));
};
var DurationSerializer_instance;
function DurationSerializer_getInstance() {
  if (DurationSerializer_instance == null)
    new DurationSerializer();
  return DurationSerializer_instance;
}
function UuidSerializer() {
  UuidSerializer_instance = this;
  this.pt_1 = new PrimitiveSerialDescriptor_0('kotlin.uuid.Uuid', STRING_getInstance());
}
protoOf(UuidSerializer).xn = function () {
  return this.pt_1;
};
protoOf(UuidSerializer).qt = function (encoder, value) {
  encoder.os(value.toString());
};
protoOf(UuidSerializer).yn = function (encoder, value) {
  return this.qt(encoder, value instanceof Uuid ? value : THROW_CCE());
};
protoOf(UuidSerializer).zn = function (decoder) {
  return Companion_getInstance_0().zl(decoder.fr());
};
var UuidSerializer_instance;
function UuidSerializer_getInstance() {
  if (UuidSerializer_instance == null)
    new UuidSerializer();
  return UuidSerializer_instance;
}
function CachedNames() {
}
function ArrayListClassDesc(elementDesc) {
  ListLikeDescriptor.call(this, elementDesc);
}
protoOf(ArrayListClassDesc).yo = function () {
  return 'kotlin.collections.ArrayList';
};
function HashSetClassDesc(elementDesc) {
  ListLikeDescriptor.call(this, elementDesc);
}
protoOf(HashSetClassDesc).yo = function () {
  return 'kotlin.collections.HashSet';
};
function LinkedHashSetClassDesc(elementDesc) {
  ListLikeDescriptor.call(this, elementDesc);
}
protoOf(LinkedHashSetClassDesc).yo = function () {
  return 'kotlin.collections.LinkedHashSet';
};
function HashMapClassDesc(keyDesc, valueDesc) {
  MapLikeDescriptor.call(this, 'kotlin.collections.HashMap', keyDesc, valueDesc);
}
function LinkedHashMapClassDesc(keyDesc, valueDesc) {
  MapLikeDescriptor.call(this, 'kotlin.collections.LinkedHashMap', keyDesc, valueDesc);
}
function ArrayClassDesc(elementDesc) {
  ListLikeDescriptor.call(this, elementDesc);
}
protoOf(ArrayClassDesc).yo = function () {
  return 'kotlin.Array';
};
function ListLikeDescriptor(elementDescriptor) {
  this.tt_1 = elementDescriptor;
  this.ut_1 = 1;
}
protoOf(ListLikeDescriptor).op = function () {
  return LIST_getInstance();
};
protoOf(ListLikeDescriptor).qp = function () {
  return this.ut_1;
};
protoOf(ListLikeDescriptor).sp = function (index) {
  return index.toString();
};
protoOf(ListLikeDescriptor).tp = function (name) {
  var tmp0_elvis_lhs = toIntOrNull(name);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$(name + ' is not a valid list index');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
};
protoOf(ListLikeDescriptor).wp = function (index) {
  // Inline function 'kotlin.require' call
  if (!(index >= 0)) {
    var message = 'Illegal index ' + index + ', ' + this.yo() + ' expects only non-negative indices';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return false;
};
protoOf(ListLikeDescriptor).up = function (index) {
  // Inline function 'kotlin.require' call
  if (!(index >= 0)) {
    var message = 'Illegal index ' + index + ', ' + this.yo() + ' expects only non-negative indices';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return emptyList();
};
protoOf(ListLikeDescriptor).vp = function (index) {
  // Inline function 'kotlin.require' call
  if (!(index >= 0)) {
    var message = 'Illegal index ' + index + ', ' + this.yo() + ' expects only non-negative indices';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return this.tt_1;
};
protoOf(ListLikeDescriptor).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ListLikeDescriptor))
    return false;
  if (equals(this.tt_1, other.tt_1) && this.yo() === other.yo())
    return true;
  return false;
};
protoOf(ListLikeDescriptor).hashCode = function () {
  return imul(hashCode(this.tt_1), 31) + getStringHashCode(this.yo()) | 0;
};
protoOf(ListLikeDescriptor).toString = function () {
  return this.yo() + '(' + toString(this.tt_1) + ')';
};
function MapLikeDescriptor(serialName, keyDescriptor, valueDescriptor) {
  this.zt_1 = serialName;
  this.au_1 = keyDescriptor;
  this.bu_1 = valueDescriptor;
  this.cu_1 = 2;
}
protoOf(MapLikeDescriptor).yo = function () {
  return this.zt_1;
};
protoOf(MapLikeDescriptor).op = function () {
  return MAP_getInstance();
};
protoOf(MapLikeDescriptor).qp = function () {
  return this.cu_1;
};
protoOf(MapLikeDescriptor).sp = function (index) {
  return index.toString();
};
protoOf(MapLikeDescriptor).tp = function (name) {
  var tmp0_elvis_lhs = toIntOrNull(name);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$(name + ' is not a valid map index');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
};
protoOf(MapLikeDescriptor).wp = function (index) {
  // Inline function 'kotlin.require' call
  if (!(index >= 0)) {
    var message = 'Illegal index ' + index + ', ' + this.yo() + ' expects only non-negative indices';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return false;
};
protoOf(MapLikeDescriptor).up = function (index) {
  // Inline function 'kotlin.require' call
  if (!(index >= 0)) {
    var message = 'Illegal index ' + index + ', ' + this.yo() + ' expects only non-negative indices';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return emptyList();
};
protoOf(MapLikeDescriptor).vp = function (index) {
  // Inline function 'kotlin.require' call
  if (!(index >= 0)) {
    var message = 'Illegal index ' + index + ', ' + this.yo() + ' expects only non-negative indices';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp;
  switch (index % 2 | 0) {
    case 0:
      tmp = this.au_1;
      break;
    case 1:
      tmp = this.bu_1;
      break;
    default:
      var message_0 = 'Unreached';
      throw IllegalStateException_init_$Create$(toString(message_0));
  }
  return tmp;
};
protoOf(MapLikeDescriptor).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof MapLikeDescriptor))
    return false;
  if (!(this.yo() === other.yo()))
    return false;
  if (!equals(this.au_1, other.au_1))
    return false;
  if (!equals(this.bu_1, other.bu_1))
    return false;
  return true;
};
protoOf(MapLikeDescriptor).hashCode = function () {
  var result = getStringHashCode(this.yo());
  result = imul(31, result) + hashCode(this.au_1) | 0;
  result = imul(31, result) + hashCode(this.bu_1) | 0;
  return result;
};
protoOf(MapLikeDescriptor).toString = function () {
  return this.yo() + '(' + toString(this.au_1) + ', ' + toString(this.bu_1) + ')';
};
function PrimitiveArrayDescriptor(primitive) {
  ListLikeDescriptor.call(this, primitive);
  this.hu_1 = primitive.yo() + 'Array';
}
protoOf(PrimitiveArrayDescriptor).yo = function () {
  return this.hu_1;
};
function ArrayListSerializer(element) {
  CollectionSerializer.call(this, element);
  this.ju_1 = new ArrayListClassDesc(element.xn());
}
protoOf(ArrayListSerializer).xn = function () {
  return this.ju_1;
};
protoOf(ArrayListSerializer).ku = function () {
  // Inline function 'kotlin.collections.arrayListOf' call
  return ArrayList_init_$Create$_0();
};
protoOf(ArrayListSerializer).lu = function (_this__u8e3s4) {
  return _this__u8e3s4.m();
};
protoOf(ArrayListSerializer).mu = function (_this__u8e3s4) {
  return this.lu(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ArrayListSerializer).nu = function (_this__u8e3s4) {
  return _this__u8e3s4;
};
protoOf(ArrayListSerializer).ou = function (_this__u8e3s4) {
  return this.nu(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ArrayListSerializer).pu = function (_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : null;
  return tmp0_elvis_lhs == null ? ArrayList_init_$Create$_1(_this__u8e3s4) : tmp0_elvis_lhs;
};
protoOf(ArrayListSerializer).qu = function (_this__u8e3s4) {
  return this.pu((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtList) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ArrayListSerializer).ru = function (_this__u8e3s4, size) {
  return _this__u8e3s4.k5(size);
};
protoOf(ArrayListSerializer).su = function (_this__u8e3s4, size) {
  return this.ru(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), size);
};
protoOf(ArrayListSerializer).tu = function (_this__u8e3s4, index, element) {
  _this__u8e3s4.f2(index, element);
};
protoOf(ArrayListSerializer).uu = function (_this__u8e3s4, index, element) {
  var tmp = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE();
  return this.tu(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
};
function HashSetSerializer(eSerializer) {
  CollectionSerializer.call(this, eSerializer);
  this.fv_1 = new HashSetClassDesc(eSerializer.xn());
}
protoOf(HashSetSerializer).xn = function () {
  return this.fv_1;
};
protoOf(HashSetSerializer).ku = function () {
  return HashSet_init_$Create$();
};
protoOf(HashSetSerializer).gv = function (_this__u8e3s4) {
  return _this__u8e3s4.m();
};
protoOf(HashSetSerializer).mu = function (_this__u8e3s4) {
  return this.gv(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE());
};
protoOf(HashSetSerializer).hv = function (_this__u8e3s4) {
  return _this__u8e3s4;
};
protoOf(HashSetSerializer).ou = function (_this__u8e3s4) {
  return this.hv(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE());
};
protoOf(HashSetSerializer).iv = function (_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : null;
  return tmp0_elvis_lhs == null ? HashSet_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
};
protoOf(HashSetSerializer).qu = function (_this__u8e3s4) {
  return this.iv((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(HashSetSerializer).jv = function (_this__u8e3s4, size) {
};
protoOf(HashSetSerializer).su = function (_this__u8e3s4, size) {
  return this.jv(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE(), size);
};
protoOf(HashSetSerializer).kv = function (_this__u8e3s4, index, element) {
  _this__u8e3s4.e(element);
};
protoOf(HashSetSerializer).uu = function (_this__u8e3s4, index, element) {
  var tmp = _this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE();
  return this.kv(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
};
function LinkedHashSetSerializer(eSerializer) {
  CollectionSerializer.call(this, eSerializer);
  this.mv_1 = new LinkedHashSetClassDesc(eSerializer.xn());
}
protoOf(LinkedHashSetSerializer).xn = function () {
  return this.mv_1;
};
protoOf(LinkedHashSetSerializer).ku = function () {
  // Inline function 'kotlin.collections.linkedSetOf' call
  return LinkedHashSet_init_$Create$();
};
protoOf(LinkedHashSetSerializer).nv = function (_this__u8e3s4) {
  return _this__u8e3s4.m();
};
protoOf(LinkedHashSetSerializer).mu = function (_this__u8e3s4) {
  return this.nv(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
};
protoOf(LinkedHashSetSerializer).ov = function (_this__u8e3s4) {
  return _this__u8e3s4;
};
protoOf(LinkedHashSetSerializer).ou = function (_this__u8e3s4) {
  return this.ov(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
};
protoOf(LinkedHashSetSerializer).iv = function (_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : null;
  return tmp0_elvis_lhs == null ? LinkedHashSet_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
};
protoOf(LinkedHashSetSerializer).qu = function (_this__u8e3s4) {
  return this.iv((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(LinkedHashSetSerializer).pv = function (_this__u8e3s4, size) {
};
protoOf(LinkedHashSetSerializer).su = function (_this__u8e3s4, size) {
  return this.pv(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE(), size);
};
protoOf(LinkedHashSetSerializer).qv = function (_this__u8e3s4, index, element) {
  _this__u8e3s4.e(element);
};
protoOf(LinkedHashSetSerializer).uu = function (_this__u8e3s4, index, element) {
  var tmp = _this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE();
  return this.qv(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
};
function HashMapSerializer(kSerializer, vSerializer) {
  MapLikeSerializer.call(this, kSerializer, vSerializer);
  this.tv_1 = new HashMapClassDesc(kSerializer.xn(), vSerializer.xn());
}
protoOf(HashMapSerializer).xn = function () {
  return this.tv_1;
};
protoOf(HashMapSerializer).uv = function (_this__u8e3s4) {
  return _this__u8e3s4.m();
};
protoOf(HashMapSerializer).vv = function (_this__u8e3s4) {
  return this.uv((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(HashMapSerializer).wv = function (_this__u8e3s4) {
  // Inline function 'kotlin.collections.iterator' call
  return _this__u8e3s4.r().j();
};
protoOf(HashMapSerializer).xv = function (_this__u8e3s4) {
  return this.wv((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(HashMapSerializer).ku = function () {
  return HashMap_init_$Create$();
};
protoOf(HashMapSerializer).yv = function (_this__u8e3s4) {
  return imul(_this__u8e3s4.m(), 2);
};
protoOf(HashMapSerializer).mu = function (_this__u8e3s4) {
  return this.yv(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE());
};
protoOf(HashMapSerializer).zv = function (_this__u8e3s4) {
  return _this__u8e3s4;
};
protoOf(HashMapSerializer).ou = function (_this__u8e3s4) {
  return this.zv(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE());
};
protoOf(HashMapSerializer).aw = function (_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : null;
  return tmp0_elvis_lhs == null ? HashMap_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
};
protoOf(HashMapSerializer).qu = function (_this__u8e3s4) {
  return this.aw((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(HashMapSerializer).bw = function (_this__u8e3s4, size) {
};
protoOf(HashMapSerializer).su = function (_this__u8e3s4, size) {
  return this.bw(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE(), size);
};
function LinkedHashMapSerializer(kSerializer, vSerializer) {
  MapLikeSerializer.call(this, kSerializer, vSerializer);
  this.iw_1 = new LinkedHashMapClassDesc(kSerializer.xn(), vSerializer.xn());
}
protoOf(LinkedHashMapSerializer).xn = function () {
  return this.iw_1;
};
protoOf(LinkedHashMapSerializer).uv = function (_this__u8e3s4) {
  return _this__u8e3s4.m();
};
protoOf(LinkedHashMapSerializer).vv = function (_this__u8e3s4) {
  return this.uv((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(LinkedHashMapSerializer).wv = function (_this__u8e3s4) {
  // Inline function 'kotlin.collections.iterator' call
  return _this__u8e3s4.r().j();
};
protoOf(LinkedHashMapSerializer).xv = function (_this__u8e3s4) {
  return this.wv((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(LinkedHashMapSerializer).ku = function () {
  return LinkedHashMap_init_$Create$();
};
protoOf(LinkedHashMapSerializer).jw = function (_this__u8e3s4) {
  return imul(_this__u8e3s4.m(), 2);
};
protoOf(LinkedHashMapSerializer).mu = function (_this__u8e3s4) {
  return this.jw(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE());
};
protoOf(LinkedHashMapSerializer).kw = function (_this__u8e3s4) {
  return _this__u8e3s4;
};
protoOf(LinkedHashMapSerializer).ou = function (_this__u8e3s4) {
  return this.kw(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE());
};
protoOf(LinkedHashMapSerializer).aw = function (_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : null;
  return tmp0_elvis_lhs == null ? LinkedHashMap_init_$Create$_1(_this__u8e3s4) : tmp0_elvis_lhs;
};
protoOf(LinkedHashMapSerializer).qu = function (_this__u8e3s4) {
  return this.aw((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(LinkedHashMapSerializer).lw = function (_this__u8e3s4, size) {
};
protoOf(LinkedHashMapSerializer).su = function (_this__u8e3s4, size) {
  return this.lw(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE(), size);
};
function ReferenceArraySerializer(kClass, eSerializer) {
  CollectionLikeSerializer.call(this, eSerializer);
  this.nw_1 = kClass;
  this.ow_1 = new ArrayClassDesc(eSerializer.xn());
}
protoOf(ReferenceArraySerializer).xn = function () {
  return this.ow_1;
};
protoOf(ReferenceArraySerializer).pw = function (_this__u8e3s4) {
  return _this__u8e3s4.length;
};
protoOf(ReferenceArraySerializer).vv = function (_this__u8e3s4) {
  return this.pw((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ReferenceArraySerializer).qw = function (_this__u8e3s4) {
  return arrayIterator(_this__u8e3s4);
};
protoOf(ReferenceArraySerializer).xv = function (_this__u8e3s4) {
  return this.qw((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ReferenceArraySerializer).ku = function () {
  // Inline function 'kotlin.collections.arrayListOf' call
  return ArrayList_init_$Create$_0();
};
protoOf(ReferenceArraySerializer).rw = function (_this__u8e3s4) {
  return _this__u8e3s4.m();
};
protoOf(ReferenceArraySerializer).mu = function (_this__u8e3s4) {
  return this.rw(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ReferenceArraySerializer).sw = function (_this__u8e3s4) {
  return toNativeArrayImpl(_this__u8e3s4, this.nw_1);
};
protoOf(ReferenceArraySerializer).ou = function (_this__u8e3s4) {
  return this.sw(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ReferenceArraySerializer).tw = function (_this__u8e3s4) {
  return ArrayList_init_$Create$_1(asList(_this__u8e3s4));
};
protoOf(ReferenceArraySerializer).qu = function (_this__u8e3s4) {
  return this.tw((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ReferenceArraySerializer).uw = function (_this__u8e3s4, size) {
  return _this__u8e3s4.k5(size);
};
protoOf(ReferenceArraySerializer).su = function (_this__u8e3s4, size) {
  return this.uw(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), size);
};
protoOf(ReferenceArraySerializer).vw = function (_this__u8e3s4, index, element) {
  _this__u8e3s4.f2(index, element);
};
protoOf(ReferenceArraySerializer).uu = function (_this__u8e3s4, index, element) {
  var tmp = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE();
  return this.vw(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
};
function CollectionSerializer(element) {
  CollectionLikeSerializer.call(this, element);
}
protoOf(CollectionSerializer).wu = function (_this__u8e3s4) {
  return _this__u8e3s4.m();
};
protoOf(CollectionSerializer).vv = function (_this__u8e3s4) {
  return this.wu((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(CollectionSerializer).xu = function (_this__u8e3s4) {
  return _this__u8e3s4.j();
};
protoOf(CollectionSerializer).xv = function (_this__u8e3s4) {
  return this.xu((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
};
function MapLikeSerializer(keySerializer, valueSerializer) {
  AbstractCollectionSerializer.call(this);
  this.cw_1 = keySerializer;
  this.dw_1 = valueSerializer;
}
protoOf(MapLikeSerializer).ew = function (decoder, builder, startIndex, size) {
  // Inline function 'kotlin.require' call
  if (!(size >= 0)) {
    var message = 'Size must be known in advance when using READ_ALL';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var progression = step(until(0, imul(size, 2)), 2);
  var inductionVariable = progression.v_1;
  var last = progression.w_1;
  var step_0 = progression.x_1;
  if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + step_0 | 0;
      this.fw(decoder, startIndex + index | 0, builder, false);
    }
     while (!(index === last));
};
protoOf(MapLikeSerializer).av = function (decoder, builder, startIndex, size) {
  return this.ew(decoder, (!(builder == null) ? isInterface(builder, KtMutableMap) : false) ? builder : THROW_CCE(), startIndex, size);
};
protoOf(MapLikeSerializer).fw = function (decoder, index, builder, checkIndex) {
  var key = decoder.xr(this.xn(), index, this.cw_1);
  var tmp;
  if (checkIndex) {
    // Inline function 'kotlin.also' call
    var this_0 = decoder.bs(this.xn());
    // Inline function 'kotlin.require' call
    if (!(this_0 === (index + 1 | 0))) {
      var message = 'Value must follow key in a map, index for key: ' + index + ', returned index for value: ' + this_0;
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    tmp = this_0;
  } else {
    tmp = index + 1 | 0;
  }
  var vIndex = tmp;
  var tmp_0;
  var tmp_1;
  if (builder.y1(key)) {
    var tmp_2 = this.dw_1.xn().op();
    tmp_1 = !(tmp_2 instanceof PrimitiveKind);
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    tmp_0 = decoder.wr(this.xn(), vIndex, this.dw_1, getValue(builder, key));
  } else {
    tmp_0 = decoder.xr(this.xn(), vIndex, this.dw_1);
  }
  var value = tmp_0;
  // Inline function 'kotlin.collections.set' call
  builder.h2(key, value);
};
protoOf(MapLikeSerializer).bv = function (decoder, index, builder, checkIndex) {
  return this.fw(decoder, index, (!(builder == null) ? isInterface(builder, KtMutableMap) : false) ? builder : THROW_CCE(), checkIndex);
};
protoOf(MapLikeSerializer).zu = function (encoder, value) {
  var size = this.vv(value);
  // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
  var descriptor = this.xn();
  var composite = encoder.gt(descriptor, size);
  var iterator = this.xv(value);
  var index = 0;
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = iterator;
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.component1' call
    var k = element.s();
    // Inline function 'kotlin.collections.component2' call
    var v = element.t();
    var tmp = this.xn();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    composite.bt(tmp, _unary__edvuaz, this.cw_1, k);
    var tmp_0 = this.xn();
    var _unary__edvuaz_0 = index;
    index = _unary__edvuaz_0 + 1 | 0;
    composite.bt(tmp_0, _unary__edvuaz_0, this.dw_1, v);
  }
  composite.lr(descriptor);
};
protoOf(MapLikeSerializer).yn = function (encoder, value) {
  return this.zu(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
};
function CollectionLikeSerializer(elementSerializer) {
  AbstractCollectionSerializer.call(this);
  this.yu_1 = elementSerializer;
}
protoOf(CollectionLikeSerializer).zu = function (encoder, value) {
  var size = this.vv(value);
  // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
  var descriptor = this.xn();
  var composite = encoder.gt(descriptor, size);
  var iterator = this.xv(value);
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      composite.bt(this.xn(), index, this.yu_1, iterator.l());
    }
     while (inductionVariable < size);
  composite.lr(descriptor);
};
protoOf(CollectionLikeSerializer).yn = function (encoder, value) {
  return this.zu(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
};
protoOf(CollectionLikeSerializer).av = function (decoder, builder, startIndex, size) {
  // Inline function 'kotlin.require' call
  if (!(size >= 0)) {
    var message = 'Size must be known in advance when using READ_ALL';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      this.bv(decoder, startIndex + index | 0, builder, false);
    }
     while (inductionVariable < size);
};
protoOf(CollectionLikeSerializer).bv = function (decoder, index, builder, checkIndex) {
  this.uu(builder, index, decoder.xr(this.xn(), index, this.yu_1));
};
function readSize($this, decoder, builder) {
  var size = decoder.cs($this.xn());
  $this.su(builder, size);
  return size;
}
function AbstractCollectionSerializer() {
}
protoOf(AbstractCollectionSerializer).dv = function (decoder, previous) {
  var tmp1_elvis_lhs = previous == null ? null : this.qu(previous);
  var builder = tmp1_elvis_lhs == null ? this.ku() : tmp1_elvis_lhs;
  var startIndex = this.mu(builder);
  var compositeDecoder = decoder.kr(this.xn());
  if (compositeDecoder.as()) {
    this.av(compositeDecoder, builder, startIndex, readSize(this, compositeDecoder, builder));
  } else {
    $l$loop: while (true) {
      var index = compositeDecoder.bs(this.xn());
      if (index === -1)
        break $l$loop;
      this.cv(compositeDecoder, startIndex + index | 0, builder);
    }
  }
  compositeDecoder.lr(this.xn());
  return this.ou(builder);
};
protoOf(AbstractCollectionSerializer).zn = function (decoder) {
  return this.dv(decoder, null);
};
protoOf(AbstractCollectionSerializer).cv = function (decoder, index, builder, checkIndex, $super) {
  checkIndex = checkIndex === VOID ? true : checkIndex;
  var tmp;
  if ($super === VOID) {
    this.bv(decoder, index, builder, checkIndex);
    tmp = Unit_instance;
  } else {
    tmp = $super.bv.call(this, decoder, index, builder, checkIndex);
  }
  return tmp;
};
function PrimitiveArraySerializer(primitiveSerializer) {
  CollectionLikeSerializer.call(this, primitiveSerializer);
  this.xw_1 = new PrimitiveArrayDescriptor(primitiveSerializer.xn());
}
protoOf(PrimitiveArraySerializer).xn = function () {
  return this.xw_1;
};
protoOf(PrimitiveArraySerializer).yw = function (_this__u8e3s4) {
  return _this__u8e3s4.zw();
};
protoOf(PrimitiveArraySerializer).mu = function (_this__u8e3s4) {
  return this.yw(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE());
};
protoOf(PrimitiveArraySerializer).ax = function (_this__u8e3s4) {
  return _this__u8e3s4.bx();
};
protoOf(PrimitiveArraySerializer).ou = function (_this__u8e3s4) {
  return this.ax(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE());
};
protoOf(PrimitiveArraySerializer).cx = function (_this__u8e3s4, size) {
  return _this__u8e3s4.dx(size);
};
protoOf(PrimitiveArraySerializer).su = function (_this__u8e3s4, size) {
  return this.cx(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE(), size);
};
protoOf(PrimitiveArraySerializer).ex = function (_this__u8e3s4) {
  var message = 'This method lead to boxing and must not be used, use writeContents instead';
  throw IllegalStateException_init_$Create$(toString(message));
};
protoOf(PrimitiveArraySerializer).xv = function (_this__u8e3s4) {
  return this.ex((_this__u8e3s4 == null ? true : !(_this__u8e3s4 == null)) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(PrimitiveArraySerializer).fx = function (_this__u8e3s4, index, element) {
  var message = 'This method lead to boxing and must not be used, use Builder.append instead';
  throw IllegalStateException_init_$Create$(toString(message));
};
protoOf(PrimitiveArraySerializer).uu = function (_this__u8e3s4, index, element) {
  var tmp = _this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE();
  return this.fx(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
};
protoOf(PrimitiveArraySerializer).ku = function () {
  return this.qu(this.gx());
};
protoOf(PrimitiveArraySerializer).jx = function (encoder, value) {
  var size = this.vv(value);
  // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
  var descriptor = this.xw_1;
  var composite = encoder.gt(descriptor, size);
  this.ix(composite, value, size);
  composite.lr(descriptor);
};
protoOf(PrimitiveArraySerializer).yn = function (encoder, value) {
  return this.jx(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
};
protoOf(PrimitiveArraySerializer).zu = function (encoder, value) {
  return this.jx(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
};
protoOf(PrimitiveArraySerializer).zn = function (decoder) {
  return this.dv(decoder, null);
};
function PrimitiveArrayBuilder() {
}
protoOf(PrimitiveArrayBuilder).kx = function (requiredCapacity, $super) {
  requiredCapacity = requiredCapacity === VOID ? this.zw() + 1 | 0 : requiredCapacity;
  var tmp;
  if ($super === VOID) {
    this.dx(requiredCapacity);
    tmp = Unit_instance;
  } else {
    tmp = $super.dx.call(this, requiredCapacity);
  }
  return tmp;
};
function Companion() {
  Companion_instance_0 = this;
  this.lx_1 = longArray(0);
}
var Companion_instance_0;
function Companion_getInstance_7() {
  if (Companion_instance_0 == null)
    new Companion();
  return Companion_instance_0;
}
function prepareHighMarksArray($this, elementsCount) {
  var slotsCount = (elementsCount - 1 | 0) >>> 6 | 0;
  var elementsInLastSlot = elementsCount & 63;
  var highMarks = longArray(slotsCount);
  if (!(elementsInLastSlot === 0)) {
    highMarks[get_lastIndex(highMarks)] = (new Long(-1, -1)).b3(elementsCount);
  }
  return highMarks;
}
function markHigh($this, index) {
  var slot = (index >>> 6 | 0) - 1 | 0;
  var offsetInSlot = index & 63;
  $this.px_1[slot] = $this.px_1[slot].f3((new Long(1, 0)).b3(offsetInSlot));
}
function nextUnmarkedHighIndex($this) {
  var inductionVariable = 0;
  var last = $this.px_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var slot = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var slotOffset = imul(slot + 1 | 0, 64);
      var slotMarks = $this.px_1[slot];
      while (!slotMarks.equals(new Long(-1, -1))) {
        var indexInSlot = countTrailingZeroBits(slotMarks.z2());
        slotMarks = slotMarks.f3((new Long(1, 0)).b3(indexInSlot));
        var index = slotOffset + indexInSlot | 0;
        if ($this.nx_1($this.mx_1, index)) {
          $this.px_1[slot] = slotMarks;
          return index;
        }
      }
      $this.px_1[slot] = slotMarks;
    }
     while (inductionVariable <= last);
  return -1;
}
function ElementMarker(descriptor, readIfAbsent) {
  Companion_getInstance_7();
  this.mx_1 = descriptor;
  this.nx_1 = readIfAbsent;
  var elementsCount = this.mx_1.qp();
  if (elementsCount <= 64) {
    var tmp = this;
    var tmp_0;
    if (elementsCount === 64) {
      tmp_0 = new Long(0, 0);
    } else {
      tmp_0 = (new Long(-1, -1)).b3(elementsCount);
    }
    tmp.ox_1 = tmp_0;
    this.px_1 = Companion_getInstance_7().lx_1;
  } else {
    this.ox_1 = new Long(0, 0);
    this.px_1 = prepareHighMarksArray(this, elementsCount);
  }
}
protoOf(ElementMarker).qx = function (index) {
  if (index < 64) {
    this.ox_1 = this.ox_1.f3((new Long(1, 0)).b3(index));
  } else {
    markHigh(this, index);
  }
};
protoOf(ElementMarker).rx = function () {
  var elementsCount = this.mx_1.qp();
  while (!this.ox_1.equals(new Long(-1, -1))) {
    var index = countTrailingZeroBits(this.ox_1.z2());
    this.ox_1 = this.ox_1.f3((new Long(1, 0)).b3(index));
    if (this.nx_1(this.mx_1, index)) {
      return index;
    }
  }
  if (elementsCount > 64) {
    return nextUnmarkedHighIndex(this);
  }
  return -1;
};
function createAnnotatedEnumSerializer(serialName, values, names, entryAnnotations, classAnnotations) {
  var descriptor = new EnumDescriptor(serialName, values.length);
  if (classAnnotations == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = classAnnotations.length;
    while (inductionVariable < last) {
      var element = classAnnotations[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      descriptor.ey(element);
    }
  }
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var inductionVariable_0 = 0;
  var last_0 = values.length;
  while (inductionVariable_0 < last_0) {
    var item = values[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var tmp0_elvis_lhs = getOrNull(names, _unary__edvuaz);
    var elementName = tmp0_elvis_lhs == null ? item.k2_1 : tmp0_elvis_lhs;
    descriptor.fy(elementName);
    var tmp1_safe_receiver = getOrNull(entryAnnotations, _unary__edvuaz);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable_1 = 0;
      var last_1 = tmp1_safe_receiver.length;
      while (inductionVariable_1 < last_1) {
        var element_0 = tmp1_safe_receiver[inductionVariable_1];
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        descriptor.gy(element_0);
      }
    }
  }
  return EnumSerializer_init_$Create$(serialName, values, descriptor);
}
function _get_elementDescriptors__y23q9p($this) {
  var tmp0 = $this.uy_1;
  // Inline function 'kotlin.getValue' call
  elementDescriptors$factory();
  return tmp0.t();
}
function EnumDescriptor$elementDescriptors$delegate$lambda($elementsCount, $name, this$0) {
  return function () {
    var tmp = 0;
    var tmp_0 = $elementsCount;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = buildSerialDescriptor($name + '.' + this$0.sp(tmp_2), OBJECT_getInstance(), []);
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  };
}
function EnumDescriptor(name, elementsCount) {
  PluginGeneratedSerialDescriptor.call(this, name, VOID, elementsCount);
  this.ty_1 = ENUM_getInstance();
  var tmp = this;
  tmp.uy_1 = lazy_0(EnumDescriptor$elementDescriptors$delegate$lambda(elementsCount, name, this));
}
protoOf(EnumDescriptor).op = function () {
  return this.ty_1;
};
protoOf(EnumDescriptor).vp = function (index) {
  return getChecked(_get_elementDescriptors__y23q9p(this), index);
};
protoOf(EnumDescriptor).equals = function (other) {
  if (this === other)
    return true;
  if (other == null)
    return false;
  if (!(!(other == null) ? isInterface(other, SerialDescriptor) : false))
    return false;
  if (!(other.op() === ENUM_getInstance()))
    return false;
  if (!(this.yo() === other.yo()))
    return false;
  if (!equals(cachedSerialNames(this), cachedSerialNames(other)))
    return false;
  return true;
};
protoOf(EnumDescriptor).toString = function () {
  return joinToString(get_elementNames(this), ', ', this.yo() + '(', ')');
};
protoOf(EnumDescriptor).hashCode = function () {
  var result = getStringHashCode(this.yo());
  // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
  // Inline function 'kotlin.collections.fold' call
  var accumulator = 1;
  var _iterator__ex2g4s = get_elementNames(this).j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var hash = accumulator;
    var tmp = imul(31, hash);
    // Inline function 'kotlin.hashCode' call
    var tmp1_elvis_lhs = element == null ? null : hashCode(element);
    accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  }
  var elementsHashCode = accumulator;
  result = imul(31, result) + elementsHashCode | 0;
  return result;
};
function EnumSerializer_init_$Init$(serialName, values, descriptor, $this) {
  EnumSerializer.call($this, serialName, values);
  $this.yy_1 = descriptor;
  return $this;
}
function EnumSerializer_init_$Create$(serialName, values, descriptor) {
  return EnumSerializer_init_$Init$(serialName, values, descriptor, objectCreate(protoOf(EnumSerializer)));
}
function createUnmarkedDescriptor($this, serialName) {
  var d = new EnumDescriptor(serialName, $this.xy_1.length);
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = $this.xy_1;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    d.fy(element.k2_1);
  }
  return d;
}
function EnumSerializer$descriptor$delegate$lambda(this$0, $serialName) {
  return function () {
    var tmp0_elvis_lhs = this$0.yy_1;
    return tmp0_elvis_lhs == null ? createUnmarkedDescriptor(this$0, $serialName) : tmp0_elvis_lhs;
  };
}
function EnumSerializer(serialName, values) {
  this.xy_1 = values;
  this.yy_1 = null;
  var tmp = this;
  tmp.zy_1 = lazy_0(EnumSerializer$descriptor$delegate$lambda(this, serialName));
}
protoOf(EnumSerializer).xn = function () {
  var tmp0 = this.zy_1;
  // Inline function 'kotlin.getValue' call
  descriptor$factory_1();
  return tmp0.t();
};
protoOf(EnumSerializer).az = function (encoder, value) {
  var index = indexOf(this.xy_1, value);
  if (index === -1) {
    throw SerializationException_init_$Create$_0(toString(value) + ' is not a valid enum ' + this.xn().yo() + ', ' + ('must be one of ' + contentToString(this.xy_1)));
  }
  encoder.ps(this.xn(), index);
};
protoOf(EnumSerializer).yn = function (encoder, value) {
  return this.az(encoder, value instanceof Enum ? value : THROW_CCE());
};
protoOf(EnumSerializer).zn = function (decoder) {
  var index = decoder.gr(this.xn());
  if (!(0 <= index ? index <= (this.xy_1.length - 1 | 0) : false)) {
    throw SerializationException_init_$Create$_0('' + index + ' is not among valid ' + this.xn().yo() + ' enum values, ' + ('values size is ' + this.xy_1.length));
  }
  return this.xy_1[index];
};
protoOf(EnumSerializer).toString = function () {
  return 'kotlinx.serialization.internal.EnumSerializer<' + this.xn().yo() + '>';
};
function createSimpleEnumSerializer(serialName, values) {
  return new EnumSerializer(serialName, values);
}
function elementDescriptors$factory() {
  return getPropertyCallableRef('elementDescriptors', 1, KProperty1, function (receiver) {
    return _get_elementDescriptors__y23q9p(receiver);
  }, null);
}
function descriptor$factory_1() {
  return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
    return receiver.xn();
  }, null);
}
function InlinePrimitiveDescriptor(name, primitiveSerializer) {
  return new InlineClassDescriptor(name, new InlinePrimitiveDescriptor$1(primitiveSerializer));
}
function InlineClassDescriptor(name, generatedSerializer) {
  PluginGeneratedSerialDescriptor.call(this, name, generatedSerializer, 1);
  this.nz_1 = true;
}
protoOf(InlineClassDescriptor).pp = function () {
  return this.nz_1;
};
protoOf(InlineClassDescriptor).hashCode = function () {
  return imul(protoOf(PluginGeneratedSerialDescriptor).hashCode.call(this), 31);
};
protoOf(InlineClassDescriptor).equals = function (other) {
  var tmp$ret$0;
  $l$block_5: {
    // Inline function 'kotlinx.serialization.internal.equalsImpl' call
    if (this === other) {
      tmp$ret$0 = true;
      break $l$block_5;
    }
    if (!(other instanceof InlineClassDescriptor)) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    if (!(this.yo() === other.yo())) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    if (!(other.nz_1 && contentEquals(this.vy(), other.vy()))) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    if (!(this.qp() === other.qp())) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    var inductionVariable = 0;
    var last = this.qp();
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(this.vp(index).yo() === other.vp(index).yo())) {
          tmp$ret$0 = false;
          break $l$block_5;
        }
        if (!equals(this.vp(index).op(), other.vp(index).op())) {
          tmp$ret$0 = false;
          break $l$block_5;
        }
      }
       while (inductionVariable < last);
    tmp$ret$0 = true;
  }
  return tmp$ret$0;
};
function InlinePrimitiveDescriptor$1($primitiveSerializer) {
  this.oz_1 = $primitiveSerializer;
}
protoOf(InlinePrimitiveDescriptor$1).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [this.oz_1];
};
protoOf(InlinePrimitiveDescriptor$1).xn = function () {
  var message = 'unsupported';
  throw IllegalStateException_init_$Create$(toString(message));
};
protoOf(InlinePrimitiveDescriptor$1).yn = function (encoder, value) {
  // Inline function 'kotlin.error' call
  var message = 'unsupported';
  throw IllegalStateException_init_$Create$(toString(message));
};
protoOf(InlinePrimitiveDescriptor$1).zn = function (decoder) {
  // Inline function 'kotlin.error' call
  var message = 'unsupported';
  throw IllegalStateException_init_$Create$(toString(message));
};
function jsonCachedSerialNames(_this__u8e3s4) {
  return cachedSerialNames(_this__u8e3s4);
}
function NoOpEncoder() {
  NoOpEncoder_instance = this;
  AbstractEncoder.call(this);
  this.rz_1 = EmptySerializersModule_0();
}
protoOf(NoOpEncoder).zr = function () {
  return this.rz_1;
};
protoOf(NoOpEncoder).es = function (value) {
  return Unit_instance;
};
protoOf(NoOpEncoder).fs = function () {
  return Unit_instance;
};
protoOf(NoOpEncoder).gs = function (value) {
  return Unit_instance;
};
protoOf(NoOpEncoder).hs = function (value) {
  return Unit_instance;
};
protoOf(NoOpEncoder).is = function (value) {
  return Unit_instance;
};
protoOf(NoOpEncoder).js = function (value) {
  return Unit_instance;
};
protoOf(NoOpEncoder).ks = function (value) {
  return Unit_instance;
};
protoOf(NoOpEncoder).ls = function (value) {
  return Unit_instance;
};
protoOf(NoOpEncoder).ms = function (value) {
  return Unit_instance;
};
protoOf(NoOpEncoder).ns = function (value) {
  return Unit_instance;
};
protoOf(NoOpEncoder).os = function (value) {
  return Unit_instance;
};
protoOf(NoOpEncoder).ps = function (enumDescriptor, index) {
  return Unit_instance;
};
var NoOpEncoder_instance;
function NoOpEncoder_getInstance() {
  if (NoOpEncoder_instance == null)
    new NoOpEncoder();
  return NoOpEncoder_instance;
}
function error($this) {
  throw IllegalStateException_init_$Create$('Descriptor for type `kotlin.Nothing` does not have elements');
}
function NothingSerialDescriptor() {
  NothingSerialDescriptor_instance = this;
  this.sz_1 = OBJECT_getInstance();
  this.tz_1 = 'kotlin.Nothing';
}
protoOf(NothingSerialDescriptor).op = function () {
  return this.sz_1;
};
protoOf(NothingSerialDescriptor).yo = function () {
  return this.tz_1;
};
protoOf(NothingSerialDescriptor).qp = function () {
  return 0;
};
protoOf(NothingSerialDescriptor).sp = function (index) {
  error(this);
};
protoOf(NothingSerialDescriptor).tp = function (name) {
  error(this);
};
protoOf(NothingSerialDescriptor).wp = function (index) {
  error(this);
};
protoOf(NothingSerialDescriptor).vp = function (index) {
  error(this);
};
protoOf(NothingSerialDescriptor).up = function (index) {
  error(this);
};
protoOf(NothingSerialDescriptor).toString = function () {
  return 'NothingSerialDescriptor';
};
protoOf(NothingSerialDescriptor).equals = function (other) {
  return this === other;
};
protoOf(NothingSerialDescriptor).hashCode = function () {
  return getStringHashCode(this.tz_1) + imul(31, this.sz_1.hashCode()) | 0;
};
var NothingSerialDescriptor_instance;
function NothingSerialDescriptor_getInstance() {
  if (NothingSerialDescriptor_instance == null)
    new NothingSerialDescriptor();
  return NothingSerialDescriptor_instance;
}
function NullableSerializer(serializer) {
  this.uz_1 = serializer;
  this.vz_1 = new SerialDescriptorForNullable(this.uz_1.xn());
}
protoOf(NullableSerializer).xn = function () {
  return this.vz_1;
};
protoOf(NullableSerializer).wz = function (encoder, value) {
  if (!(value == null)) {
    encoder.ft();
    encoder.ct(this.uz_1, value);
  } else {
    encoder.fs();
  }
};
protoOf(NullableSerializer).yn = function (encoder, value) {
  return this.wz(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
};
protoOf(NullableSerializer).zn = function (decoder) {
  return decoder.vq() ? decoder.jr(this.uz_1) : decoder.wq();
};
protoOf(NullableSerializer).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof NullableSerializer))
    THROW_CCE();
  if (!equals(this.uz_1, other.uz_1))
    return false;
  return true;
};
protoOf(NullableSerializer).hashCode = function () {
  return hashCode(this.uz_1);
};
function SerialDescriptorForNullable(original) {
  this.xp_1 = original;
  this.yp_1 = this.xp_1.yo() + '?';
  this.zp_1 = cachedSerialNames(this.xp_1);
}
protoOf(SerialDescriptorForNullable).yo = function () {
  return this.yp_1;
};
protoOf(SerialDescriptorForNullable).tq = function () {
  return this.zp_1;
};
protoOf(SerialDescriptorForNullable).kp = function () {
  return true;
};
protoOf(SerialDescriptorForNullable).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof SerialDescriptorForNullable))
    return false;
  if (!equals(this.xp_1, other.xp_1))
    return false;
  return true;
};
protoOf(SerialDescriptorForNullable).toString = function () {
  return toString(this.xp_1) + '?';
};
protoOf(SerialDescriptorForNullable).hashCode = function () {
  return imul(hashCode(this.xp_1), 31);
};
protoOf(SerialDescriptorForNullable).op = function () {
  return this.xp_1.op();
};
protoOf(SerialDescriptorForNullable).pp = function () {
  return this.xp_1.pp();
};
protoOf(SerialDescriptorForNullable).qp = function () {
  return this.xp_1.qp();
};
protoOf(SerialDescriptorForNullable).rp = function () {
  return this.xp_1.rp();
};
protoOf(SerialDescriptorForNullable).sp = function (index) {
  return this.xp_1.sp(index);
};
protoOf(SerialDescriptorForNullable).tp = function (name) {
  return this.xp_1.tp(name);
};
protoOf(SerialDescriptorForNullable).up = function (index) {
  return this.xp_1.up(index);
};
protoOf(SerialDescriptorForNullable).vp = function (index) {
  return this.xp_1.vp(index);
};
protoOf(SerialDescriptorForNullable).wp = function (index) {
  return this.xp_1.wp(index);
};
function ObjectSerializer$descriptor$delegate$lambda$lambda(this$0) {
  return function ($this$buildSerialDescriptor) {
    $this$buildSerialDescriptor.co_1 = this$0.yz_1;
    return Unit_instance;
  };
}
function ObjectSerializer$descriptor$delegate$lambda($serialName, this$0) {
  return function () {
    var tmp = OBJECT_getInstance();
    return buildSerialDescriptor($serialName, tmp, [], ObjectSerializer$descriptor$delegate$lambda$lambda(this$0));
  };
}
function ObjectSerializer(serialName, objectInstance) {
  this.xz_1 = objectInstance;
  this.yz_1 = emptyList();
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.zz_1 = lazy(tmp_0, ObjectSerializer$descriptor$delegate$lambda(serialName, this));
}
protoOf(ObjectSerializer).xn = function () {
  var tmp0 = this.zz_1;
  // Inline function 'kotlin.getValue' call
  descriptor$factory_2();
  return tmp0.t();
};
protoOf(ObjectSerializer).no = function (encoder, value) {
  encoder.kr(this.xn()).lr(this.xn());
};
protoOf(ObjectSerializer).yn = function (encoder, value) {
  return this.no(encoder, !(value == null) ? value : THROW_CCE());
};
protoOf(ObjectSerializer).zn = function (decoder) {
  // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
  var descriptor = this.xn();
  var composite = decoder.kr(descriptor);
  var tmp$ret$0;
  $l$block_0: {
    if (composite.as()) {
      tmp$ret$0 = Unit_instance;
      break $l$block_0;
    }
    var index = composite.bs(this.xn());
    if (index === -1) {
      tmp$ret$0 = Unit_instance;
      break $l$block_0;
    } else
      throw SerializationException_init_$Create$_0('Unexpected index ' + index);
  }
  var result = tmp$ret$0;
  composite.lr(descriptor);
  return this.xz_1;
};
function descriptor$factory_2() {
  return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
    return receiver.xn();
  }, null);
}
function get_EMPTY_DESCRIPTOR_ARRAY() {
  _init_properties_Platform_common_kt__3qzecs();
  return EMPTY_DESCRIPTOR_ARRAY;
}
var EMPTY_DESCRIPTOR_ARRAY;
function cachedSerialNames(_this__u8e3s4) {
  _init_properties_Platform_common_kt__3qzecs();
  if (isInterface(_this__u8e3s4, CachedNames))
    return _this__u8e3s4.tq();
  var result = HashSet_init_$Create$_1(_this__u8e3s4.qp());
  var inductionVariable = 0;
  var last = _this__u8e3s4.qp();
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.plusAssign' call
      var element = _this__u8e3s4.sp(i);
      result.e(element);
    }
     while (inductionVariable < last);
  return result;
}
function kclass(_this__u8e3s4) {
  _init_properties_Platform_common_kt__3qzecs();
  var t = _this__u8e3s4.eb();
  var tmp;
  if (!(t == null) ? isInterface(t, KClass) : false) {
    tmp = t;
  } else {
    if (!(t == null) ? isInterface(t, KTypeParameter) : false) {
      throw IllegalArgumentException_init_$Create$('Captured type parameter ' + toString(t) + ' from generic non-reified function. ' + ('Such functionality cannot be supported because ' + toString(t) + ' is erased, either specify serializer explicitly or make ') + ('calling function inline with reified ' + toString(t) + '.'));
    } else {
      throw IllegalArgumentException_init_$Create$('Only KClass supported as classifier, got ' + toString_0(t));
    }
  }
  var tmp_0 = tmp;
  return isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE();
}
function typeOrThrow(_this__u8e3s4) {
  _init_properties_Platform_common_kt__3qzecs();
  var tmp0 = _this__u8e3s4.kj_1;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.requireNotNull' call
    if (tmp0 == null) {
      var message = 'Star projections in type arguments are not allowed, but had ' + toString_0(_this__u8e3s4.kj_1);
      throw IllegalArgumentException_init_$Create$(toString(message));
    } else {
      tmp$ret$1 = tmp0;
      break $l$block;
    }
  }
  return tmp$ret$1;
}
function notRegisteredMessage(_this__u8e3s4) {
  _init_properties_Platform_common_kt__3qzecs();
  var tmp0_elvis_lhs = _this__u8e3s4.pa();
  return notRegisteredMessage_0(tmp0_elvis_lhs == null ? '<local class name not available>' : tmp0_elvis_lhs);
}
function compactArray(_this__u8e3s4) {
  _init_properties_Platform_common_kt__3qzecs();
  // Inline function 'kotlin.takeUnless' call
  var tmp;
  // Inline function 'kotlin.collections.isNullOrEmpty' call
  if (!(_this__u8e3s4 == null || _this__u8e3s4.p())) {
    tmp = _this__u8e3s4;
  } else {
    tmp = null;
  }
  var tmp0_safe_receiver = tmp;
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_0 = copyToArray(tmp0_safe_receiver);
  }
  var tmp1_elvis_lhs = tmp_0;
  return tmp1_elvis_lhs == null ? get_EMPTY_DESCRIPTOR_ARRAY() : tmp1_elvis_lhs;
}
function notRegisteredMessage_0(className) {
  _init_properties_Platform_common_kt__3qzecs();
  return "Serializer for class '" + className + "' is not found.\n" + "Please ensure that class is marked as '@Serializable' and that the serialization compiler plugin is applied.\n";
}
function serializerNotRegistered(_this__u8e3s4) {
  _init_properties_Platform_common_kt__3qzecs();
  throw SerializationException_init_$Create$_0(notRegisteredMessage(_this__u8e3s4));
}
var properties_initialized_Platform_common_kt_i7q4ty;
function _init_properties_Platform_common_kt__3qzecs() {
  if (!properties_initialized_Platform_common_kt_i7q4ty) {
    properties_initialized_Platform_common_kt_i7q4ty = true;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    EMPTY_DESCRIPTOR_ARRAY = [];
  }
}
function throwMissingFieldException(seen, goldenMask, descriptor) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var missingFields = ArrayList_init_$Create$_0();
  var missingFieldsBits = goldenMask & ~seen;
  var inductionVariable = 0;
  if (inductionVariable < 32)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!((missingFieldsBits & 1) === 0)) {
        // Inline function 'kotlin.collections.plusAssign' call
        var element = descriptor.sp(i);
        missingFields.e(element);
      }
      missingFieldsBits = missingFieldsBits >>> 1 | 0;
    }
     while (inductionVariable < 32);
  throw MissingFieldException_init_$Create$(missingFields, descriptor.yo());
}
function hashCodeImpl(_this__u8e3s4, typeParams) {
  var result = getStringHashCode(_this__u8e3s4.yo());
  result = imul(31, result) + contentHashCode(typeParams) | 0;
  var elementDescriptors = get_elementDescriptors(_this__u8e3s4);
  // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
  // Inline function 'kotlin.collections.fold' call
  var accumulator = 1;
  var _iterator__ex2g4s = elementDescriptors.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var hash = accumulator;
    var tmp = imul(31, hash);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = element.yo();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  }
  var namesHash = accumulator;
  // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
  // Inline function 'kotlin.collections.fold' call
  var accumulator_0 = 1;
  var _iterator__ex2g4s_0 = elementDescriptors.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var hash_0 = accumulator_0;
    var tmp_0 = imul(31, hash_0);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_0 = element_0.op();
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
    accumulator_0 = tmp_0 + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
  }
  var kindHash = accumulator_0;
  result = imul(31, result) + namesHash | 0;
  result = imul(31, result) + kindHash | 0;
  return result;
}
function toStringImpl(_this__u8e3s4) {
  var tmp = until(0, _this__u8e3s4.qp());
  var tmp_0 = _this__u8e3s4.yo() + '(';
  return joinToString(tmp, ', ', tmp_0, ')', VOID, VOID, toStringImpl$lambda(_this__u8e3s4));
}
function _get_childSerializers__7vnyfa($this) {
  var tmp0 = $this.by_1;
  // Inline function 'kotlin.getValue' call
  childSerializers$factory();
  return tmp0.t();
}
function _get__hashCode__tgwhef_0($this) {
  var tmp0 = $this.dy_1;
  // Inline function 'kotlin.getValue' call
  _hashCode$factory_0();
  return tmp0.t();
}
function buildIndices($this) {
  var indices = HashMap_init_$Create$();
  var inductionVariable = 0;
  var last = $this.wx_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.set' call
      var key = $this.wx_1[i];
      indices.h2(key, i);
    }
     while (inductionVariable <= last);
  return indices;
}
function PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this$0) {
  return function () {
    var tmp0_safe_receiver = this$0.tx_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.pz();
    return tmp1_elvis_lhs == null ? get_EMPTY_SERIALIZER_ARRAY() : tmp1_elvis_lhs;
  };
}
function PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this$0) {
  return function () {
    var tmp0_safe_receiver = this$0.tx_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.qz();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(tmp1_safe_receiver.length);
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var item = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$0 = item.xn();
        destination.e(tmp$ret$0);
      }
      tmp = destination;
    }
    return compactArray(tmp);
  };
}
function PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this$0) {
  return function () {
    return hashCodeImpl(this$0, this$0.vy());
  };
}
function PluginGeneratedSerialDescriptor(serialName, generatedSerializer, elementsCount) {
  generatedSerializer = generatedSerializer === VOID ? null : generatedSerializer;
  this.sx_1 = serialName;
  this.tx_1 = generatedSerializer;
  this.ux_1 = elementsCount;
  this.vx_1 = -1;
  var tmp = this;
  var tmp_0 = 0;
  var tmp_1 = this.ux_1;
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_2 = Array(tmp_1);
  while (tmp_0 < tmp_1) {
    tmp_2[tmp_0] = '[UNINITIALIZED]';
    tmp_0 = tmp_0 + 1 | 0;
  }
  tmp.wx_1 = tmp_2;
  var tmp_3 = this;
  // Inline function 'kotlin.arrayOfNulls' call
  var size = this.ux_1;
  tmp_3.xx_1 = Array(size);
  this.yx_1 = null;
  this.zx_1 = booleanArray(this.ux_1);
  this.ay_1 = emptyMap();
  var tmp_4 = this;
  var tmp_5 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp_4.by_1 = lazy(tmp_5, PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this));
  var tmp_6 = this;
  var tmp_7 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp_6.cy_1 = lazy(tmp_7, PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this));
  var tmp_8 = this;
  var tmp_9 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp_8.dy_1 = lazy(tmp_9, PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this));
}
protoOf(PluginGeneratedSerialDescriptor).yo = function () {
  return this.sx_1;
};
protoOf(PluginGeneratedSerialDescriptor).qp = function () {
  return this.ux_1;
};
protoOf(PluginGeneratedSerialDescriptor).op = function () {
  return CLASS_getInstance();
};
protoOf(PluginGeneratedSerialDescriptor).rp = function () {
  var tmp0_elvis_lhs = this.yx_1;
  return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
};
protoOf(PluginGeneratedSerialDescriptor).tq = function () {
  return this.ay_1.b2();
};
protoOf(PluginGeneratedSerialDescriptor).vy = function () {
  var tmp0 = this.cy_1;
  // Inline function 'kotlin.getValue' call
  typeParameterDescriptors$factory();
  return tmp0.t();
};
protoOf(PluginGeneratedSerialDescriptor).wy = function (name, isOptional) {
  this.vx_1 = this.vx_1 + 1 | 0;
  this.wx_1[this.vx_1] = name;
  this.zx_1[this.vx_1] = isOptional;
  this.xx_1[this.vx_1] = null;
  if (this.vx_1 === (this.ux_1 - 1 | 0)) {
    this.ay_1 = buildIndices(this);
  }
};
protoOf(PluginGeneratedSerialDescriptor).fy = function (name, isOptional, $super) {
  isOptional = isOptional === VOID ? false : isOptional;
  var tmp;
  if ($super === VOID) {
    this.wy(name, isOptional);
    tmp = Unit_instance;
  } else {
    tmp = $super.wy.call(this, name, isOptional);
  }
  return tmp;
};
protoOf(PluginGeneratedSerialDescriptor).gy = function (annotation) {
  // Inline function 'kotlin.let' call
  var it = this.xx_1[this.vx_1];
  var tmp;
  if (it == null) {
    var result = ArrayList_init_$Create$(1);
    this.xx_1[this.vx_1] = result;
    tmp = result;
  } else {
    tmp = it;
  }
  var list = tmp;
  list.e(annotation);
};
protoOf(PluginGeneratedSerialDescriptor).ey = function (a) {
  if (this.yx_1 == null) {
    this.yx_1 = ArrayList_init_$Create$(1);
  }
  ensureNotNull(this.yx_1).e(a);
};
protoOf(PluginGeneratedSerialDescriptor).vp = function (index) {
  return getChecked(_get_childSerializers__7vnyfa(this), index).xn();
};
protoOf(PluginGeneratedSerialDescriptor).wp = function (index) {
  return getChecked_0(this.zx_1, index);
};
protoOf(PluginGeneratedSerialDescriptor).up = function (index) {
  var tmp0_elvis_lhs = getChecked(this.xx_1, index);
  return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
};
protoOf(PluginGeneratedSerialDescriptor).sp = function (index) {
  return getChecked(this.wx_1, index);
};
protoOf(PluginGeneratedSerialDescriptor).tp = function (name) {
  var tmp0_elvis_lhs = this.ay_1.a2(name);
  return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
};
protoOf(PluginGeneratedSerialDescriptor).equals = function (other) {
  var tmp$ret$0;
  $l$block_5: {
    // Inline function 'kotlinx.serialization.internal.equalsImpl' call
    if (this === other) {
      tmp$ret$0 = true;
      break $l$block_5;
    }
    if (!(other instanceof PluginGeneratedSerialDescriptor)) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    if (!(this.yo() === other.yo())) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    if (!contentEquals(this.vy(), other.vy())) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    if (!(this.qp() === other.qp())) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    var inductionVariable = 0;
    var last = this.qp();
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(this.vp(index).yo() === other.vp(index).yo())) {
          tmp$ret$0 = false;
          break $l$block_5;
        }
        if (!equals(this.vp(index).op(), other.vp(index).op())) {
          tmp$ret$0 = false;
          break $l$block_5;
        }
      }
       while (inductionVariable < last);
    tmp$ret$0 = true;
  }
  return tmp$ret$0;
};
protoOf(PluginGeneratedSerialDescriptor).hashCode = function () {
  return _get__hashCode__tgwhef_0(this);
};
protoOf(PluginGeneratedSerialDescriptor).toString = function () {
  return toStringImpl(this);
};
function toStringImpl$lambda($this_toStringImpl) {
  return function (i) {
    return $this_toStringImpl.sp(i) + ': ' + $this_toStringImpl.vp(i).yo();
  };
}
function childSerializers$factory() {
  return getPropertyCallableRef('childSerializers', 1, KProperty1, function (receiver) {
    return _get_childSerializers__7vnyfa(receiver);
  }, null);
}
function typeParameterDescriptors$factory() {
  return getPropertyCallableRef('typeParameterDescriptors', 1, KProperty1, function (receiver) {
    return receiver.vy();
  }, null);
}
function _hashCode$factory_0() {
  return getPropertyCallableRef('_hashCode', 1, KProperty1, function (receiver) {
    return _get__hashCode__tgwhef_0(receiver);
  }, null);
}
function get_EMPTY_SERIALIZER_ARRAY() {
  _init_properties_PluginHelperInterfaces_kt__xgvzfp();
  return EMPTY_SERIALIZER_ARRAY;
}
var EMPTY_SERIALIZER_ARRAY;
function SerializerFactory() {
}
function GeneratedSerializer() {
}
var properties_initialized_PluginHelperInterfaces_kt_ap8in1;
function _init_properties_PluginHelperInterfaces_kt__xgvzfp() {
  if (!properties_initialized_PluginHelperInterfaces_kt_ap8in1) {
    properties_initialized_PluginHelperInterfaces_kt_ap8in1 = true;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    EMPTY_SERIALIZER_ARRAY = [];
  }
}
function CharArraySerializer_0() {
  CharArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_3(Companion_getInstance_1()));
}
protoOf(CharArraySerializer_0).d10 = function (_this__u8e3s4) {
  return _this__u8e3s4.length;
};
protoOf(CharArraySerializer_0).vv = function (_this__u8e3s4) {
  return this.d10((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(CharArraySerializer_0).e10 = function (_this__u8e3s4) {
  return new CharArrayBuilder(_this__u8e3s4);
};
protoOf(CharArraySerializer_0).qu = function (_this__u8e3s4) {
  return this.e10((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(CharArraySerializer_0).gx = function () {
  return charArray(0);
};
protoOf(CharArraySerializer_0).f10 = function (decoder, index, builder, checkIndex) {
  builder.i10(decoder.tr(this.xw_1, index));
};
protoOf(CharArraySerializer_0).bv = function (decoder, index, builder, checkIndex) {
  return this.f10(decoder, index, builder instanceof CharArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(CharArraySerializer_0).hx = function (decoder, index, builder, checkIndex) {
  return this.f10(decoder, index, builder instanceof CharArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(CharArraySerializer_0).j10 = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      encoder.ys(this.xw_1, i, content[i]);
    }
     while (inductionVariable < size);
};
protoOf(CharArraySerializer_0).ix = function (encoder, content, size) {
  return this.j10(encoder, (!(content == null) ? isCharArray(content) : false) ? content : THROW_CCE(), size);
};
var CharArraySerializer_instance;
function CharArraySerializer_getInstance() {
  if (CharArraySerializer_instance == null)
    new CharArraySerializer_0();
  return CharArraySerializer_instance;
}
function DoubleArraySerializer_0() {
  DoubleArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_4(DoubleCompanionObject_instance));
}
protoOf(DoubleArraySerializer_0).m10 = function (_this__u8e3s4) {
  return _this__u8e3s4.length;
};
protoOf(DoubleArraySerializer_0).vv = function (_this__u8e3s4) {
  return this.m10((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(DoubleArraySerializer_0).n10 = function (_this__u8e3s4) {
  return new DoubleArrayBuilder(_this__u8e3s4);
};
protoOf(DoubleArraySerializer_0).qu = function (_this__u8e3s4) {
  return this.n10((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(DoubleArraySerializer_0).gx = function () {
  return new Float64Array(0);
};
protoOf(DoubleArraySerializer_0).o10 = function (decoder, index, builder, checkIndex) {
  builder.r10(decoder.sr(this.xw_1, index));
};
protoOf(DoubleArraySerializer_0).bv = function (decoder, index, builder, checkIndex) {
  return this.o10(decoder, index, builder instanceof DoubleArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(DoubleArraySerializer_0).hx = function (decoder, index, builder, checkIndex) {
  return this.o10(decoder, index, builder instanceof DoubleArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(DoubleArraySerializer_0).s10 = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      encoder.xs(this.xw_1, i, content[i]);
    }
     while (inductionVariable < size);
};
protoOf(DoubleArraySerializer_0).ix = function (encoder, content, size) {
  return this.s10(encoder, (!(content == null) ? isDoubleArray(content) : false) ? content : THROW_CCE(), size);
};
var DoubleArraySerializer_instance;
function DoubleArraySerializer_getInstance() {
  if (DoubleArraySerializer_instance == null)
    new DoubleArraySerializer_0();
  return DoubleArraySerializer_instance;
}
function FloatArraySerializer_0() {
  FloatArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_5(FloatCompanionObject_instance));
}
protoOf(FloatArraySerializer_0).v10 = function (_this__u8e3s4) {
  return _this__u8e3s4.length;
};
protoOf(FloatArraySerializer_0).vv = function (_this__u8e3s4) {
  return this.v10((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(FloatArraySerializer_0).w10 = function (_this__u8e3s4) {
  return new FloatArrayBuilder(_this__u8e3s4);
};
protoOf(FloatArraySerializer_0).qu = function (_this__u8e3s4) {
  return this.w10((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(FloatArraySerializer_0).gx = function () {
  return new Float32Array(0);
};
protoOf(FloatArraySerializer_0).x10 = function (decoder, index, builder, checkIndex) {
  builder.a11(decoder.rr(this.xw_1, index));
};
protoOf(FloatArraySerializer_0).bv = function (decoder, index, builder, checkIndex) {
  return this.x10(decoder, index, builder instanceof FloatArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(FloatArraySerializer_0).hx = function (decoder, index, builder, checkIndex) {
  return this.x10(decoder, index, builder instanceof FloatArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(FloatArraySerializer_0).b11 = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      encoder.ws(this.xw_1, i, content[i]);
    }
     while (inductionVariable < size);
};
protoOf(FloatArraySerializer_0).ix = function (encoder, content, size) {
  return this.b11(encoder, (!(content == null) ? isFloatArray(content) : false) ? content : THROW_CCE(), size);
};
var FloatArraySerializer_instance;
function FloatArraySerializer_getInstance() {
  if (FloatArraySerializer_instance == null)
    new FloatArraySerializer_0();
  return FloatArraySerializer_instance;
}
function LongArraySerializer_0() {
  LongArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_6(Companion_getInstance_2()));
}
protoOf(LongArraySerializer_0).e11 = function (_this__u8e3s4) {
  return _this__u8e3s4.length;
};
protoOf(LongArraySerializer_0).vv = function (_this__u8e3s4) {
  return this.e11((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(LongArraySerializer_0).f11 = function (_this__u8e3s4) {
  return new LongArrayBuilder(_this__u8e3s4);
};
protoOf(LongArraySerializer_0).qu = function (_this__u8e3s4) {
  return this.f11((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(LongArraySerializer_0).gx = function () {
  return longArray(0);
};
protoOf(LongArraySerializer_0).g11 = function (decoder, index, builder, checkIndex) {
  builder.j11(decoder.qr(this.xw_1, index));
};
protoOf(LongArraySerializer_0).bv = function (decoder, index, builder, checkIndex) {
  return this.g11(decoder, index, builder instanceof LongArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(LongArraySerializer_0).hx = function (decoder, index, builder, checkIndex) {
  return this.g11(decoder, index, builder instanceof LongArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(LongArraySerializer_0).k11 = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      encoder.vs(this.xw_1, i, content[i]);
    }
     while (inductionVariable < size);
};
protoOf(LongArraySerializer_0).ix = function (encoder, content, size) {
  return this.k11(encoder, (!(content == null) ? isLongArray(content) : false) ? content : THROW_CCE(), size);
};
var LongArraySerializer_instance;
function LongArraySerializer_getInstance() {
  if (LongArraySerializer_instance == null)
    new LongArraySerializer_0();
  return LongArraySerializer_instance;
}
function ULongArraySerializer_0() {
  ULongArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_7(Companion_getInstance_3()));
}
protoOf(ULongArraySerializer_0).n11 = function (_this__u8e3s4) {
  return _ULongArray___get_size__impl__ju6dtr(_this__u8e3s4);
};
protoOf(ULongArraySerializer_0).vv = function (_this__u8e3s4) {
  return this.n11(_this__u8e3s4 instanceof ULongArray ? _this__u8e3s4.kn_1 : THROW_CCE());
};
protoOf(ULongArraySerializer_0).o11 = function (_this__u8e3s4) {
  return new ULongArrayBuilder(_this__u8e3s4);
};
protoOf(ULongArraySerializer_0).qu = function (_this__u8e3s4) {
  return this.o11(_this__u8e3s4 instanceof ULongArray ? _this__u8e3s4.kn_1 : THROW_CCE());
};
protoOf(ULongArraySerializer_0).p11 = function () {
  return _ULongArray___init__impl__twm1l3(0);
};
protoOf(ULongArraySerializer_0).gx = function () {
  return new ULongArray(this.p11());
};
protoOf(ULongArraySerializer_0).q11 = function (decoder, index, builder, checkIndex) {
  // Inline function 'kotlin.toULong' call
  var this_0 = decoder.vr(this.xw_1, index).br();
  var tmp$ret$0 = _ULong___init__impl__c78o9k(this_0);
  builder.t11(tmp$ret$0);
};
protoOf(ULongArraySerializer_0).bv = function (decoder, index, builder, checkIndex) {
  return this.q11(decoder, index, builder instanceof ULongArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(ULongArraySerializer_0).hx = function (decoder, index, builder, checkIndex) {
  return this.q11(decoder, index, builder instanceof ULongArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(ULongArraySerializer_0).u11 = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = encoder.at(this.xw_1, i);
      // Inline function 'kotlin.ULong.toLong' call
      var this_0 = ULongArray__get_impl_pr71q9(content, i);
      var tmp$ret$0 = _ULong___get_data__impl__fggpzb(this_0);
      tmp.ks(tmp$ret$0);
    }
     while (inductionVariable < size);
};
protoOf(ULongArraySerializer_0).ix = function (encoder, content, size) {
  return this.u11(encoder, content instanceof ULongArray ? content.kn_1 : THROW_CCE(), size);
};
var ULongArraySerializer_instance;
function ULongArraySerializer_getInstance() {
  if (ULongArraySerializer_instance == null)
    new ULongArraySerializer_0();
  return ULongArraySerializer_instance;
}
function IntArraySerializer_0() {
  IntArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_8(IntCompanionObject_instance));
}
protoOf(IntArraySerializer_0).x11 = function (_this__u8e3s4) {
  return _this__u8e3s4.length;
};
protoOf(IntArraySerializer_0).vv = function (_this__u8e3s4) {
  return this.x11((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(IntArraySerializer_0).y11 = function (_this__u8e3s4) {
  return new IntArrayBuilder(_this__u8e3s4);
};
protoOf(IntArraySerializer_0).qu = function (_this__u8e3s4) {
  return this.y11((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(IntArraySerializer_0).gx = function () {
  return new Int32Array(0);
};
protoOf(IntArraySerializer_0).z11 = function (decoder, index, builder, checkIndex) {
  builder.c12(decoder.pr(this.xw_1, index));
};
protoOf(IntArraySerializer_0).bv = function (decoder, index, builder, checkIndex) {
  return this.z11(decoder, index, builder instanceof IntArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(IntArraySerializer_0).hx = function (decoder, index, builder, checkIndex) {
  return this.z11(decoder, index, builder instanceof IntArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(IntArraySerializer_0).d12 = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      encoder.us(this.xw_1, i, content[i]);
    }
     while (inductionVariable < size);
};
protoOf(IntArraySerializer_0).ix = function (encoder, content, size) {
  return this.d12(encoder, (!(content == null) ? isIntArray(content) : false) ? content : THROW_CCE(), size);
};
var IntArraySerializer_instance;
function IntArraySerializer_getInstance() {
  if (IntArraySerializer_instance == null)
    new IntArraySerializer_0();
  return IntArraySerializer_instance;
}
function UIntArraySerializer_0() {
  UIntArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_9(Companion_getInstance_4()));
}
protoOf(UIntArraySerializer_0).g12 = function (_this__u8e3s4) {
  return _UIntArray___get_size__impl__r6l8ci(_this__u8e3s4);
};
protoOf(UIntArraySerializer_0).vv = function (_this__u8e3s4) {
  return this.g12(_this__u8e3s4 instanceof UIntArray ? _this__u8e3s4.zm_1 : THROW_CCE());
};
protoOf(UIntArraySerializer_0).h12 = function (_this__u8e3s4) {
  return new UIntArrayBuilder(_this__u8e3s4);
};
protoOf(UIntArraySerializer_0).qu = function (_this__u8e3s4) {
  return this.h12(_this__u8e3s4 instanceof UIntArray ? _this__u8e3s4.zm_1 : THROW_CCE());
};
protoOf(UIntArraySerializer_0).i12 = function () {
  return _UIntArray___init__impl__ghjpc6(0);
};
protoOf(UIntArraySerializer_0).gx = function () {
  return new UIntArray(this.i12());
};
protoOf(UIntArraySerializer_0).j12 = function (decoder, index, builder, checkIndex) {
  // Inline function 'kotlin.toUInt' call
  var this_0 = decoder.vr(this.xw_1, index).ar();
  var tmp$ret$0 = _UInt___init__impl__l7qpdl(this_0);
  builder.m12(tmp$ret$0);
};
protoOf(UIntArraySerializer_0).bv = function (decoder, index, builder, checkIndex) {
  return this.j12(decoder, index, builder instanceof UIntArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(UIntArraySerializer_0).hx = function (decoder, index, builder, checkIndex) {
  return this.j12(decoder, index, builder instanceof UIntArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(UIntArraySerializer_0).n12 = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = encoder.at(this.xw_1, i);
      // Inline function 'kotlin.UInt.toInt' call
      var this_0 = UIntArray__get_impl_gp5kza(content, i);
      var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(this_0);
      tmp.js(tmp$ret$0);
    }
     while (inductionVariable < size);
};
protoOf(UIntArraySerializer_0).ix = function (encoder, content, size) {
  return this.n12(encoder, content instanceof UIntArray ? content.zm_1 : THROW_CCE(), size);
};
var UIntArraySerializer_instance;
function UIntArraySerializer_getInstance() {
  if (UIntArraySerializer_instance == null)
    new UIntArraySerializer_0();
  return UIntArraySerializer_instance;
}
function ShortArraySerializer_0() {
  ShortArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_10(ShortCompanionObject_instance));
}
protoOf(ShortArraySerializer_0).q12 = function (_this__u8e3s4) {
  return _this__u8e3s4.length;
};
protoOf(ShortArraySerializer_0).vv = function (_this__u8e3s4) {
  return this.q12((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ShortArraySerializer_0).r12 = function (_this__u8e3s4) {
  return new ShortArrayBuilder(_this__u8e3s4);
};
protoOf(ShortArraySerializer_0).qu = function (_this__u8e3s4) {
  return this.r12((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ShortArraySerializer_0).gx = function () {
  return new Int16Array(0);
};
protoOf(ShortArraySerializer_0).s12 = function (decoder, index, builder, checkIndex) {
  builder.v12(decoder.or(this.xw_1, index));
};
protoOf(ShortArraySerializer_0).bv = function (decoder, index, builder, checkIndex) {
  return this.s12(decoder, index, builder instanceof ShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(ShortArraySerializer_0).hx = function (decoder, index, builder, checkIndex) {
  return this.s12(decoder, index, builder instanceof ShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(ShortArraySerializer_0).w12 = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      encoder.ts(this.xw_1, i, content[i]);
    }
     while (inductionVariable < size);
};
protoOf(ShortArraySerializer_0).ix = function (encoder, content, size) {
  return this.w12(encoder, (!(content == null) ? isShortArray(content) : false) ? content : THROW_CCE(), size);
};
var ShortArraySerializer_instance;
function ShortArraySerializer_getInstance() {
  if (ShortArraySerializer_instance == null)
    new ShortArraySerializer_0();
  return ShortArraySerializer_instance;
}
function UShortArraySerializer_0() {
  UShortArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_11(Companion_getInstance_5()));
}
protoOf(UShortArraySerializer_0).z12 = function (_this__u8e3s4) {
  return _UShortArray___get_size__impl__jqto1b(_this__u8e3s4);
};
protoOf(UShortArraySerializer_0).vv = function (_this__u8e3s4) {
  return this.z12(_this__u8e3s4 instanceof UShortArray ? _this__u8e3s4.vn_1 : THROW_CCE());
};
protoOf(UShortArraySerializer_0).a13 = function (_this__u8e3s4) {
  return new UShortArrayBuilder(_this__u8e3s4);
};
protoOf(UShortArraySerializer_0).qu = function (_this__u8e3s4) {
  return this.a13(_this__u8e3s4 instanceof UShortArray ? _this__u8e3s4.vn_1 : THROW_CCE());
};
protoOf(UShortArraySerializer_0).b13 = function () {
  return _UShortArray___init__impl__9b26ef(0);
};
protoOf(UShortArraySerializer_0).gx = function () {
  return new UShortArray(this.b13());
};
protoOf(UShortArraySerializer_0).c13 = function (decoder, index, builder, checkIndex) {
  // Inline function 'kotlin.toUShort' call
  var this_0 = decoder.vr(this.xw_1, index).zq();
  var tmp$ret$0 = _UShort___init__impl__jigrne(this_0);
  builder.f13(tmp$ret$0);
};
protoOf(UShortArraySerializer_0).bv = function (decoder, index, builder, checkIndex) {
  return this.c13(decoder, index, builder instanceof UShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(UShortArraySerializer_0).hx = function (decoder, index, builder, checkIndex) {
  return this.c13(decoder, index, builder instanceof UShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(UShortArraySerializer_0).g13 = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = encoder.at(this.xw_1, i);
      // Inline function 'kotlin.UShort.toShort' call
      var this_0 = UShortArray__get_impl_fnbhmx(content, i);
      var tmp$ret$0 = _UShort___get_data__impl__g0245(this_0);
      tmp.is(tmp$ret$0);
    }
     while (inductionVariable < size);
};
protoOf(UShortArraySerializer_0).ix = function (encoder, content, size) {
  return this.g13(encoder, content instanceof UShortArray ? content.vn_1 : THROW_CCE(), size);
};
var UShortArraySerializer_instance;
function UShortArraySerializer_getInstance() {
  if (UShortArraySerializer_instance == null)
    new UShortArraySerializer_0();
  return UShortArraySerializer_instance;
}
function ByteArraySerializer_0() {
  ByteArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_12(ByteCompanionObject_instance));
}
protoOf(ByteArraySerializer_0).j13 = function (_this__u8e3s4) {
  return _this__u8e3s4.length;
};
protoOf(ByteArraySerializer_0).vv = function (_this__u8e3s4) {
  return this.j13((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ByteArraySerializer_0).k13 = function (_this__u8e3s4) {
  return new ByteArrayBuilder(_this__u8e3s4);
};
protoOf(ByteArraySerializer_0).qu = function (_this__u8e3s4) {
  return this.k13((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ByteArraySerializer_0).gx = function () {
  return new Int8Array(0);
};
protoOf(ByteArraySerializer_0).l13 = function (decoder, index, builder, checkIndex) {
  builder.o13(decoder.nr(this.xw_1, index));
};
protoOf(ByteArraySerializer_0).bv = function (decoder, index, builder, checkIndex) {
  return this.l13(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(ByteArraySerializer_0).hx = function (decoder, index, builder, checkIndex) {
  return this.l13(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(ByteArraySerializer_0).p13 = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      encoder.ss(this.xw_1, i, content[i]);
    }
     while (inductionVariable < size);
};
protoOf(ByteArraySerializer_0).ix = function (encoder, content, size) {
  return this.p13(encoder, (!(content == null) ? isByteArray(content) : false) ? content : THROW_CCE(), size);
};
var ByteArraySerializer_instance;
function ByteArraySerializer_getInstance() {
  if (ByteArraySerializer_instance == null)
    new ByteArraySerializer_0();
  return ByteArraySerializer_instance;
}
function UByteArraySerializer_0() {
  UByteArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_13(Companion_getInstance_6()));
}
protoOf(UByteArraySerializer_0).s13 = function (_this__u8e3s4) {
  return _UByteArray___get_size__impl__h6pkdv(_this__u8e3s4);
};
protoOf(UByteArraySerializer_0).vv = function (_this__u8e3s4) {
  return this.s13(_this__u8e3s4 instanceof UByteArray ? _this__u8e3s4.om_1 : THROW_CCE());
};
protoOf(UByteArraySerializer_0).t13 = function (_this__u8e3s4) {
  return new UByteArrayBuilder(_this__u8e3s4);
};
protoOf(UByteArraySerializer_0).qu = function (_this__u8e3s4) {
  return this.t13(_this__u8e3s4 instanceof UByteArray ? _this__u8e3s4.om_1 : THROW_CCE());
};
protoOf(UByteArraySerializer_0).u13 = function () {
  return _UByteArray___init__impl__ip4y9n(0);
};
protoOf(UByteArraySerializer_0).gx = function () {
  return new UByteArray(this.u13());
};
protoOf(UByteArraySerializer_0).v13 = function (decoder, index, builder, checkIndex) {
  // Inline function 'kotlin.toUByte' call
  var this_0 = decoder.vr(this.xw_1, index).yq();
  var tmp$ret$0 = _UByte___init__impl__g9hnc4(this_0);
  builder.y13(tmp$ret$0);
};
protoOf(UByteArraySerializer_0).bv = function (decoder, index, builder, checkIndex) {
  return this.v13(decoder, index, builder instanceof UByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(UByteArraySerializer_0).hx = function (decoder, index, builder, checkIndex) {
  return this.v13(decoder, index, builder instanceof UByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(UByteArraySerializer_0).z13 = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = encoder.at(this.xw_1, i);
      // Inline function 'kotlin.UByte.toByte' call
      var this_0 = UByteArray__get_impl_t5f3hv(content, i);
      var tmp$ret$0 = _UByte___get_data__impl__jof9qr(this_0);
      tmp.hs(tmp$ret$0);
    }
     while (inductionVariable < size);
};
protoOf(UByteArraySerializer_0).ix = function (encoder, content, size) {
  return this.z13(encoder, content instanceof UByteArray ? content.om_1 : THROW_CCE(), size);
};
var UByteArraySerializer_instance;
function UByteArraySerializer_getInstance() {
  if (UByteArraySerializer_instance == null)
    new UByteArraySerializer_0();
  return UByteArraySerializer_instance;
}
function BooleanArraySerializer_0() {
  BooleanArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_14(BooleanCompanionObject_instance));
}
protoOf(BooleanArraySerializer_0).c14 = function (_this__u8e3s4) {
  return _this__u8e3s4.length;
};
protoOf(BooleanArraySerializer_0).vv = function (_this__u8e3s4) {
  return this.c14((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(BooleanArraySerializer_0).d14 = function (_this__u8e3s4) {
  return new BooleanArrayBuilder(_this__u8e3s4);
};
protoOf(BooleanArraySerializer_0).qu = function (_this__u8e3s4) {
  return this.d14((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(BooleanArraySerializer_0).gx = function () {
  return booleanArray(0);
};
protoOf(BooleanArraySerializer_0).e14 = function (decoder, index, builder, checkIndex) {
  builder.h14(decoder.mr(this.xw_1, index));
};
protoOf(BooleanArraySerializer_0).bv = function (decoder, index, builder, checkIndex) {
  return this.e14(decoder, index, builder instanceof BooleanArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(BooleanArraySerializer_0).hx = function (decoder, index, builder, checkIndex) {
  return this.e14(decoder, index, builder instanceof BooleanArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(BooleanArraySerializer_0).i14 = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      encoder.rs(this.xw_1, i, content[i]);
    }
     while (inductionVariable < size);
};
protoOf(BooleanArraySerializer_0).ix = function (encoder, content, size) {
  return this.i14(encoder, (!(content == null) ? isBooleanArray(content) : false) ? content : THROW_CCE(), size);
};
var BooleanArraySerializer_instance;
function BooleanArraySerializer_getInstance() {
  if (BooleanArraySerializer_instance == null)
    new BooleanArraySerializer_0();
  return BooleanArraySerializer_instance;
}
function CharArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.g10_1 = bufferWithData;
  this.h10_1 = bufferWithData.length;
  this.dx(10);
}
protoOf(CharArrayBuilder).zw = function () {
  return this.h10_1;
};
protoOf(CharArrayBuilder).dx = function (requiredCapacity) {
  if (this.g10_1.length < requiredCapacity)
    this.g10_1 = copyOf(this.g10_1, coerceAtLeast(requiredCapacity, imul(this.g10_1.length, 2)));
};
protoOf(CharArrayBuilder).i10 = function (c) {
  this.kx();
  var tmp = this.g10_1;
  var _unary__edvuaz = this.h10_1;
  this.h10_1 = _unary__edvuaz + 1 | 0;
  tmp[_unary__edvuaz] = c;
};
protoOf(CharArrayBuilder).bx = function () {
  return copyOf(this.g10_1, this.h10_1);
};
function DoubleArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.p10_1 = bufferWithData;
  this.q10_1 = bufferWithData.length;
  this.dx(10);
}
protoOf(DoubleArrayBuilder).zw = function () {
  return this.q10_1;
};
protoOf(DoubleArrayBuilder).dx = function (requiredCapacity) {
  if (this.p10_1.length < requiredCapacity)
    this.p10_1 = copyOf_0(this.p10_1, coerceAtLeast(requiredCapacity, imul(this.p10_1.length, 2)));
};
protoOf(DoubleArrayBuilder).r10 = function (c) {
  this.kx();
  var tmp = this.p10_1;
  var _unary__edvuaz = this.q10_1;
  this.q10_1 = _unary__edvuaz + 1 | 0;
  tmp[_unary__edvuaz] = c;
};
protoOf(DoubleArrayBuilder).bx = function () {
  return copyOf_0(this.p10_1, this.q10_1);
};
function FloatArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.y10_1 = bufferWithData;
  this.z10_1 = bufferWithData.length;
  this.dx(10);
}
protoOf(FloatArrayBuilder).zw = function () {
  return this.z10_1;
};
protoOf(FloatArrayBuilder).dx = function (requiredCapacity) {
  if (this.y10_1.length < requiredCapacity)
    this.y10_1 = copyOf_1(this.y10_1, coerceAtLeast(requiredCapacity, imul(this.y10_1.length, 2)));
};
protoOf(FloatArrayBuilder).a11 = function (c) {
  this.kx();
  var tmp = this.y10_1;
  var _unary__edvuaz = this.z10_1;
  this.z10_1 = _unary__edvuaz + 1 | 0;
  tmp[_unary__edvuaz] = c;
};
protoOf(FloatArrayBuilder).bx = function () {
  return copyOf_1(this.y10_1, this.z10_1);
};
function LongArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.h11_1 = bufferWithData;
  this.i11_1 = bufferWithData.length;
  this.dx(10);
}
protoOf(LongArrayBuilder).zw = function () {
  return this.i11_1;
};
protoOf(LongArrayBuilder).dx = function (requiredCapacity) {
  if (this.h11_1.length < requiredCapacity)
    this.h11_1 = copyOf_2(this.h11_1, coerceAtLeast(requiredCapacity, imul(this.h11_1.length, 2)));
};
protoOf(LongArrayBuilder).j11 = function (c) {
  this.kx();
  var tmp = this.h11_1;
  var _unary__edvuaz = this.i11_1;
  this.i11_1 = _unary__edvuaz + 1 | 0;
  tmp[_unary__edvuaz] = c;
};
protoOf(LongArrayBuilder).bx = function () {
  return copyOf_2(this.h11_1, this.i11_1);
};
function ULongArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.r11_1 = bufferWithData;
  this.s11_1 = _ULongArray___get_size__impl__ju6dtr(bufferWithData);
  this.dx(10);
}
protoOf(ULongArrayBuilder).zw = function () {
  return this.s11_1;
};
protoOf(ULongArrayBuilder).dx = function (requiredCapacity) {
  if (_ULongArray___get_size__impl__ju6dtr(this.r11_1) < requiredCapacity) {
    var tmp = this;
    var tmp0 = this.r11_1;
    // Inline function 'kotlin.collections.copyOf' call
    var newSize = coerceAtLeast(requiredCapacity, imul(_ULongArray___get_size__impl__ju6dtr(this.r11_1), 2));
    tmp.r11_1 = _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(tmp0), newSize));
  }
};
protoOf(ULongArrayBuilder).t11 = function (c) {
  this.kx();
  var tmp = this.r11_1;
  var _unary__edvuaz = this.s11_1;
  this.s11_1 = _unary__edvuaz + 1 | 0;
  ULongArray__set_impl_z19mvh(tmp, _unary__edvuaz, c);
};
protoOf(ULongArrayBuilder).j14 = function () {
  var tmp0 = this.r11_1;
  // Inline function 'kotlin.collections.copyOf' call
  var newSize = this.s11_1;
  return _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(tmp0), newSize));
};
protoOf(ULongArrayBuilder).bx = function () {
  return new ULongArray(this.j14());
};
function IntArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.a12_1 = bufferWithData;
  this.b12_1 = bufferWithData.length;
  this.dx(10);
}
protoOf(IntArrayBuilder).zw = function () {
  return this.b12_1;
};
protoOf(IntArrayBuilder).dx = function (requiredCapacity) {
  if (this.a12_1.length < requiredCapacity)
    this.a12_1 = copyOf_3(this.a12_1, coerceAtLeast(requiredCapacity, imul(this.a12_1.length, 2)));
};
protoOf(IntArrayBuilder).c12 = function (c) {
  this.kx();
  var tmp = this.a12_1;
  var _unary__edvuaz = this.b12_1;
  this.b12_1 = _unary__edvuaz + 1 | 0;
  tmp[_unary__edvuaz] = c;
};
protoOf(IntArrayBuilder).bx = function () {
  return copyOf_3(this.a12_1, this.b12_1);
};
function UIntArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.k12_1 = bufferWithData;
  this.l12_1 = _UIntArray___get_size__impl__r6l8ci(bufferWithData);
  this.dx(10);
}
protoOf(UIntArrayBuilder).zw = function () {
  return this.l12_1;
};
protoOf(UIntArrayBuilder).dx = function (requiredCapacity) {
  if (_UIntArray___get_size__impl__r6l8ci(this.k12_1) < requiredCapacity) {
    var tmp = this;
    var tmp0 = this.k12_1;
    // Inline function 'kotlin.collections.copyOf' call
    var newSize = coerceAtLeast(requiredCapacity, imul(_UIntArray___get_size__impl__r6l8ci(this.k12_1), 2));
    tmp.k12_1 = _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(tmp0), newSize));
  }
};
protoOf(UIntArrayBuilder).m12 = function (c) {
  this.kx();
  var tmp = this.k12_1;
  var _unary__edvuaz = this.l12_1;
  this.l12_1 = _unary__edvuaz + 1 | 0;
  UIntArray__set_impl_7f2zu2(tmp, _unary__edvuaz, c);
};
protoOf(UIntArrayBuilder).k14 = function () {
  var tmp0 = this.k12_1;
  // Inline function 'kotlin.collections.copyOf' call
  var newSize = this.l12_1;
  return _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(tmp0), newSize));
};
protoOf(UIntArrayBuilder).bx = function () {
  return new UIntArray(this.k14());
};
function ShortArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.t12_1 = bufferWithData;
  this.u12_1 = bufferWithData.length;
  this.dx(10);
}
protoOf(ShortArrayBuilder).zw = function () {
  return this.u12_1;
};
protoOf(ShortArrayBuilder).dx = function (requiredCapacity) {
  if (this.t12_1.length < requiredCapacity)
    this.t12_1 = copyOf_4(this.t12_1, coerceAtLeast(requiredCapacity, imul(this.t12_1.length, 2)));
};
protoOf(ShortArrayBuilder).v12 = function (c) {
  this.kx();
  var tmp = this.t12_1;
  var _unary__edvuaz = this.u12_1;
  this.u12_1 = _unary__edvuaz + 1 | 0;
  tmp[_unary__edvuaz] = c;
};
protoOf(ShortArrayBuilder).bx = function () {
  return copyOf_4(this.t12_1, this.u12_1);
};
function UShortArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.d13_1 = bufferWithData;
  this.e13_1 = _UShortArray___get_size__impl__jqto1b(bufferWithData);
  this.dx(10);
}
protoOf(UShortArrayBuilder).zw = function () {
  return this.e13_1;
};
protoOf(UShortArrayBuilder).dx = function (requiredCapacity) {
  if (_UShortArray___get_size__impl__jqto1b(this.d13_1) < requiredCapacity) {
    var tmp = this;
    var tmp0 = this.d13_1;
    // Inline function 'kotlin.collections.copyOf' call
    var newSize = coerceAtLeast(requiredCapacity, imul(_UShortArray___get_size__impl__jqto1b(this.d13_1), 2));
    tmp.d13_1 = _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(tmp0), newSize));
  }
};
protoOf(UShortArrayBuilder).f13 = function (c) {
  this.kx();
  var tmp = this.d13_1;
  var _unary__edvuaz = this.e13_1;
  this.e13_1 = _unary__edvuaz + 1 | 0;
  UShortArray__set_impl_6d8whp(tmp, _unary__edvuaz, c);
};
protoOf(UShortArrayBuilder).l14 = function () {
  var tmp0 = this.d13_1;
  // Inline function 'kotlin.collections.copyOf' call
  var newSize = this.e13_1;
  return _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(tmp0), newSize));
};
protoOf(UShortArrayBuilder).bx = function () {
  return new UShortArray(this.l14());
};
function ByteArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.m13_1 = bufferWithData;
  this.n13_1 = bufferWithData.length;
  this.dx(10);
}
protoOf(ByteArrayBuilder).zw = function () {
  return this.n13_1;
};
protoOf(ByteArrayBuilder).dx = function (requiredCapacity) {
  if (this.m13_1.length < requiredCapacity)
    this.m13_1 = copyOf_5(this.m13_1, coerceAtLeast(requiredCapacity, imul(this.m13_1.length, 2)));
};
protoOf(ByteArrayBuilder).o13 = function (c) {
  this.kx();
  var tmp = this.m13_1;
  var _unary__edvuaz = this.n13_1;
  this.n13_1 = _unary__edvuaz + 1 | 0;
  tmp[_unary__edvuaz] = c;
};
protoOf(ByteArrayBuilder).bx = function () {
  return copyOf_5(this.m13_1, this.n13_1);
};
function UByteArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.w13_1 = bufferWithData;
  this.x13_1 = _UByteArray___get_size__impl__h6pkdv(bufferWithData);
  this.dx(10);
}
protoOf(UByteArrayBuilder).zw = function () {
  return this.x13_1;
};
protoOf(UByteArrayBuilder).dx = function (requiredCapacity) {
  if (_UByteArray___get_size__impl__h6pkdv(this.w13_1) < requiredCapacity) {
    var tmp = this;
    var tmp0 = this.w13_1;
    // Inline function 'kotlin.collections.copyOf' call
    var newSize = coerceAtLeast(requiredCapacity, imul(_UByteArray___get_size__impl__h6pkdv(this.w13_1), 2));
    tmp.w13_1 = _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(tmp0), newSize));
  }
};
protoOf(UByteArrayBuilder).y13 = function (c) {
  this.kx();
  var tmp = this.w13_1;
  var _unary__edvuaz = this.x13_1;
  this.x13_1 = _unary__edvuaz + 1 | 0;
  UByteArray__set_impl_jvcicn(tmp, _unary__edvuaz, c);
};
protoOf(UByteArrayBuilder).m14 = function () {
  var tmp0 = this.w13_1;
  // Inline function 'kotlin.collections.copyOf' call
  var newSize = this.x13_1;
  return _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(tmp0), newSize));
};
protoOf(UByteArrayBuilder).bx = function () {
  return new UByteArray(this.m14());
};
function BooleanArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.f14_1 = bufferWithData;
  this.g14_1 = bufferWithData.length;
  this.dx(10);
}
protoOf(BooleanArrayBuilder).zw = function () {
  return this.g14_1;
};
protoOf(BooleanArrayBuilder).dx = function (requiredCapacity) {
  if (this.f14_1.length < requiredCapacity)
    this.f14_1 = copyOf_6(this.f14_1, coerceAtLeast(requiredCapacity, imul(this.f14_1.length, 2)));
};
protoOf(BooleanArrayBuilder).h14 = function (c) {
  this.kx();
  var tmp = this.f14_1;
  var _unary__edvuaz = this.g14_1;
  this.g14_1 = _unary__edvuaz + 1 | 0;
  tmp[_unary__edvuaz] = c;
};
protoOf(BooleanArrayBuilder).bx = function () {
  return copyOf_6(this.f14_1, this.g14_1);
};
function get_BUILTIN_SERIALIZERS() {
  _init_properties_Primitives_kt__k0eto4();
  return BUILTIN_SERIALIZERS;
}
var BUILTIN_SERIALIZERS;
function builtinSerializerOrNull(_this__u8e3s4) {
  _init_properties_Primitives_kt__k0eto4();
  var tmp = get_BUILTIN_SERIALIZERS().a2(_this__u8e3s4);
  return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : THROW_CCE();
}
function StringSerializer() {
  StringSerializer_instance = this;
  this.n14_1 = new PrimitiveSerialDescriptor_0('kotlin.String', STRING_getInstance());
}
protoOf(StringSerializer).xn = function () {
  return this.n14_1;
};
protoOf(StringSerializer).o14 = function (encoder, value) {
  return encoder.os(value);
};
protoOf(StringSerializer).yn = function (encoder, value) {
  return this.o14(encoder, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
};
protoOf(StringSerializer).zn = function (decoder) {
  return decoder.fr();
};
var StringSerializer_instance;
function StringSerializer_getInstance() {
  if (StringSerializer_instance == null)
    new StringSerializer();
  return StringSerializer_instance;
}
function CharSerializer() {
  CharSerializer_instance = this;
  this.p14_1 = new PrimitiveSerialDescriptor_0('kotlin.Char', CHAR_getInstance());
}
protoOf(CharSerializer).xn = function () {
  return this.p14_1;
};
protoOf(CharSerializer).q14 = function (encoder, value) {
  return encoder.ns(value);
};
protoOf(CharSerializer).yn = function (encoder, value) {
  return this.q14(encoder, value instanceof Char ? value.i1_1 : THROW_CCE());
};
protoOf(CharSerializer).r14 = function (decoder) {
  return decoder.er();
};
protoOf(CharSerializer).zn = function (decoder) {
  return new Char(this.r14(decoder));
};
var CharSerializer_instance;
function CharSerializer_getInstance() {
  if (CharSerializer_instance == null)
    new CharSerializer();
  return CharSerializer_instance;
}
function DoubleSerializer() {
  DoubleSerializer_instance = this;
  this.s14_1 = new PrimitiveSerialDescriptor_0('kotlin.Double', DOUBLE_getInstance());
}
protoOf(DoubleSerializer).xn = function () {
  return this.s14_1;
};
protoOf(DoubleSerializer).t14 = function (encoder, value) {
  return encoder.ms(value);
};
protoOf(DoubleSerializer).yn = function (encoder, value) {
  return this.t14(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
};
protoOf(DoubleSerializer).zn = function (decoder) {
  return decoder.dr();
};
var DoubleSerializer_instance;
function DoubleSerializer_getInstance() {
  if (DoubleSerializer_instance == null)
    new DoubleSerializer();
  return DoubleSerializer_instance;
}
function FloatSerializer() {
  FloatSerializer_instance = this;
  this.u14_1 = new PrimitiveSerialDescriptor_0('kotlin.Float', FLOAT_getInstance());
}
protoOf(FloatSerializer).xn = function () {
  return this.u14_1;
};
protoOf(FloatSerializer).v14 = function (encoder, value) {
  return encoder.ls(value);
};
protoOf(FloatSerializer).yn = function (encoder, value) {
  return this.v14(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
};
protoOf(FloatSerializer).zn = function (decoder) {
  return decoder.cr();
};
var FloatSerializer_instance;
function FloatSerializer_getInstance() {
  if (FloatSerializer_instance == null)
    new FloatSerializer();
  return FloatSerializer_instance;
}
function LongSerializer() {
  LongSerializer_instance = this;
  this.w14_1 = new PrimitiveSerialDescriptor_0('kotlin.Long', LONG_getInstance());
}
protoOf(LongSerializer).xn = function () {
  return this.w14_1;
};
protoOf(LongSerializer).x14 = function (encoder, value) {
  return encoder.ks(value);
};
protoOf(LongSerializer).yn = function (encoder, value) {
  return this.x14(encoder, value instanceof Long ? value : THROW_CCE());
};
protoOf(LongSerializer).zn = function (decoder) {
  return decoder.br();
};
var LongSerializer_instance;
function LongSerializer_getInstance() {
  if (LongSerializer_instance == null)
    new LongSerializer();
  return LongSerializer_instance;
}
function IntSerializer() {
  IntSerializer_instance = this;
  this.y14_1 = new PrimitiveSerialDescriptor_0('kotlin.Int', INT_getInstance());
}
protoOf(IntSerializer).xn = function () {
  return this.y14_1;
};
protoOf(IntSerializer).z14 = function (encoder, value) {
  return encoder.js(value);
};
protoOf(IntSerializer).yn = function (encoder, value) {
  return this.z14(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
};
protoOf(IntSerializer).zn = function (decoder) {
  return decoder.ar();
};
var IntSerializer_instance;
function IntSerializer_getInstance() {
  if (IntSerializer_instance == null)
    new IntSerializer();
  return IntSerializer_instance;
}
function ShortSerializer() {
  ShortSerializer_instance = this;
  this.a15_1 = new PrimitiveSerialDescriptor_0('kotlin.Short', SHORT_getInstance());
}
protoOf(ShortSerializer).xn = function () {
  return this.a15_1;
};
protoOf(ShortSerializer).b15 = function (encoder, value) {
  return encoder.is(value);
};
protoOf(ShortSerializer).yn = function (encoder, value) {
  return this.b15(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
};
protoOf(ShortSerializer).zn = function (decoder) {
  return decoder.zq();
};
var ShortSerializer_instance;
function ShortSerializer_getInstance() {
  if (ShortSerializer_instance == null)
    new ShortSerializer();
  return ShortSerializer_instance;
}
function ByteSerializer() {
  ByteSerializer_instance = this;
  this.c15_1 = new PrimitiveSerialDescriptor_0('kotlin.Byte', BYTE_getInstance());
}
protoOf(ByteSerializer).xn = function () {
  return this.c15_1;
};
protoOf(ByteSerializer).d15 = function (encoder, value) {
  return encoder.hs(value);
};
protoOf(ByteSerializer).yn = function (encoder, value) {
  return this.d15(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
};
protoOf(ByteSerializer).zn = function (decoder) {
  return decoder.yq();
};
var ByteSerializer_instance;
function ByteSerializer_getInstance() {
  if (ByteSerializer_instance == null)
    new ByteSerializer();
  return ByteSerializer_instance;
}
function BooleanSerializer() {
  BooleanSerializer_instance = this;
  this.e15_1 = new PrimitiveSerialDescriptor_0('kotlin.Boolean', BOOLEAN_getInstance());
}
protoOf(BooleanSerializer).xn = function () {
  return this.e15_1;
};
protoOf(BooleanSerializer).f15 = function (encoder, value) {
  return encoder.gs(value);
};
protoOf(BooleanSerializer).yn = function (encoder, value) {
  return this.f15(encoder, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
};
protoOf(BooleanSerializer).zn = function (decoder) {
  return decoder.xq();
};
var BooleanSerializer_instance;
function BooleanSerializer_getInstance() {
  if (BooleanSerializer_instance == null)
    new BooleanSerializer();
  return BooleanSerializer_instance;
}
function UnitSerializer() {
  UnitSerializer_instance = this;
  this.g15_1 = new ObjectSerializer('kotlin.Unit', Unit_instance);
}
protoOf(UnitSerializer).xn = function () {
  return this.g15_1.xn();
};
protoOf(UnitSerializer).h15 = function (encoder, value) {
  this.g15_1.no(encoder, Unit_instance);
};
protoOf(UnitSerializer).yn = function (encoder, value) {
  return this.h15(encoder, value instanceof Unit ? value : THROW_CCE());
};
protoOf(UnitSerializer).i15 = function (decoder) {
  this.g15_1.zn(decoder);
};
protoOf(UnitSerializer).zn = function (decoder) {
  this.i15(decoder);
  return Unit_instance;
};
var UnitSerializer_instance;
function UnitSerializer_getInstance() {
  if (UnitSerializer_instance == null)
    new UnitSerializer();
  return UnitSerializer_instance;
}
function error_0($this) {
  throw IllegalStateException_init_$Create$('Primitive descriptor ' + $this.j15_1 + ' does not have elements');
}
function PrimitiveSerialDescriptor_0(serialName, kind) {
  this.j15_1 = serialName;
  this.k15_1 = kind;
}
protoOf(PrimitiveSerialDescriptor_0).yo = function () {
  return this.j15_1;
};
protoOf(PrimitiveSerialDescriptor_0).op = function () {
  return this.k15_1;
};
protoOf(PrimitiveSerialDescriptor_0).qp = function () {
  return 0;
};
protoOf(PrimitiveSerialDescriptor_0).sp = function (index) {
  error_0(this);
};
protoOf(PrimitiveSerialDescriptor_0).tp = function (name) {
  error_0(this);
};
protoOf(PrimitiveSerialDescriptor_0).wp = function (index) {
  error_0(this);
};
protoOf(PrimitiveSerialDescriptor_0).vp = function (index) {
  error_0(this);
};
protoOf(PrimitiveSerialDescriptor_0).up = function (index) {
  error_0(this);
};
protoOf(PrimitiveSerialDescriptor_0).toString = function () {
  return 'PrimitiveDescriptor(' + this.j15_1 + ')';
};
protoOf(PrimitiveSerialDescriptor_0).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PrimitiveSerialDescriptor_0))
    return false;
  if (this.j15_1 === other.j15_1 && equals(this.k15_1, other.k15_1))
    return true;
  return false;
};
protoOf(PrimitiveSerialDescriptor_0).hashCode = function () {
  return getStringHashCode(this.j15_1) + imul(31, this.k15_1.hashCode()) | 0;
};
function PrimitiveDescriptorSafe(serialName, kind) {
  _init_properties_Primitives_kt__k0eto4();
  checkNameIsNotAPrimitive(serialName);
  return new PrimitiveSerialDescriptor_0(serialName, kind);
}
function checkNameIsNotAPrimitive(serialName) {
  _init_properties_Primitives_kt__k0eto4();
  var values = get_BUILTIN_SERIALIZERS().c2();
  var _iterator__ex2g4s = values.j();
  while (_iterator__ex2g4s.k()) {
    var primitive = _iterator__ex2g4s.l();
    var primitiveName = primitive.xn().yo();
    if (serialName === primitiveName) {
      throw IllegalArgumentException_init_$Create$(trimIndent('\n                The name of serial descriptor should uniquely identify associated serializer.\n                For serial name ' + serialName + ' there already exists ' + getKClassFromExpression(primitive).pa() + '.\n                Please refer to SerialDescriptor documentation for additional information.\n            '));
    }
  }
}
var properties_initialized_Primitives_kt_6dpii6;
function _init_properties_Primitives_kt__k0eto4() {
  if (!properties_initialized_Primitives_kt_6dpii6) {
    properties_initialized_Primitives_kt_6dpii6 = true;
    BUILTIN_SERIALIZERS = initBuiltins();
  }
}
function NamedValueDecoder() {
  TaggedDecoder.call(this);
}
protoOf(NamedValueDecoder).n15 = function (_this__u8e3s4, index) {
  return this.p15(this.o15(_this__u8e3s4, index));
};
protoOf(NamedValueDecoder).p15 = function (nestedName) {
  var tmp0_elvis_lhs = this.s15();
  return this.t15(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
};
protoOf(NamedValueDecoder).o15 = function (descriptor, index) {
  return descriptor.sp(index);
};
protoOf(NamedValueDecoder).t15 = function (parentName, childName) {
  var tmp;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(parentName) === 0) {
    tmp = childName;
  } else {
    tmp = parentName + '.' + childName;
  }
  return tmp;
};
protoOf(NamedValueDecoder).u15 = function () {
  return this.q15_1.p() ? '$' : joinToString(this.q15_1, '.', '$.');
};
function tagBlock($this, tag, block) {
  $this.i16(tag);
  var r = block();
  if (!$this.r15_1) {
    $this.j16();
  }
  $this.r15_1 = false;
  return r;
}
function TaggedDecoder$decodeSerializableElement$lambda(this$0, $deserializer, $previousValue) {
  return function () {
    return this$0.ir($deserializer, $previousValue);
  };
}
function TaggedDecoder$decodeNullableSerializableElement$lambda(this$0, $deserializer, $previousValue) {
  return function () {
    var tmp0 = this$0;
    // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
    var isNullabilitySupported = $deserializer.xn().kp();
    var tmp;
    if (isNullabilitySupported || tmp0.vq()) {
      tmp = this$0.ir($deserializer, $previousValue);
    } else {
      tmp = tmp0.wq();
    }
    return tmp;
  };
}
function TaggedDecoder() {
  var tmp = this;
  // Inline function 'kotlin.collections.arrayListOf' call
  tmp.q15_1 = ArrayList_init_$Create$_0();
  this.r15_1 = false;
}
protoOf(TaggedDecoder).zr = function () {
  return EmptySerializersModule_0();
};
protoOf(TaggedDecoder).v15 = function (tag) {
  throw SerializationException_init_$Create$_0(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
};
protoOf(TaggedDecoder).w15 = function (tag) {
  return true;
};
protoOf(TaggedDecoder).x15 = function (tag) {
  var tmp = this.v15(tag);
  return typeof tmp === 'boolean' ? tmp : THROW_CCE();
};
protoOf(TaggedDecoder).y15 = function (tag) {
  var tmp = this.v15(tag);
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(TaggedDecoder).z15 = function (tag) {
  var tmp = this.v15(tag);
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(TaggedDecoder).a16 = function (tag) {
  var tmp = this.v15(tag);
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(TaggedDecoder).b16 = function (tag) {
  var tmp = this.v15(tag);
  return tmp instanceof Long ? tmp : THROW_CCE();
};
protoOf(TaggedDecoder).c16 = function (tag) {
  var tmp = this.v15(tag);
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(TaggedDecoder).d16 = function (tag) {
  var tmp = this.v15(tag);
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(TaggedDecoder).e16 = function (tag) {
  var tmp = this.v15(tag);
  return tmp instanceof Char ? tmp.i1_1 : THROW_CCE();
};
protoOf(TaggedDecoder).f16 = function (tag) {
  var tmp = this.v15(tag);
  return typeof tmp === 'string' ? tmp : THROW_CCE();
};
protoOf(TaggedDecoder).g16 = function (tag, enumDescriptor) {
  var tmp = this.v15(tag);
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(TaggedDecoder).h16 = function (tag, inlineDescriptor) {
  // Inline function 'kotlin.apply' call
  this.i16(tag);
  return this;
};
protoOf(TaggedDecoder).ir = function (deserializer, previousValue) {
  return this.jr(deserializer);
};
protoOf(TaggedDecoder).hr = function (descriptor) {
  return this.h16(this.j16(), descriptor);
};
protoOf(TaggedDecoder).vq = function () {
  var tmp0_elvis_lhs = this.s15();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var currentTag = tmp;
  return this.w15(currentTag);
};
protoOf(TaggedDecoder).wq = function () {
  return null;
};
protoOf(TaggedDecoder).xq = function () {
  return this.x15(this.j16());
};
protoOf(TaggedDecoder).yq = function () {
  return this.y15(this.j16());
};
protoOf(TaggedDecoder).zq = function () {
  return this.z15(this.j16());
};
protoOf(TaggedDecoder).ar = function () {
  return this.a16(this.j16());
};
protoOf(TaggedDecoder).br = function () {
  return this.b16(this.j16());
};
protoOf(TaggedDecoder).cr = function () {
  return this.c16(this.j16());
};
protoOf(TaggedDecoder).dr = function () {
  return this.d16(this.j16());
};
protoOf(TaggedDecoder).er = function () {
  return this.e16(this.j16());
};
protoOf(TaggedDecoder).fr = function () {
  return this.f16(this.j16());
};
protoOf(TaggedDecoder).gr = function (enumDescriptor) {
  return this.g16(this.j16(), enumDescriptor);
};
protoOf(TaggedDecoder).kr = function (descriptor) {
  return this;
};
protoOf(TaggedDecoder).lr = function (descriptor) {
};
protoOf(TaggedDecoder).mr = function (descriptor, index) {
  return this.x15(this.n15(descriptor, index));
};
protoOf(TaggedDecoder).nr = function (descriptor, index) {
  return this.y15(this.n15(descriptor, index));
};
protoOf(TaggedDecoder).or = function (descriptor, index) {
  return this.z15(this.n15(descriptor, index));
};
protoOf(TaggedDecoder).pr = function (descriptor, index) {
  return this.a16(this.n15(descriptor, index));
};
protoOf(TaggedDecoder).qr = function (descriptor, index) {
  return this.b16(this.n15(descriptor, index));
};
protoOf(TaggedDecoder).rr = function (descriptor, index) {
  return this.c16(this.n15(descriptor, index));
};
protoOf(TaggedDecoder).sr = function (descriptor, index) {
  return this.d16(this.n15(descriptor, index));
};
protoOf(TaggedDecoder).tr = function (descriptor, index) {
  return this.e16(this.n15(descriptor, index));
};
protoOf(TaggedDecoder).ur = function (descriptor, index) {
  return this.f16(this.n15(descriptor, index));
};
protoOf(TaggedDecoder).vr = function (descriptor, index) {
  return this.h16(this.n15(descriptor, index), descriptor.vp(index));
};
protoOf(TaggedDecoder).wr = function (descriptor, index, deserializer, previousValue) {
  var tmp = this.n15(descriptor, index);
  return tagBlock(this, tmp, TaggedDecoder$decodeSerializableElement$lambda(this, deserializer, previousValue));
};
protoOf(TaggedDecoder).yr = function (descriptor, index, deserializer, previousValue) {
  var tmp = this.n15(descriptor, index);
  return tagBlock(this, tmp, TaggedDecoder$decodeNullableSerializableElement$lambda(this, deserializer, previousValue));
};
protoOf(TaggedDecoder).s15 = function () {
  return lastOrNull(this.q15_1);
};
protoOf(TaggedDecoder).i16 = function (name) {
  this.q15_1.e(name);
};
protoOf(TaggedDecoder).j16 = function () {
  var r = this.q15_1.g2(get_lastIndex_0(this.q15_1));
  this.r15_1 = true;
  return r;
};
function get_NULL() {
  _init_properties_Tuples_kt__dz0qyd();
  return NULL;
}
var NULL;
function MapEntry(key, value) {
  this.k16_1 = key;
  this.l16_1 = value;
}
protoOf(MapEntry).s = function () {
  return this.k16_1;
};
protoOf(MapEntry).t = function () {
  return this.l16_1;
};
protoOf(MapEntry).toString = function () {
  return 'MapEntry(key=' + toString_0(this.k16_1) + ', value=' + toString_0(this.l16_1) + ')';
};
protoOf(MapEntry).hashCode = function () {
  var result = this.k16_1 == null ? 0 : hashCode(this.k16_1);
  result = imul(result, 31) + (this.l16_1 == null ? 0 : hashCode(this.l16_1)) | 0;
  return result;
};
protoOf(MapEntry).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof MapEntry))
    return false;
  var tmp0_other_with_cast = other instanceof MapEntry ? other : THROW_CCE();
  if (!equals(this.k16_1, tmp0_other_with_cast.k16_1))
    return false;
  if (!equals(this.l16_1, tmp0_other_with_cast.l16_1))
    return false;
  return true;
};
function MapEntrySerializer$descriptor$lambda($keySerializer, $valueSerializer) {
  return function ($this$buildSerialDescriptor) {
    $this$buildSerialDescriptor.io('key', $keySerializer.xn());
    $this$buildSerialDescriptor.io('value', $valueSerializer.xn());
    return Unit_instance;
  };
}
function MapEntrySerializer_0(keySerializer, valueSerializer) {
  KeyValueSerializer.call(this, keySerializer, valueSerializer);
  var tmp = this;
  var tmp_0 = MAP_getInstance();
  tmp.o16_1 = buildSerialDescriptor('kotlin.collections.Map.Entry', tmp_0, [], MapEntrySerializer$descriptor$lambda(keySerializer, valueSerializer));
}
protoOf(MapEntrySerializer_0).xn = function () {
  return this.o16_1;
};
protoOf(MapEntrySerializer_0).p16 = function (_this__u8e3s4) {
  return _this__u8e3s4.s();
};
protoOf(MapEntrySerializer_0).q16 = function (_this__u8e3s4) {
  return this.p16((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(MapEntrySerializer_0).r16 = function (_this__u8e3s4) {
  return _this__u8e3s4.t();
};
protoOf(MapEntrySerializer_0).s16 = function (_this__u8e3s4) {
  return this.r16((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(MapEntrySerializer_0).t16 = function (key, value) {
  return new MapEntry(key, value);
};
function PairSerializer$descriptor$lambda($keySerializer, $valueSerializer) {
  return function ($this$buildClassSerialDescriptor) {
    $this$buildClassSerialDescriptor.io('first', $keySerializer.xn());
    $this$buildClassSerialDescriptor.io('second', $valueSerializer.xn());
    return Unit_instance;
  };
}
function PairSerializer_0(keySerializer, valueSerializer) {
  KeyValueSerializer.call(this, keySerializer, valueSerializer);
  var tmp = this;
  tmp.z16_1 = buildClassSerialDescriptor('kotlin.Pair', [], PairSerializer$descriptor$lambda(keySerializer, valueSerializer));
}
protoOf(PairSerializer_0).xn = function () {
  return this.z16_1;
};
protoOf(PairSerializer_0).a17 = function (_this__u8e3s4) {
  return _this__u8e3s4.kf_1;
};
protoOf(PairSerializer_0).q16 = function (_this__u8e3s4) {
  return this.a17(_this__u8e3s4 instanceof Pair ? _this__u8e3s4 : THROW_CCE());
};
protoOf(PairSerializer_0).b17 = function (_this__u8e3s4) {
  return _this__u8e3s4.lf_1;
};
protoOf(PairSerializer_0).s16 = function (_this__u8e3s4) {
  return this.b17(_this__u8e3s4 instanceof Pair ? _this__u8e3s4 : THROW_CCE());
};
protoOf(PairSerializer_0).t16 = function (key, value) {
  return to(key, value);
};
function decodeSequentially_1($this, composite) {
  var a = composite.xr($this.f17_1, 0, $this.c17_1);
  var b = composite.xr($this.f17_1, 1, $this.d17_1);
  var c = composite.xr($this.f17_1, 2, $this.e17_1);
  composite.lr($this.f17_1);
  return new Triple(a, b, c);
}
function decodeStructure($this, composite) {
  var a = get_NULL();
  var b = get_NULL();
  var c = get_NULL();
  mainLoop: while (true) {
    var index = composite.bs($this.f17_1);
    switch (index) {
      case -1:
        break mainLoop;
      case 0:
        a = composite.xr($this.f17_1, 0, $this.c17_1);
        break;
      case 1:
        b = composite.xr($this.f17_1, 1, $this.d17_1);
        break;
      case 2:
        c = composite.xr($this.f17_1, 2, $this.e17_1);
        break;
      default:
        throw SerializationException_init_$Create$_0('Unexpected index ' + index);
    }
  }
  composite.lr($this.f17_1);
  if (a === get_NULL())
    throw SerializationException_init_$Create$_0("Element 'first' is missing");
  if (b === get_NULL())
    throw SerializationException_init_$Create$_0("Element 'second' is missing");
  if (c === get_NULL())
    throw SerializationException_init_$Create$_0("Element 'third' is missing");
  var tmp = (a == null ? true : !(a == null)) ? a : THROW_CCE();
  var tmp_0 = (b == null ? true : !(b == null)) ? b : THROW_CCE();
  return new Triple(tmp, tmp_0, (c == null ? true : !(c == null)) ? c : THROW_CCE());
}
function TripleSerializer$descriptor$lambda(this$0) {
  return function ($this$buildClassSerialDescriptor) {
    $this$buildClassSerialDescriptor.io('first', this$0.c17_1.xn());
    $this$buildClassSerialDescriptor.io('second', this$0.d17_1.xn());
    $this$buildClassSerialDescriptor.io('third', this$0.e17_1.xn());
    return Unit_instance;
  };
}
function TripleSerializer_0(aSerializer, bSerializer, cSerializer) {
  this.c17_1 = aSerializer;
  this.d17_1 = bSerializer;
  this.e17_1 = cSerializer;
  var tmp = this;
  tmp.f17_1 = buildClassSerialDescriptor('kotlin.Triple', [], TripleSerializer$descriptor$lambda(this));
}
protoOf(TripleSerializer_0).xn = function () {
  return this.f17_1;
};
protoOf(TripleSerializer_0).g17 = function (encoder, value) {
  var structuredEncoder = encoder.kr(this.f17_1);
  structuredEncoder.bt(this.f17_1, 0, this.c17_1, value.vl_1);
  structuredEncoder.bt(this.f17_1, 1, this.d17_1, value.wl_1);
  structuredEncoder.bt(this.f17_1, 2, this.e17_1, value.xl_1);
  structuredEncoder.lr(this.f17_1);
};
protoOf(TripleSerializer_0).yn = function (encoder, value) {
  return this.g17(encoder, value instanceof Triple ? value : THROW_CCE());
};
protoOf(TripleSerializer_0).zn = function (decoder) {
  var composite = decoder.kr(this.f17_1);
  if (composite.as()) {
    return decodeSequentially_1(this, composite);
  }
  return decodeStructure(this, composite);
};
function KeyValueSerializer(keySerializer, valueSerializer) {
  this.u16_1 = keySerializer;
  this.v16_1 = valueSerializer;
}
protoOf(KeyValueSerializer).w16 = function (encoder, value) {
  var structuredEncoder = encoder.kr(this.xn());
  structuredEncoder.bt(this.xn(), 0, this.u16_1, this.q16(value));
  structuredEncoder.bt(this.xn(), 1, this.v16_1, this.s16(value));
  structuredEncoder.lr(this.xn());
};
protoOf(KeyValueSerializer).yn = function (encoder, value) {
  return this.w16(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
};
protoOf(KeyValueSerializer).zn = function (decoder) {
  // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
  var descriptor = this.xn();
  var composite = decoder.kr(descriptor);
  var tmp$ret$0;
  $l$block: {
    if (composite.as()) {
      var key = composite.xr(this.xn(), 0, this.u16_1);
      var value = composite.xr(this.xn(), 1, this.v16_1);
      tmp$ret$0 = this.t16(key, value);
      break $l$block;
    }
    var key_0 = get_NULL();
    var value_0 = get_NULL();
    mainLoop: while (true) {
      var idx = composite.bs(this.xn());
      switch (idx) {
        case -1:
          break mainLoop;
        case 0:
          key_0 = composite.xr(this.xn(), 0, this.u16_1);
          break;
        case 1:
          value_0 = composite.xr(this.xn(), 1, this.v16_1);
          break;
        default:
          throw SerializationException_init_$Create$_0('Invalid index: ' + idx);
      }
    }
    if (key_0 === get_NULL())
      throw SerializationException_init_$Create$_0("Element 'key' is missing");
    if (value_0 === get_NULL())
      throw SerializationException_init_$Create$_0("Element 'value' is missing");
    var tmp = (key_0 == null ? true : !(key_0 == null)) ? key_0 : THROW_CCE();
    tmp$ret$0 = this.t16(tmp, (value_0 == null ? true : !(value_0 == null)) ? value_0 : THROW_CCE());
  }
  var result = tmp$ret$0;
  composite.lr(descriptor);
  return result;
};
var properties_initialized_Tuples_kt_3vs7ar;
function _init_properties_Tuples_kt__dz0qyd() {
  if (!properties_initialized_Tuples_kt_3vs7ar) {
    properties_initialized_Tuples_kt_3vs7ar = true;
    NULL = new Object();
  }
}
function ULongSerializer() {
  ULongSerializer_instance = this;
  this.h17_1 = InlinePrimitiveDescriptor('kotlin.ULong', serializer_6(Companion_getInstance_2()));
}
protoOf(ULongSerializer).xn = function () {
  return this.h17_1;
};
protoOf(ULongSerializer).i17 = function (encoder, value) {
  var tmp = encoder.qs(this.h17_1);
  // Inline function 'kotlin.ULong.toLong' call
  var tmp$ret$0 = _ULong___get_data__impl__fggpzb(value);
  tmp.ks(tmp$ret$0);
};
protoOf(ULongSerializer).yn = function (encoder, value) {
  return this.i17(encoder, value instanceof ULong ? value.fn_1 : THROW_CCE());
};
protoOf(ULongSerializer).j17 = function (decoder) {
  // Inline function 'kotlin.toULong' call
  var this_0 = decoder.hr(this.h17_1).br();
  return _ULong___init__impl__c78o9k(this_0);
};
protoOf(ULongSerializer).zn = function (decoder) {
  return new ULong(this.j17(decoder));
};
var ULongSerializer_instance;
function ULongSerializer_getInstance() {
  if (ULongSerializer_instance == null)
    new ULongSerializer();
  return ULongSerializer_instance;
}
function UIntSerializer() {
  UIntSerializer_instance = this;
  this.k17_1 = InlinePrimitiveDescriptor('kotlin.UInt', serializer_8(IntCompanionObject_instance));
}
protoOf(UIntSerializer).xn = function () {
  return this.k17_1;
};
protoOf(UIntSerializer).l17 = function (encoder, value) {
  var tmp = encoder.qs(this.k17_1);
  // Inline function 'kotlin.UInt.toInt' call
  var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(value);
  tmp.js(tmp$ret$0);
};
protoOf(UIntSerializer).yn = function (encoder, value) {
  return this.l17(encoder, value instanceof UInt ? value.um_1 : THROW_CCE());
};
protoOf(UIntSerializer).m17 = function (decoder) {
  // Inline function 'kotlin.toUInt' call
  var this_0 = decoder.hr(this.k17_1).ar();
  return _UInt___init__impl__l7qpdl(this_0);
};
protoOf(UIntSerializer).zn = function (decoder) {
  return new UInt(this.m17(decoder));
};
var UIntSerializer_instance;
function UIntSerializer_getInstance() {
  if (UIntSerializer_instance == null)
    new UIntSerializer();
  return UIntSerializer_instance;
}
function UShortSerializer() {
  UShortSerializer_instance = this;
  this.n17_1 = InlinePrimitiveDescriptor('kotlin.UShort', serializer_10(ShortCompanionObject_instance));
}
protoOf(UShortSerializer).xn = function () {
  return this.n17_1;
};
protoOf(UShortSerializer).o17 = function (encoder, value) {
  var tmp = encoder.qs(this.n17_1);
  // Inline function 'kotlin.UShort.toShort' call
  var tmp$ret$0 = _UShort___get_data__impl__g0245(value);
  tmp.is(tmp$ret$0);
};
protoOf(UShortSerializer).yn = function (encoder, value) {
  return this.o17(encoder, value instanceof UShort ? value.qn_1 : THROW_CCE());
};
protoOf(UShortSerializer).p17 = function (decoder) {
  // Inline function 'kotlin.toUShort' call
  var this_0 = decoder.hr(this.n17_1).zq();
  return _UShort___init__impl__jigrne(this_0);
};
protoOf(UShortSerializer).zn = function (decoder) {
  return new UShort(this.p17(decoder));
};
var UShortSerializer_instance;
function UShortSerializer_getInstance() {
  if (UShortSerializer_instance == null)
    new UShortSerializer();
  return UShortSerializer_instance;
}
function UByteSerializer() {
  UByteSerializer_instance = this;
  this.q17_1 = InlinePrimitiveDescriptor('kotlin.UByte', serializer_12(ByteCompanionObject_instance));
}
protoOf(UByteSerializer).xn = function () {
  return this.q17_1;
};
protoOf(UByteSerializer).r17 = function (encoder, value) {
  var tmp = encoder.qs(this.q17_1);
  // Inline function 'kotlin.UByte.toByte' call
  var tmp$ret$0 = _UByte___get_data__impl__jof9qr(value);
  tmp.hs(tmp$ret$0);
};
protoOf(UByteSerializer).yn = function (encoder, value) {
  return this.r17(encoder, value instanceof UByte ? value.jm_1 : THROW_CCE());
};
protoOf(UByteSerializer).s17 = function (decoder) {
  // Inline function 'kotlin.toUByte' call
  var this_0 = decoder.hr(this.q17_1).yq();
  return _UByte___init__impl__g9hnc4(this_0);
};
protoOf(UByteSerializer).zn = function (decoder) {
  return new UByte(this.s17(decoder));
};
var UByteSerializer_instance;
function UByteSerializer_getInstance() {
  if (UByteSerializer_instance == null)
    new UByteSerializer();
  return UByteSerializer_instance;
}
function get_EmptySerializersModuleLegacyJs() {
  _init_properties_SerializersModule_kt__u78ha3();
  return EmptySerializersModule;
}
var EmptySerializersModule;
function SerializersModule() {
}
protoOf(SerializersModule).gp = function (kClass, typeArgumentsSerializers, $super) {
  typeArgumentsSerializers = typeArgumentsSerializers === VOID ? emptyList() : typeArgumentsSerializers;
  return $super === VOID ? this.hp(kClass, typeArgumentsSerializers) : $super.hp.call(this, kClass, typeArgumentsSerializers);
};
function SerialModuleImpl(class2ContextualFactory, polyBase2Serializers, polyBase2DefaultSerializerProvider, polyBase2NamedSerializers, polyBase2DefaultDeserializerProvider, hasInterfaceContextualSerializers) {
  SerializersModule.call(this);
  this.u17_1 = class2ContextualFactory;
  this.v17_1 = polyBase2Serializers;
  this.w17_1 = polyBase2DefaultSerializerProvider;
  this.x17_1 = polyBase2NamedSerializers;
  this.y17_1 = polyBase2DefaultDeserializerProvider;
  this.z17_1 = hasInterfaceContextualSerializers;
}
protoOf(SerialModuleImpl).fp = function () {
  return this.z17_1;
};
protoOf(SerialModuleImpl).jt = function (baseClass, value) {
  if (!baseClass.qa(value))
    return null;
  var tmp0_safe_receiver = this.v17_1.a2(baseClass);
  var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a2(getKClassFromExpression(value));
  var registered = (!(tmp == null) ? isInterface(tmp, SerializationStrategy) : false) ? tmp : null;
  if (!(registered == null))
    return registered;
  var tmp_0 = this.w17_1.a2(baseClass);
  var tmp1_safe_receiver = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
  return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(value);
};
protoOf(SerialModuleImpl).it = function (baseClass, serializedClassName) {
  var tmp0_safe_receiver = this.x17_1.a2(baseClass);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.get' call
    tmp = (isInterface(tmp0_safe_receiver, KtMap) ? tmp0_safe_receiver : THROW_CCE()).a2(serializedClassName);
  }
  var tmp_0 = tmp;
  var registered = (!(tmp_0 == null) ? isInterface(tmp_0, KSerializer) : false) ? tmp_0 : null;
  if (!(registered == null))
    return registered;
  var tmp_1 = this.y17_1.a2(baseClass);
  var tmp1_safe_receiver = (!(tmp_1 == null) ? typeof tmp_1 === 'function' : false) ? tmp_1 : null;
  return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(serializedClassName);
};
protoOf(SerialModuleImpl).hp = function (kClass, typeArgumentsSerializers) {
  var tmp0_safe_receiver = this.u17_1.a2(kClass);
  var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a18(typeArgumentsSerializers);
  return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : null;
};
protoOf(SerialModuleImpl).t17 = function (collector) {
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = this.u17_1.r().j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.component1' call
    var kclass = element.s();
    // Inline function 'kotlin.collections.component2' call
    var serial = element.t();
    if (serial instanceof Argless) {
      var tmp = isInterface(kclass, KClass) ? kclass : THROW_CCE();
      var tmp_0 = serial.d18_1;
      collector.e18(tmp, isInterface(tmp_0, KSerializer) ? tmp_0 : THROW_CCE());
    } else {
      if (serial instanceof WithTypeArguments) {
        collector.c18(kclass, serial.b18_1);
      } else {
        noWhenBranchMatchedException();
      }
    }
  }
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_0 = this.v17_1.r().j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    // Inline function 'kotlin.collections.component1' call
    var baseClass = element_0.s();
    // Inline function 'kotlin.collections.component2' call
    var classMap = element_0.t();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_1 = classMap.r().j();
    while (_iterator__ex2g4s_1.k()) {
      var element_1 = _iterator__ex2g4s_1.l();
      // Inline function 'kotlin.collections.component1' call
      var actualClass = element_1.s();
      // Inline function 'kotlin.collections.component2' call
      var serializer = element_1.t();
      var tmp_1 = isInterface(baseClass, KClass) ? baseClass : THROW_CCE();
      var tmp_2 = isInterface(actualClass, KClass) ? actualClass : THROW_CCE();
      // Inline function 'kotlinx.serialization.internal.cast' call
      var tmp$ret$11 = isInterface(serializer, KSerializer) ? serializer : THROW_CCE();
      collector.f18(tmp_1, tmp_2, tmp$ret$11);
    }
  }
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_2 = this.w17_1.r().j();
  while (_iterator__ex2g4s_2.k()) {
    var element_2 = _iterator__ex2g4s_2.l();
    // Inline function 'kotlin.collections.component1' call
    var baseClass_0 = element_2.s();
    // Inline function 'kotlin.collections.component2' call
    var provider = element_2.t();
    var tmp_3 = isInterface(baseClass_0, KClass) ? baseClass_0 : THROW_CCE();
    collector.g18(tmp_3, typeof provider === 'function' ? provider : THROW_CCE());
  }
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_3 = this.y17_1.r().j();
  while (_iterator__ex2g4s_3.k()) {
    var element_3 = _iterator__ex2g4s_3.l();
    // Inline function 'kotlin.collections.component1' call
    var baseClass_1 = element_3.s();
    // Inline function 'kotlin.collections.component2' call
    var provider_0 = element_3.t();
    var tmp_4 = isInterface(baseClass_1, KClass) ? baseClass_1 : THROW_CCE();
    collector.h18(tmp_4, typeof provider_0 === 'function' ? provider_0 : THROW_CCE());
  }
};
function Argless() {
}
function WithTypeArguments() {
}
function ContextualProvider() {
}
var properties_initialized_SerializersModule_kt_fjigjn;
function _init_properties_SerializersModule_kt__u78ha3() {
  if (!properties_initialized_SerializersModule_kt_fjigjn) {
    properties_initialized_SerializersModule_kt_fjigjn = true;
    EmptySerializersModule = new SerialModuleImpl(emptyMap(), emptyMap(), emptyMap(), emptyMap(), emptyMap(), false);
  }
}
function EmptySerializersModule_0() {
  return get_EmptySerializersModuleLegacyJs();
}
function SerializersModuleCollector$contextual$lambda($serializer) {
  return function (it) {
    return $serializer;
  };
}
function SerializersModuleCollector() {
}
function SerializableWith(serializer) {
  this.i18_1 = serializer;
}
protoOf(SerializableWith).equals = function (other) {
  if (!(other instanceof SerializableWith))
    return false;
  var tmp0_other_with_cast = other instanceof SerializableWith ? other : THROW_CCE();
  if (!this.i18_1.equals(tmp0_other_with_cast.i18_1))
    return false;
  return true;
};
protoOf(SerializableWith).hashCode = function () {
  return imul(getStringHashCode('serializer'), 127) ^ this.i18_1.hashCode();
};
protoOf(SerializableWith).toString = function () {
  return '@kotlinx.serialization.SerializableWith(' + 'serializer=' + toString(this.i18_1) + ')';
};
function createCache(factory) {
  return new createCache$1(factory);
}
function createParametrizedCache(factory) {
  return new createParametrizedCache$1(factory);
}
function isInterface_0(_this__u8e3s4) {
  return get_isInterface(_this__u8e3s4);
}
function initBuiltins() {
  return mapOf([to(PrimitiveClasses_getInstance().vb(), serializer_2(StringCompanionObject_instance)), to(getKClass(Char), serializer_3(Companion_getInstance_1())), to(PrimitiveClasses_getInstance().yb(), CharArraySerializer()), to(PrimitiveClasses_getInstance().tb(), serializer_4(DoubleCompanionObject_instance)), to(PrimitiveClasses_getInstance().ec(), DoubleArraySerializer()), to(PrimitiveClasses_getInstance().sb(), serializer_5(FloatCompanionObject_instance)), to(PrimitiveClasses_getInstance().dc(), FloatArraySerializer()), to(getKClass(Long), serializer_6(Companion_getInstance_2())), to(PrimitiveClasses_getInstance().cc(), LongArraySerializer()), to(getKClass(ULong), serializer_7(Companion_getInstance_3())), to(getKClass(ULongArray), ULongArraySerializer()), to(PrimitiveClasses_getInstance().rb(), serializer_8(IntCompanionObject_instance)), to(PrimitiveClasses_getInstance().bc(), IntArraySerializer()), to(getKClass(UInt), serializer_9(Companion_getInstance_4())), to(getKClass(UIntArray), UIntArraySerializer()), to(PrimitiveClasses_getInstance().qb(), serializer_10(ShortCompanionObject_instance)), to(PrimitiveClasses_getInstance().ac(), ShortArraySerializer()), to(getKClass(UShort), serializer_11(Companion_getInstance_5())), to(getKClass(UShortArray), UShortArraySerializer()), to(PrimitiveClasses_getInstance().pb(), serializer_12(ByteCompanionObject_instance)), to(PrimitiveClasses_getInstance().zb(), ByteArraySerializer()), to(getKClass(UByte), serializer_13(Companion_getInstance_6())), to(getKClass(UByteArray), UByteArraySerializer()), to(PrimitiveClasses_getInstance().ob(), serializer_14(BooleanCompanionObject_instance)), to(PrimitiveClasses_getInstance().xb(), BooleanArraySerializer()), to(getKClass(Unit), serializer_15(Unit_instance)), to(PrimitiveClasses_getInstance().nb(), NothingSerializer()), to(getKClass(Duration), serializer_16(Companion_getInstance())), to(getKClass(Uuid), serializer_17(Companion_getInstance_0()))]);
}
function get_isInterface(_this__u8e3s4) {
  if (_this__u8e3s4 === PrimitiveClasses_getInstance().nb())
    return false;
  // Inline function 'kotlin.js.asDynamic' call
  var tmp0_safe_receiver = get_js(_this__u8e3s4).$metadata$;
  return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kind) == 'interface';
}
function compiledSerializerImpl(_this__u8e3s4) {
  var tmp0_elvis_lhs = constructSerializerForGivenTypeArgs(_this__u8e3s4, []);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp_0;
    if (_this__u8e3s4 === PrimitiveClasses_getInstance().nb()) {
      tmp_0 = NothingSerializer_getInstance();
    } else {
      // Inline function 'kotlin.js.asDynamic' call
      var tmp1_safe_receiver = get_js(_this__u8e3s4).Companion;
      tmp_0 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.serializer();
    }
    var tmp_1 = tmp_0;
    tmp = (!(tmp_1 == null) ? isInterface(tmp_1, KSerializer) : false) ? tmp_1 : null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function platformSpecificSerializerNotRegistered(_this__u8e3s4) {
  throw SerializationException_init_$Create$_0(notRegisteredMessage(_this__u8e3s4) + 'To get enum serializer on Kotlin/JS, it should be annotated with @Serializable annotation.');
}
function isReferenceArray(rootClass) {
  return rootClass.equals(PrimitiveClasses_getInstance().ub());
}
function constructSerializerForGivenTypeArgs(_this__u8e3s4, args) {
  var tmp;
  try {
    // Inline function 'kotlin.reflect.findAssociatedObject' call
    var assocObject = findAssociatedObject(_this__u8e3s4, getKClass(SerializableWith));
    var tmp_0;
    if (!(assocObject == null) ? isInterface(assocObject, KSerializer) : false) {
      tmp_0 = isInterface(assocObject, KSerializer) ? assocObject : THROW_CCE();
    } else {
      if (!(assocObject == null) ? isInterface(assocObject, SerializerFactory) : false) {
        var tmp_1 = assocObject.a10(args.slice());
        tmp_0 = isInterface(tmp_1, KSerializer) ? tmp_1 : THROW_CCE();
      } else {
        tmp_0 = null;
      }
    }
    tmp = tmp_0;
  } catch ($p) {
    var tmp_2;
    var e = $p;
    tmp_2 = null;
    tmp = tmp_2;
  }
  return tmp;
}
function toNativeArrayImpl(_this__u8e3s4, eClass) {
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(_this__u8e3s4);
}
function getChecked(_this__u8e3s4, index) {
  if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
    throw IndexOutOfBoundsException_init_$Create$('Index ' + index + ' out of bounds ' + get_indices(_this__u8e3s4).toString());
  return _this__u8e3s4[index];
}
function getChecked_0(_this__u8e3s4, index) {
  if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
    throw IndexOutOfBoundsException_init_$Create$('Index ' + index + ' out of bounds ' + get_indices_0(_this__u8e3s4).toString());
  return _this__u8e3s4[index];
}
function createCache$1($factory) {
  this.j18_1 = $factory;
}
protoOf(createCache$1).ip = function (key) {
  return this.j18_1(key);
};
function createParametrizedCache$1($factory) {
  this.k18_1 = $factory;
}
protoOf(createParametrizedCache$1).jp = function (key, types) {
  // Inline function 'kotlin.runCatching' call
  var tmp;
  try {
    // Inline function 'kotlin.Companion.success' call
    var value = this.k18_1(key, types);
    tmp = _Result___init__impl__xyqfz8(value);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'kotlin.Companion.failure' call
      tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  return tmp;
};
//region block: post-declaration
protoOf(SerialDescriptorImpl).kp = get_isNullable;
protoOf(SerialDescriptorImpl).pp = get_isInline;
protoOf(AbstractDecoder).xr = decodeSerializableElement$default;
protoOf(AbstractDecoder).jr = decodeSerializableValue;
protoOf(AbstractDecoder).as = decodeSequentially;
protoOf(AbstractDecoder).cs = decodeCollectionSize;
protoOf(AbstractEncoder).ft = encodeNotNullMark;
protoOf(AbstractEncoder).gt = beginCollection;
protoOf(AbstractEncoder).ct = encodeSerializableValue;
protoOf(AbstractEncoder).et = encodeNullableSerializableValue;
protoOf(AbstractEncoder).ht = shouldEncodeElementDefault;
protoOf(ListLikeDescriptor).kp = get_isNullable;
protoOf(ListLikeDescriptor).pp = get_isInline;
protoOf(ListLikeDescriptor).rp = get_annotations;
protoOf(MapLikeDescriptor).kp = get_isNullable;
protoOf(MapLikeDescriptor).pp = get_isInline;
protoOf(MapLikeDescriptor).rp = get_annotations;
protoOf(PluginGeneratedSerialDescriptor).kp = get_isNullable;
protoOf(PluginGeneratedSerialDescriptor).pp = get_isInline;
protoOf(InlinePrimitiveDescriptor$1).qz = typeParametersSerializers;
protoOf(NothingSerialDescriptor).kp = get_isNullable;
protoOf(NothingSerialDescriptor).pp = get_isInline;
protoOf(NothingSerialDescriptor).rp = get_annotations;
protoOf(PrimitiveSerialDescriptor_0).kp = get_isNullable;
protoOf(PrimitiveSerialDescriptor_0).pp = get_isInline;
protoOf(PrimitiveSerialDescriptor_0).rp = get_annotations;
protoOf(TaggedDecoder).xr = decodeSerializableElement$default;
protoOf(TaggedDecoder).jr = decodeSerializableValue;
protoOf(TaggedDecoder).as = decodeSequentially;
protoOf(TaggedDecoder).cs = decodeCollectionSize;
//endregion
//region block: exports
export {
  MissingFieldException_init_$Create$_0 as MissingFieldException_init_$Create$drk9dj4n2hab,
  SerializationException_init_$Init$_0 as SerializationException_init_$Init$2mbwpyyvgkydo,
  SerializationException_init_$Create$_0 as SerializationException_init_$Create$1byppqmdb64jn,
  UnknownFieldException_init_$Create$ as UnknownFieldException_init_$Create$1mnsp66c6fnup,
  SEALED_getInstance as SEALED_getInstance15u0wl5f5h4qk,
  INT_getInstance as INT_getInstance3cjna3yzozsnp,
  STRING_getInstance as STRING_getInstance2gbamclnmtzqa,
  CONTEXTUAL_getInstance as CONTEXTUAL_getInstance40twmib99zqv,
  ENUM_getInstance as ENUM_getInstance3doea03ve3rgg,
  CLASS_getInstance as CLASS_getInstance1ss90e870vddp,
  LIST_getInstance as LIST_getInstance3iji3zetpdcxm,
  MAP_getInstance as MAP_getInstance2l4ulrz8ljw5i,
  OBJECT_getInstance as OBJECT_getInstancee89a3hlgr5ys,
  BooleanSerializer_getInstance as BooleanSerializer_getInstancet3wtk7fl7i4f,
  DoubleSerializer_getInstance as DoubleSerializer_getInstance2avi1jm48x8le,
  IntSerializer_getInstance as IntSerializer_getInstance9scrtcljaiv6,
  LongSerializer_getInstance as LongSerializer_getInstance3iic24guzegu7,
  StringSerializer_getInstance as StringSerializer_getInstance1k1oz5j50sfik,
  ListSerializer as ListSerializer1hxuk9dx5n9du,
  MapSerializer as MapSerializer11kmegt3g5c1g,
  SetSerializer as SetSerializert3lb0yy9iftr,
  get_nullable as get_nullable197rfua9r7fsz,
  serializer_2 as serializer1x79l67jvwntn,
  serializer_11 as serializer1q7c5q67ysppr,
  serializer_9 as serializer3ikrxnm8b29d6,
  serializer_13 as serializer36584sjyg5661,
  serializer_7 as serializer2lw83vwvpnyms,
  PolymorphicKind as PolymorphicKindla9gurooefwb,
  PrimitiveKind as PrimitiveKindndgbuh6is7ze,
  PrimitiveSerialDescriptor as PrimitiveSerialDescriptor3egfp53lutxj2,
  get_annotations as get_annotationshjxdbdcl8kmv,
  get_isInline as get_isInline5x26qrhi9qs6,
  get_isNullable as get_isNullable36pbikm8xb7bz,
  SerialDescriptor as SerialDescriptor2pelqekb5ic3a,
  ENUM as ENUMlmq49cvwy4ow,
  buildClassSerialDescriptor as buildClassSerialDescriptors2a6xdp6mrtw,
  buildSerialDescriptor as buildSerialDescriptor2873qmkp8r2ib,
  getContextualDescriptor as getContextualDescriptor2n1gf3b895yb8,
  AbstractDecoder as AbstractDecoder35guh02ubh2hm,
  AbstractEncoder as AbstractEncoder2gxtu3xmy3f8j,
  CompositeDecoder as CompositeDecoder2tzm7wpwkr0og,
  CompositeEncoder as CompositeEncoderknecpkexzn3v,
  Decoder as Decoder23nde051s631g,
  Encoder as Encoderqvmrpqtq8hnu,
  AbstractPolymorphicSerializer as AbstractPolymorphicSerializer1ccxwp48nfy58,
  ArrayListSerializer as ArrayListSerializer7k5wnrulb3y6,
  ElementMarker as ElementMarker33ojvsajwmzts,
  typeParametersSerializers as typeParametersSerializers2likxjr48tr7y,
  GeneratedSerializer as GeneratedSerializer1f7t7hssdd2ws,
  InlinePrimitiveDescriptor as InlinePrimitiveDescriptor3i6ccn1a4fw94,
  NamedValueDecoder as NamedValueDecoderzk26ztf92xbq,
  PluginGeneratedSerialDescriptor as PluginGeneratedSerialDescriptorqdzeg5asqhfg,
  SerializerFactory as SerializerFactory1qv9hivitncuv,
  createAnnotatedEnumSerializer as createAnnotatedEnumSerializer20ay4pme9p2h9,
  createSimpleEnumSerializer as createSimpleEnumSerializer2guioz11kk1m0,
  jsonCachedSerialNames as jsonCachedSerialNameslxufy2gu43jt,
  throwMissingFieldException as throwMissingFieldException2cmke0v3ynf14,
  EmptySerializersModule_0 as EmptySerializersModule991ju6pz9b79,
  contextual as contextual3hpp1gupsu4al,
  SerializersModuleCollector as SerializersModuleCollector3dddz14wd7brg,
  BinaryFormat as BinaryFormat3f3aelhmz0ro1,
  DeserializationStrategy as DeserializationStrategy1z3z5pj9f7zc8,
  KSerializer as KSerializerzf77vz1967fq,
  MissingFieldException as MissingFieldException24tqif29emcmi,
  SealedClassSerializer as SealedClassSerializeriwipiibk55zc,
  SerializationException as SerializationExceptioneqrdve3ts2n9,
  SerializationStrategy as SerializationStrategyh6ouydnm6hci,
  StringFormat as StringFormat2r2ka8mzcb3mi,
  findPolymorphicSerializer_0 as findPolymorphicSerializer1nm87hvemahcj,
  findPolymorphicSerializer as findPolymorphicSerializerk638ixyjovk5,
  serializerOrNull_0 as serializerOrNull31x2b6nu6gruj,
  serializer_0 as serializer1hwzc6m64v1op,
  serializer_1 as serializer1rka18p0rjk4x,
  serializer as serializer1i4e9ym37oxmo,
};
//endregion

